import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import './SuperMarket.css';

function Services() {
  const [categories] = useState({
    
      "Car repair and maintenance ": [

    { "name": "Engine Oil Replacement", "price": 1200 },
  { "name": "Air Filter Replacement", "price": 500 },
  { "name": "Oil Filter Replacement", "price": 450 },
  { "name": "Spark Plug Replacement", "price": 900 },
  { "name": "Battery Check & Replacement", "price": 3500 },
  { "name": "Coolant Flush", "price": 850 },
  { "name": "Transmission Fluid Change", "price": 1450 },
  { "name": "Brake Pad Replacement (Front)", "price": 2200 },
  { "name": "Brake Pad Replacement (Rear)", "price": 2100 },
  { "name": "Brake Fluid Replacement", "price": 750 },
  { "name": "AC Gas Refill", "price": 1850 },
  { "name": "AC Filter Replacement", "price": 650 },
  { "name": "Wheel Alignment", "price": 1050 },
  { "name": "Wheel Balancing", "price": 950 },
  { "name": "Tire Rotation", "price": 550 },
  { "name": "Wiper Blade Replacement", "price": 300 },
  { "name": "Windshield Washer Fluid Top-Up", "price": 250 },
  { "name": "Headlight Bulb Replacement", "price": 400 },
  { "name": "Taillight Bulb Replacement", "price": 350 },
  { "name": "Battery Terminal Cleaning", "price": 250 },
  { "name": "Alternator Replacement", "price": 5200 },
  { "name": "Starter Motor Repair", "price": 4200 },
  { "name": "Timing Belt Replacement", "price": 4600 },
  { "name": "Radiator Flush", "price": 900 },
  { "name": "Fuel Injector Cleaning", "price": 1750 },
  { "name": "Throttle Body Cleaning", "price": 1600 },
  { "name": "Clutch Plate Replacement", "price": 5800 },
  { "name": "Flywheel Resurfacing", "price": 3600 },
  { "name": "Suspension Check & Repair", "price": 3900 },
  { "name": "Shock Absorber Replacement", "price": 4700 },
  { "name": "Steering Rack Repair", "price": 4400 },
  { "name": "Power Steering Fluid Change", "price": 800 },
  { "name": "Drive Belt Replacement", "price": 1350 },
  { "name": "Exhaust System Repair", "price": 4100 },
  { "name": "Muffler Replacement", "price": 3400 },
  { "name": "Catalytic Converter Replacement", "price": 6700 },
  { "name": "O2 Sensor Replacement", "price": 1850 },
  { "name": "Engine Mount Replacement", "price": 2900 },
  { "name": "Door Lock Mechanism Repair", "price": 1350 },
  { "name": "Window Regulator Replacement", "price": 2400 },
  { "name": "Interior Cleaning", "price": 850 },
  { "name": "Exterior Polishing", "price": 1200 },
  { "name": "Underbody Coating", "price": 2500 },
  { "name": "Rustproofing Treatment", "price": 3200 },
  { "name": "Paint Touch-Up", "price": 1800 },
  { "name": "Full Body Painting", "price": 15000 },
  { "name": "Dent Repair", "price": 1100 },
  { "name": "Scratch Removal", "price": 950 },
  { "name": "Horn Replacement", "price": 700 },
  { "name": "Rear View Mirror Replacement", "price": 1150 },
  { "name": "Side Mirror Motor Repair", "price": 1300 },
  { "name": "Dashboard Electrical Diagnosis", "price": 1750 },
  { "name": "OBD Diagnostic Scan", "price": 800 },
  { "name": "Wheel Rim Repair", "price": 1200 },
  { "name": "Alloy Wheel Replacement", "price": 4200 },
  { "name": "Sunroof Repair", "price": 5600 },
  { "name": "Roof Liner Replacement", "price": 2700 },
  { "name": "Seat Upholstery Change", "price": 6500 },
  { "name": "Headrest Replacement", "price": 850 },
  { "name": "Glove Box Repair", "price": 950 },
  { "name": "Steering Wheel Cover Change", "price": 700 },
  { "name": "Handbrake Adjustment", "price": 650 },
  { "name": "Gearbox Oil Change", "price": 1550 },
  { "name": "Fuel Pump Replacement", "price": 4800 },
  { "name": "Brake Disc Skimming", "price": 1400 },
  { "name": "Engine Tuning", "price": 2300 },
  { "name": "Idle Speed Adjustment", "price": 600 },
  { "name": "Parking Sensor Installation", "price": 2800 },
  { "name": "Camera System Repair", "price": 4100 },
  { "name": "Wireless Charging Pad Install", "price": 2600 },


  { "name": "Turbocharger Replacement", "price": 9200 },
  { "name": "Cylinder Head Gasket Replacement", "price": 7800 },
  { "name": "Valve Cover Gasket Replacement", "price": 3400 },
  { "name": "Crankshaft Position Sensor Replacement", "price": 1900 },
  { "name": "Camshaft Sensor Repair", "price": 1650 },
  { "name": "ABS Sensor Replacement", "price": 1750 },
  { "name": "Electronic Control Unit (ECU) Repair", "price": 8500 },
  { "name": "Tailgate Lift Support Replacement", "price": 1300 },
  { "name": "Fuel Tank Cleaning", "price": 1500 },
  { "name": "PCV Valve Replacement", "price": 700 },
  { "name": "Idle Air Control Valve Replacement", "price": 1450 },
  { "name": "Ignition Coil Replacement", "price": 2100 },
  { "name": "Distributor Cap Replacement", "price": 1200 },
  { "name": "Timing Chain Inspection", "price": 850 },
  { "name": "Heater Core Flush", "price": 1450 },
  { "name": "Blower Motor Repair", "price": 2500 },
  { "name": "Cabin Noise Dampening", "price": 3000 },
  { "name": "Headlamp Adjustment", "price": 650 },
  { "name": "Fog Light Installation", "price": 2200 },
  { "name": "Tailgate Sensor Calibration", "price": 900 },
  { "name": "Ambient Light System Install", "price": 3800 },
  { "name": "Dashcam Wiring & Setup", "price": 1500 },
  { "name": "Infotainment System Update", "price": 1900 },
  { "name": "GPS Module Repair", "price": 2400 },
  { "name": "Roof Rack Installation", "price": 3200 },
  { "name": "Tow Hitch Fitting", "price": 3300 },
  { "name": "Body Panel Replacement (Single)", "price": 4700 },
  { "name": "Electronic Window Tinting", "price": 2100 },
  { "name": "Rear Defogger Repair", "price": 1100 },
  { "name": "Interior Ambient Sensor Replacement", "price": 1450 },
  { "name": "Child Lock Repair", "price": 750 },
  { "name": "Keyless Entry System Repair", "price": 3600 },
  { "name": "Remote Key Programming", "price": 1750 },
  { "name": "Rear Spoiler Fitting", "price": 2900 },
  { "name": "Door Seal Replacement", "price": 950 },
  { "name": "Gear Shifter Boot Replacement", "price": 800 },
  { "name": "Dashboard Trims Replacement", "price": 1600 },
  { "name": "Instrument Cluster Diagnosis", "price": 1950 },
  { "name": "Speedometer Calibration", "price": 1450 },
  { "name": "Fuel Economy Test & Report", "price": 900 },
  { "name": "Cruise Control System Repair", "price": 5200 },
  { "name": "Rear Seat Folding Mechanism Repair", "price": 2400 },
  { "name": "Engine Block Cleaning", "price": 1600 },
  { "name": "Intake Manifold Repair", "price": 4500 },
  { "name": "EGR Valve Cleaning", "price": 1300 },
  { "name": "EVAP System Check", "price": 1100 },
  { "name": "Differential Oil Change", "price": 950 },
  { "name": "Axle Seal Replacement", "price": 2800 },
  { "name": "CV Joint Boot Repair", "price": 1850 },
  { "name": "Drive Shaft Balancing", "price": 3400 },
  { "name": "Propeller Shaft Replacement", "price": 4900 },
  { "name": "Hydraulic Mount Replacement", "price": 2100 },
  { "name": "Wheel Hub Assembly Repair", "price": 2600 },
  { "name": "Tire Pressure Sensor Replacement", "price": 1600 },
  { "name": "Wheel Bearing Replacement", "price": 4200 },
  { "name": "Axle Replacement (Front)", "price": 4800 },
  { "name": "Axle Replacement (Rear)", "price": 4700 },
  { "name": "Brake Caliper Painting", "price": 1900 },
  { "name": "Handbrake Cable Replacement", "price": 1150 },
  { "name": "Parking Brake Sensor Adjustment", "price": 950 },
  { "name": "Clutch Slave Cylinder Repair", "price": 2450 },
  { "name": "Hydraulic Clutch Bleeding", "price": 950 },
  { "name": "Gear Synchronizer Repair", "price": 3800 },
  { "name": "Headlight Washer Jet Cleaning", "price": 650 },
  { "name": "Sun Visor Replacement", "price": 800 },
  { "name": "Parcel Tray Installation", "price": 1200 },
  { "name": "Armrest Installation", "price": 1350 },
  { "name": "Rear Vent Cleaning", "price": 750 },
  { "name": "Climate Control Calibration", "price": 2150 },
  { "name": "Air Suspension Adjustment", "price": 6900 },


  { "name": "Engine Compression Test", "price": 950 },
  { "name": "Cylinder Leak Down Test", "price": 1150 },
  { "name": "Throttle Position Sensor Calibration", "price": 1250 },
  { "name": "Mass Air Flow Sensor Cleaning", "price": 950 },
  { "name": "Exhaust Manifold Replacement", "price": 5200 },
  { "name": "Intake Valve Cleaning", "price": 1700 },
  { "name": "Camshaft Replacement", "price": 7800 },
  { "name": "Serpentine Belt Tensioner Replacement", "price": 1350 },
  { "name": "Idle Control Motor Replacement", "price": 1450 },
  { "name": "Thermostat Replacement", "price": 1600 },
  { "name": "Radiator Cap Replacement", "price": 450 },
  { "name": "Transmission Mount Replacement", "price": 2750 },
  { "name": "Differential Inspection", "price": 1250 },
  { "name": "Manual Transmission Fluid Flush", "price": 1450 },
  { "name": "Automatic Transmission Diagnosis", "price": 1750 },
  { "name": "Shifter Linkage Repair", "price": 1400 },
  { "name": "Torque Converter Replacement", "price": 6200 },
  { "name": "Brake Pedal Sensor Adjustment", "price": 950 },
  { "name": "Brake Drum Replacement", "price": 3200 },
  { "name": "Rear Brake Shoes Replacement", "price": 2900 },
  { "name": "ABS Module Repair", "price": 6100 },
  { "name": "Brake Booster Replacement", "price": 3500 },
  { "name": "Brake Line Flush", "price": 1250 },
  { "name": "Front Suspension Arm Replacement", "price": 4200 },
  { "name": "Ball Joint Replacement", "price": 2800 },
  { "name": "Strut Assembly Replacement", "price": 5000 },
  { "name": "Tie Rod End Replacement", "price": 1950 },
  { "name": "Sway Bar Link Replacement", "price": 1600 },
  { "name": "Control Arm Bushing Replacement", "price": 2100 },
  { "name": "Electric Steering Motor Calibration", "price": 2400 },
  { "name": "Power Steering Hose Replacement", "price": 1800 },
  { "name": "Steering Column Adjustment", "price": 1350 },
  { "name": "Upper Ball Joint Greasing", "price": 650 },
  { "name": "Wheel Stud Replacement", "price": 850 },
  { "name": "Tire Valve Stem Replacement", "price": 400 },
  { "name": "Underbody Inspection", "price": 950 },
  { "name": "Rust Removal & Primer Application", "price": 3100 },
  { "name": "Fender Replacement", "price": 4800 },
  { "name": "Tailgate Alignment", "price": 1700 },
  { "name": "Bonnet Lock Repair", "price": 950 },
  { "name": "Windshield Seal Replacement", "price": 1750 },
  { "name": "Rear Windshield Heating Grid Repair", "price": 1450 },
  { "name": "Roof Dent Repair", "price": 2100 },
  { "name": "Door Hinge Lubrication", "price": 650 },
  { "name": "Window Tint Legal Compliance Check", "price": 700 },
  { "name": "Chrome Detailing", "price": 2200 },
  { "name": "Headlight Lens Polishing", "price": 950 },
  { "name": "Interior Trim Fixing", "price": 1350 },
  { "name": "Seatbelt Mechanism Check", "price": 800 },
  { "name": "Pedal Rubber Replacement", "price": 300 },
  { "name": "Footwell Light Installation", "price": 1650 },
  { "name": "Interior LED Strip Fitting", "price": 1250 },
  { "name": "Door Speaker Replacement", "price": 1800 },
  { "name": "Amplifier Mounting & Wiring", "price": 2600 },
  { "name": "Subwoofer Enclosure Installation", "price": 3100 },
  { "name": "Antenna Mast Replacement", "price": 800 },
  { "name": "Power Window Relay Repair", "price": 1400 },
  { "name": "Climate Control Sensor Replacement", "price": 1850 },
  { "name": "Rearview Camera Adjustment", "price": 950 },
  { "name": "Wireless Connectivity Check", "price": 900 },
  { "name": "Dashboard Display Backlight Repair", "price": 1650 },
  { "name": "Electronic Mirror Fold Mechanism Repair", "price": 1450 },
  { "name": "Door Courtesy Light Installation", "price": 1250 },
  { "name": "Emergency Brake Light Setup", "price": 950 },
  { "name": "Coolant Reservoir Replacement", "price": 1500 },
  { "name": "Glove Box Latch Replacement", "price": 650 },
  { "name": "Trunk Light Fixing", "price": 750 },
  { "name": "Power Outlet Installation", "price": 1100 },
  { "name": "Airbag System Diagnosis", "price": 2150 },
  { "name": "Seat Height Motor Repair", "price": 1550 },
  { "name": "Steering Wheel Vibration Diagnosis", "price": 950 },


  { "name": "Engine Timing Recalibration", "price": 1600 },
  { "name": "Turbo Wastegate Adjustment", "price": 1350 },
  { "name": "VVT Solenoid Replacement", "price": 1850 },
  { "name": "Engine Valve Lash Adjustment", "price": 1950 },
  { "name": "Timing Chain Tensioner Replacement", "price": 2350 },
  { "name": "Oil Pressure Sensor Replacement", "price": 850 },
  { "name": "Crankcase Ventilation Inspection", "price": 750 },
  { "name": "Fuel Pressure Regulator Replacement", "price": 1750 },
  { "name": "Throttle Cable Lubrication", "price": 400 },
  { "name": "Intake Resonator Box Replacement", "price": 1200 },
  { "name": "Turbo Intercooler Flush", "price": 1400 },
  { "name": "Engine Breather Hose Replacement", "price": 950 },
  { "name": "EGR Cooler Cleaning", "price": 1550 },
  { "name": "Throttle Actuator Repair", "price": 1850 },
  { "name": "Oil Cooler Line Replacement", "price": 1250 },
  { "name": "Fuel Filter Housing Replacement", "price": 1600 },
  { "name": "Heater Hose Assembly Replacement", "price": 1300 },
  { "name": "AC Condenser Coil Flush", "price": 1100 },
  { "name": "Air Conditioning Compressor Clutch Repair", "price": 2150 },
  { "name": "Radiator Fan Motor Replacement", "price": 1750 },
  { "name": "Water Pump Pulley Replacement", "price": 1550 },
  { "name": "Timing Cover Seal Replacement", "price": 1250 },
  { "name": "Transmission Shift Solenoid Cleaning", "price": 1450 },
  { "name": "Valve Body Reprogramming", "price": 2950 },
  { "name": "Flywheel Housing Inspection", "price": 950 },
  { "name": "Gear Selector Cable Replacement", "price": 1350 },
  { "name": "Rear Differential Mount Repair", "price": 1850 },
  { "name": "Clutch Fork Lubrication", "price": 650 },
  { "name": "Drive Plate Resurfacing", "price": 2150 },
  { "name": "Brake Sensor Wiring Check", "price": 700 },
  { "name": "Drum Brake Adjustment", "price": 1350 },
  { "name": "Brake Hardware Kit Installation", "price": 1450 },
  { "name": "Front Brake Disc Replacement", "price": 3400 },
  { "name": "Rear Brake Disc Replacement", "price": 3300 },
  { "name": "Brake Master Cylinder Bleeding", "price": 950 },
  { "name": "Emergency Brake Cable Greasing", "price": 500 },
  { "name": "Torsion Bar Adjustment", "price": 1450 },
  { "name": "Subframe Bushing Replacement", "price": 2750 },
  { "name": "Wheel Knuckle Cleaning", "price": 850 },
  { "name": "Suspension Lift Kit Install", "price": 5800 },
  { "name": "Rear Coil Spring Replacement", "price": 2100 },
  { "name": "Front Coil Spring Replacement", "price": 2200 },
  { "name": "Upper Control Arm Repair", "price": 2400 },
  { "name": "Chassis Crack Welding", "price": 4600 },
  { "name": "Shock Mount Repair", "price": 1900 },
  { "name": "Body Seam Seal Replacement", "price": 950 },
  { "name": "Quarter Panel Realignment", "price": 2800 },
  { "name": "Interior Fabric Refitting", "price": 2650 },
  { "name": "Rearview Mirror Auto-Dim Calibration", "price": 1200 },
  { "name": "Steering Tilt Adjustment", "price": 1050 },
  { "name": "Sunroof Seal Greasing", "price": 650 },
  { "name": "Tailgate Wiring Harness Repair", "price": 1950 },
  { "name": "Interior Door Handle Replacement", "price": 850 },
  { "name": "Cigarette Lighter Socket Repair", "price": 700 },
  { "name": "Rear Door Lock Actuator Replacement", "price": 1450 },
  { "name": "Ignition Barrel Lubrication", "price": 600 },
  { "name": "Smart Key Sensor Calibration", "price": 1750 },
  { "name": "Windshield Wiper Motor Check", "price": 1100 },
  { "name": "License Plate Light Installation", "price": 450 },
  { "name": "AC Temperature Blend Door Adjustment", "price": 950 },
  { "name": "Headrest Audio Wiring Repair", "price": 1600 },
  { "name": "Interior Switch Panel Replacement", "price": 1350 },
  { "name": "Rear Seat Armrest Fix", "price": 950 },
  { "name": "Door Trim Fastener Replacement", "price": 700 },
  { "name": "Floor Mat Anchor Installation", "price": 400 },
  { "name": "Interior Roof Clip Replacement", "price": 600 },
  { "name": "USB Charging Port Wiring", "price": 1150 },
  { "name": "Windshield Defogger Vent Cleaning", "price": 850 },
  { "name": "Garage Mode Control System Repair", "price": 1850 },


                  ],
          "Bike servicing": [

      { "name": "Engine Oil Change", "price": 350 },
  { "name": "Air Filter Cleaning", "price": 150 },
  { "name": "Spark Plug Replacement", "price": 250 },
  { "name": "Brake Pad Replacement (Front)", "price": 500 },
  { "name": "Brake Pad Replacement (Rear)", "price": 450 },
  { "name": "Chain Lubrication", "price": 200 },
  { "name": "Battery Check", "price": 100 },
  { "name": "Clutch Adjustment", "price": 300 },
  { "name": "Headlight Bulb Replacement", "price": 200 },
  { "name": "Tail Light Bulb Replacement", "price": 150 },
  { "name": "Horn Replacement", "price": 250 },
  { "name": "Engine Tune-Up", "price": 700 },
  { "name": "Wheel Alignment", "price": 400 },
  { "name": "Tyre Air Pressure Check", "price": 100 },
  { "name": "Tyre Replacement (Front)", "price": 1800 },
  { "name": "Tyre Replacement (Rear)", "price": 2000 },
  { "name": "Wheel Balancing", "price": 300 },
  { "name": "Brake Fluid Top-Up", "price": 200 },
  { "name": "Coolant Check & Top-Up", "price": 250 },
  { "name": "Clutch Cable Replacement", "price": 350 },
  { "name": "Throttle Cable Adjustment", "price": 150 },
  { "name": "Throttle Cable Replacement", "price": 300 },
  { "name": "Speedometer Cable Replacement", "price": 350 },
  { "name": "Battery Replacement", "price": 1800 },
  { "name": "Indicator Bulb Replacement", "price": 150 },
  { "name": "Rear View Mirror Replacement", "price": 400 },
  { "name": "Handlebar Grip Replacement", "price": 250 },
  { "name": "Brake Lever Replacement", "price": 300 },
  { "name": "Clutch Lever Replacement", "price": 300 },
  { "name": "Kick Starter Rubber Replacement", "price": 150 },
  { "name": "Footrest Rubber Change", "price": 200 },
  { "name": "Seat Cover Replacement", "price": 850 },
  { "name": "Fuel Pipe Replacement", "price": 300 },
  { "name": "Fuel Tank Cleaning", "price": 500 },
  { "name": "Silencer Cleaning", "price": 400 },
  { "name": "Exhaust System Check", "price": 650 },
  { "name": "Muffler Replacement", "price": 1600 },
  { "name": "Engine Decarbonizing", "price": 1200 },
  { "name": "Gear Oil Change", "price": 400 },
  { "name": "Chain Replacement", "price": 950 },
  { "name": "Sprocket Replacement (Front)", "price": 750 },
  { "name": "Sprocket Replacement (Rear)", "price": 850 },
  { "name": "Side Stand Replacement", "price": 300 },
  { "name": "Main Stand Lubrication", "price": 250 },
  { "name": "Suspension Check", "price": 350 },
  { "name": "Fork Oil Change", "price": 500 },
  { "name": "Shock Absorber Replacement", "price": 1200 },
  { "name": "Handlebar Alignment", "price": 300 },
  { "name": "Control Wiring Check", "price": 250 },
  { "name": "Electric Circuit Diagnosis", "price": 600 },
  { "name": "Starter Motor Repair", "price": 950 },
  { "name": "Alternator Repair", "price": 1150 },
  { "name": "Fuel Gauge Repair", "price": 400 },
  { "name": "Kick Starter Assembly Replacement", "price": 950 },
  { "name": "Handlebar Mount Replacement", "price": 650 },
  { "name": "Headlight Assembly Replacement", "price": 950 },
  { "name": "Indicator Assembly Installation", "price": 750 },
  { "name": "Side Panel Painting", "price": 1300 },
  { "name": "Seat Lock Adjustment", "price": 250 },
  { "name": "License Plate Light Check", "price": 150 },
  { "name": "Frame Inspection", "price": 850 },
  { "name": "Carburetor Cleaning", "price": 650 },
  { "name": "Air Intake Manifold Check", "price": 550 },
  { "name": "Electrical Fuse Box Repair", "price": 350 },
  { "name": "Clutch Plate Replacement", "price": 1800 },
  { "name": "Oil Seal Replacement", "price": 850 },
  { "name": "Chain Tension Check", "price": 200 },
  { "name": "Battery Terminal Cleaning", "price": 150 },
  { "name": "Oil Filter Replacement", "price": 400 },
  { "name": "Engine Mount Check", "price": 500 },
  { "name": "RPM Sensor Calibration", "price": 450 },
  { "name": "Side Stand Sensor Repair", "price": 350 },
  { "name": "Self Start Button Replacement", "price": 400 },


  { "name": "Digital Speedometer Calibration", "price": 400 },
  { "name": "Oil Seal Inspection", "price": 250 },
  { "name": "Headlight Bracket Replacement", "price": 300 },
  { "name": "Clutch Bell Housing Repair", "price": 850 },
  { "name": "Footrest Welding", "price": 550 },
  { "name": "Chain Sprocket Alignment", "price": 250 },
  { "name": "Shock Bush Replacement", "price": 500 },
  { "name": "Carburetor Jet Adjustment", "price": 450 },
  { "name": "Electronic Ignition Check", "price": 600 },
  { "name": "Starter Relay Replacement", "price": 400 },
  { "name": "Regulator Rectifier Check", "price": 350 },
  { "name": "Front Fork Seal Replacement", "price": 950 },
  { "name": "Ignition Switch Repair", "price": 650 },
  { "name": "Fuel Cap Seal Change", "price": 150 },
  { "name": "Disc Brake Caliper Check", "price": 700 },
  { "name": "Rear Shock Absorber Oil Change", "price": 800 },
  { "name": "Digital Console Backlight Replacement", "price": 550 },
  { "name": "Kick Lever Alignment", "price": 250 },
  { "name": "Rear Mudguard Replacement", "price": 650 },
  { "name": "Seat Base Frame Repair", "price": 1200 },
  { "name": "Battery Box Welding", "price": 750 },
  { "name": "Handlebar Clamp Adjustment", "price": 300 },
  { "name": "Throttle Housing Replacement", "price": 350 },
  { "name": "Tail Lamp Assembly Wiring", "price": 500 },
  { "name": "Silencer Bracket Fabrication", "price": 600 },
  { "name": "Fuel Tap Replacement", "price": 450 },
  { "name": "Radiator Guard Installation", "price": 950 },
  { "name": "Digital Fuel Meter Check", "price": 400 },
  { "name": "Exhaust Gasket Replacement", "price": 350 },
  { "name": "Engine Guard Fitting", "price": 800 },
  { "name": "Cylinder Head Cleaning", "price": 950 },
  { "name": "Gear Shift Pedal Replacement", "price": 350 },
  { "name": "Kick Shaft Seal Replacement", "price": 450 },
  { "name": "Fuel Injector Cleaning", "price": 850 },
  { "name": "Throttle Sensor Calibration", "price": 700 },
  { "name": "Electronic Control Unit (ECU) Update", "price": 1200 },
  { "name": "Trip Meter Cable Replacement", "price": 400 },
  { "name": "Handlebar End Weight Fitting", "price": 250 },
  { "name": "Front Fender Painting", "price": 1100 },
  { "name": "Brake Master Cylinder Repair", "price": 950 },
  { "name": "Coolant Reservoir Flush", "price": 600 },
  { "name": "Engine Mount Bolt Tightening", "price": 250 },
  { "name": "Self-Starter Gear Check", "price": 750 },
  { "name": "Clutch Plate Greasing", "price": 500 },
  { "name": "Underbody Rust Coating", "price": 1200 },
  { "name": "Rear View Mirror Angle Adjustment", "price": 150 },
  { "name": "Headlight Beam Alignment", "price": 250 },
  { "name": "LED Indicator Conversion", "price": 800 },
  { "name": "Frame Crack Welding", "price": 1350 },
  { "name": "Side Panel Clip Replacement", "price": 300 },
  { "name": "Ignition Coil Wiring", "price": 650 },
  { "name": "Clutch Spring Replacement", "price": 400 },
  { "name": "Gear Lever Rubber Installation", "price": 150 },
  { "name": "Engine Cooling Fan Repair", "price": 1150 },
  { "name": "Chain Guard Replacement", "price": 450 },
  { "name": "Horn Wiring Harness Installation", "price": 550 },
  { "name": "Front Suspension Damping Check", "price": 700 },
  { "name": "Side Stand Spring Replacement", "price": 300 },
  { "name": "Handlebar Vibration Check", "price": 350 },
  { "name": "Wiring Circuit Overhaul", "price": 1450 },
  { "name": "Tail Lamp Bulb Upgrade", "price": 250 },
  { "name": "Control Switch Panel Replacement", "price": 800 },
  { "name": "Exhaust Silencer Packing Change", "price": 350 },
  { "name": "Fuel Pipe Clamp Replacement", "price": 150 },
  { "name": "Cylinder Bore Polish", "price": 1000 },
  { "name": "Rear Brake Drum Cleaning", "price": 650 },
  { "name": "Kick Starter Return Spring Replacement", "price": 300 },
  { "name": "Windshield Mount Bracket Fitment", "price": 700 },
  { "name": "Fuel Level Sensor Replacement", "price": 950 },
  { "name": "Tank Pad Installation", "price": 400 },
  { "name": "Tappet Noise Diagnosis", "price": 550 },


  { "name": "Rear Disc Rotor Replacement", "price": 950 },
  { "name": "Engine Oil Filter Mesh Cleaning", "price": 400 },
  { "name": "Digital Clock Battery Replacement", "price": 150 },
  { "name": "Instrument Cluster Glass Polishing", "price": 300 },
  { "name": "Chain Roller Lubrication", "price": 200 },
  { "name": "Centre Stand Pin Tightening", "price": 250 },
  { "name": "Fork Clamp Adjustment", "price": 350 },
  { "name": "Starter Button Rewiring", "price": 450 },
  { "name": "Tank Rubber Pad Replacement", "price": 300 },
  { "name": "Fuel Overflow Pipe Clearing", "price": 250 },
  { "name": "Clutch Basket Cleaning", "price": 600 },
  { "name": "Magnet Coil Testing", "price": 500 },
  { "name": "Tail Lamp Holder Repair", "price": 350 },
  { "name": "Front Indicator Glass Replacement", "price": 200 },
  { "name": "Underseat Wiring Harness Refit", "price": 750 },
  { "name": "Alloy Wheel Painting", "price": 1400 },
  { "name": "Oil Filter Cap Gasket Change", "price": 250 },
  { "name": "Speed Sensor Cleaning", "price": 300 },
  { "name": "Fork Dust Seal Replacement", "price": 550 },
  { "name": "Battery Acid Level Check", "price": 200 },
  { "name": "Brake Pedal Height Adjustment", "price": 150 },
  { "name": "Rear Axle Bolt Torque Check", "price": 200 },
  { "name": "Fuel Line Insulation Wrap", "price": 450 },
  { "name": "LED Headlight Upgrade", "price": 950 },
  { "name": "Exhaust Heat Shield Fitting", "price": 650 },
  { "name": "Side Panel Latch Replacement", "price": 250 },
  { "name": "Chain Guard Bracket Welding", "price": 500 },
  { "name": "Ignition Key Barrel Replacement", "price": 800 },
  { "name": "Front Number Plate Mounting", "price": 300 },
  { "name": "Radiator Hose Check", "price": 350 },
  { "name": "LED DRL Installation", "price": 850 },
  { "name": "Engine Noise Diagnosis", "price": 700 },
  { "name": "Disc Pad Grooving", "price": 950 },
  { "name": "Kick Starter Bush Change", "price": 250 },
  { "name": "Swing Arm Bush Lubrication", "price": 300 },
  { "name": "Tank Cap Lock Repair", "price": 400 },
  { "name": "Horn Mount Tightening", "price": 200 },
  { "name": "Oil Level Sensor Replacement", "price": 600 },
  { "name": "Grip End Weight Realignment", "price": 250 },
  { "name": "Rear Indicator Wiring Fix", "price": 350 },
  { "name": "Throttle Grip Change", "price": 400 },
  { "name": "Tail Light Bezel Polish", "price": 300 },
  { "name": "Control Cable Routing Check", "price": 250 },
  { "name": "Trip Reset Button Repair", "price": 450 },
  { "name": "Steering Stem Nut Tightening", "price": 200 },
  { "name": "Seat Foam Padding Repair", "price": 850 },
  { "name": "Handlebar Riser Adjustment", "price": 300 },
  { "name": "Silencer Cap Refit", "price": 400 },
  { "name": "Rear Brake Rod Greasing", "price": 250 },
  { "name": "Exhaust Packing Replacement", "price": 350 },
  { "name": "Engine Kill Switch Check", "price": 300 },
  { "name": "Oil Drain Bolt Washer Change", "price": 150 },
  { "name": "License Plate Frame Fitting", "price": 450 },
  { "name": "Front Axle Cone Adjustment", "price": 500 },
  { "name": "Clutch Cable Free Play Check", "price": 200 },
  { "name": "Fuel Tank Rubber Mount Replacement", "price": 250 },
  { "name": "Swing Arm Axle Bolt Replacement", "price": 600 },
  { "name": "Footrest Bracket Adjustment", "price": 350 },
  { "name": "Console Housing Screws Check", "price": 200 },
  { "name": "Gear Indicator LED Replacement", "price": 300 },
  { "name": "Starter Motor Ground Wire Repair", "price": 400 },
  { "name": "Horn Fuse Check", "price": 150 },
  { "name": "Front Axle Spacer Realignment", "price": 250 },
  { "name": "Tank Breather Hose Clearing", "price": 350 },
  { "name": "Front Fork Preload Setting", "price": 550 },
  { "name": "Control Cables Lubrication", "price": 300 },
  { "name": "Handlebar Center Marking", "price": 200 },
  { "name": "Engine Head Bolt Torque Check", "price": 300 },
  { "name": "Engine Bay Dust Cleaning", "price": 500 },
  { "name": "Key Battery Replacement (Smart Key)", "price": 400 },
  { "name": "Rear Brake Shoe Refacing", "price": 600 },


  { "name": "Gear Shifter Link Inspection", "price": 450 },
  { "name": "Radiator Fan Mount Repair", "price": 850 },
  { "name": "Chain Slack Adjustment", "price": 250 },
  { "name": "Fuel Tank Lid Gasket Replacement", "price": 300 },
  { "name": "Digital Console Button Repair", "price": 600 },
  { "name": "Trip Meter Display Check", "price": 350 },
  { "name": "Handlebar Switch Assembly Replacement", "price": 950 },
  { "name": "Frame Paint Touch-Up", "price": 1150 },
  { "name": "Rear Suspension Linkage Greasing", "price": 400 },
  { "name": "Oil Pump Inspection", "price": 900 },
  { "name": "Throttle Cam Replacement", "price": 350 },
  { "name": "Speed Limiter Setting Check", "price": 450 },
  { "name": "Starter Clutch Assembly Repair", "price": 1100 },
  { "name": "Rear Shock Mounting Bolt Tightening", "price": 300 },
  { "name": "Engine Ground Cable Installation", "price": 500 },
  { "name": "Front Brake Hose Replacement", "price": 650 },
  { "name": "Front Axle Nut Replacement", "price": 250 },
  { "name": "Tank Side Pad Fixing", "price": 350 },
  { "name": "Side Stand Switch Diagnosis", "price": 550 },
  { "name": "Rear Brake Pedal Rod Replacement", "price": 400 },
  { "name": "Starter Motor Pinion Gear Cleaning", "price": 650 },
  { "name": "Wiring Connector Waterproofing", "price": 300 },
  { "name": "Headlamp Reflector Cleaning", "price": 250 },
  { "name": "Kick Starter Shaft Alignment", "price": 450 },
  { "name": "Instrument Cluster Calibration", "price": 950 },
  { "name": "Fuel Tank Exterior Polish", "price": 550 },
  { "name": "Grip Rubber Refit", "price": 200 },
  { "name": "Brake Fluid Reservoir Cap Replacement", "price": 150 },
  { "name": "Clutch Hub Re-Alignment", "price": 750 },
  { "name": "Brake Caliper Bolt Check", "price": 350 },
  { "name": "Cam Chain Tensioner Adjustment", "price": 950 },
  { "name": "Throttle Response Fine-Tuning", "price": 600 },
  { "name": "Rear Suspension Rebound Setting", "price": 700 },
  { "name": "Battery Terminal Bolt Change", "price": 150 },
  { "name": "Fuel Pipe Routing Check", "price": 350 },
  { "name": "Brake Lever Reach Adjustment", "price": 250 },
  { "name": "Gear Sensor Realignment", "price": 500 },
  { "name": "Front Caliper Piston Lubrication", "price": 400 },
  { "name": "Engine Mount Rubber Replacement", "price": 800 },
  { "name": "Rear Mudguard Screw Tightening", "price": 200 },
  { "name": "Coolant Pipe Clamp Replacement", "price": 250 },
  { "name": "Seat Hinge Greasing", "price": 300 },
  { "name": "Silencer Paint Touch-Up", "price": 700 },
  { "name": "Dashboard Indicator Light Check", "price": 450 },
  { "name": "Rear Swing Arm Angle Inspection", "price": 350 },
  { "name": "Oil Sump Bolt Replacement", "price": 250 },
  { "name": "Tank Cover Screw Realignment", "price": 300 },
  { "name": "Handlebar Wire Routing", "price": 250 },
  { "name": "Rear Fender Bolt Replacement", "price": 200 },
  { "name": "Ignition Lock Plate Adjustment", "price": 600 },
  { "name": "Side Panel Decal Refit", "price": 450 },
  { "name": "Chain Guard Nut Tightening", "price": 300 },
  { "name": "Speedometer Gear Oil Seal Change", "price": 350 },
  { "name": "Brake Switch Sensor Installation", "price": 500 },
  { "name": "Silencer End Cone Polishing", "price": 400 },
  { "name": "Front Axle Thread Inspection", "price": 250 },
  { "name": "Headlight Wiring Connector Replacement", "price": 600 },
  { "name": "Front Number Plate Screw Adjustment", "price": 150 },
  { "name": "Underseat Tray Cleaning", "price": 400 },
  { "name": "Kick Lever Washer Replacement", "price": 150 },
  { "name": "Radiator Cover Fixing", "price": 550 },
  { "name": "Gear Pedal Bush Change", "price": 250 },
  { "name": "Engine Compression Valve Check", "price": 900 },
  { "name": "Brake Pad Anti-Rattle Clip Install", "price": 300 },
  { "name": "Coolant Overflow Hose Replacement", "price": 350 },
  { "name": "Front Fork Reflector Fitment", "price": 250 },
  { "name": "Digital Console Protective Film Install", "price": 200 },
  { "name": "Rear View Mirror Thread Cleaning", "price": 200 },
  { "name": "Wiring Bundle Tie Replacement", "price": 250 },
  { "name": "Underbody Bolt Corrosion Check", "price": 300 },
  { "name": "Tail Lamp Lens Tightening", "price": 200 },


                  ],
          "Taxi and ride-hailing services ": [

      { "name": "Base Fare – Economy Ride", "price": 75 },
  { "name": "Base Fare – Premium Ride", "price": 125 },
  { "name": "Distance Charge – Per Kilometer", "price": 12 },
  { "name": "Time-Based Fare – Per Minute", "price": 2 },
  { "name": "Ride Booking Fee", "price": 25 },
  { "name": "Surge Pricing Adjustment", "price": 80 },
  { "name": "GST on Ride Fare", "price": 18 },
  { "name": "Night Time Surcharge", "price": 50 },
  { "name": "Airport Pickup Fee", "price": 65 },
  { "name": "Toll Charges", "price": 85 },
  { "name": "State Entry Tax", "price": 100 },
  { "name": "Ride Cancellation Fee", "price": 50 },
  { "name": "Driver Waiting Charge – Per 5 Min", "price": 20 },
  { "name": "Outstation Fare – Per Kilometer", "price": 14 },
  { "name": "Extra Luggage Handling Fee", "price": 40 },
  { "name": "Return Trip Charge", "price": 60 },
  { "name": "Convenience Fee", "price": 20 },
  { "name": "Cash Collection Fee", "price": 30 },
  { "name": "Peak Hour Charge", "price": 55 },
  { "name": "Ride Insurance Fee", "price": 15 },
  { "name": "Preferred Driver Selection Charge", "price": 25 },
  { "name": "Booking Modification Fee", "price": 20 },
  { "name": "Doorstep Pickup Premium", "price": 35 },
  { "name": "Priority Ride Charge", "price": 45 },
  { "name": "Driver Bonus Top-Up", "price": 100 },
  { "name": "Route Optimization Add-On", "price": 20 },
  { "name": "Ride Feedback Discount", "price": -10 },
  { "name": "Promo Code Discount", "price": -50 },
  { "name": "Wallet Cashback Applied", "price": -75 },
  { "name": "Subscription Plan Ride Benefit", "price": -100 },
  { "name": "Fuel Surcharge", "price": 25 },
  { "name": "Ride Pause Fee", "price": 30 },
  { "name": "Extra Stop Fee", "price": 40 },
  { "name": "FastTrack Booking Service", "price": 35 },
  { "name": "Driver Ratings Incentive", "price": 15 },
  { "name": "Emergency Stop Fine", "price": 100 },
  { "name": "Rescheduled Ride Fee", "price": 25 },
  { "name": "Smoking Violation Penalty", "price": 200 },
  { "name": "Pet-Friendly Ride Premium", "price": 60 },
  { "name": "Lost Item Recovery Fee", "price": 150 },
  { "name": "Special Festival Surcharge", "price": 80 },
  { "name": "Complimentary Water Bottle", "price": 0 },
  { "name": "Entertainment Onboard Fee", "price": 40 },
  { "name": "Ride Share Discount", "price": -25 },
  { "name": "Shared Ride Fare Split Adjustment", "price": 10 },
  { "name": "Vehicle Type Upgrade Charge", "price": 85 },
  { "name": "Driver Mask Compliance Bonus", "price": -10 },
  { "name": "Sanitization Charge", "price": 20 },
  { "name": "Long Wait Penalty", "price": 45 },
  { "name": "Ride Invoicing Service Fee", "price": 10 },
  { "name": "Voice Support Assistance Fee", "price": 30 },
  { "name": "Chat Support Fee", "price": 15 },
  { "name": "Cross-City Travel Charge", "price": 125 },
  { "name": "Ride Rescheduling Window Charge", "price": 40 },
  { "name": "Alternate Vehicle Dispatch Charge", "price": 70 },
  { "name": "Fast Lane Toll Pass Premium", "price": 55 },
  { "name": "Ride Tracking Feature Access", "price": 10 },
  { "name": "Trip Summary Digital Access Fee", "price": 5 },
  { "name": "E-Invoice Convenience Fee", "price": 10 },
  { "name": "Late Night Driver Gratitude Bonus", "price": 100 },
  { "name": "App Usage Infrastructure Fee", "price": 15 },
  { "name": "Peak Fuel Adjustment", "price": 45 },
  { "name": "Eco-Friendly Vehicle Incentive", "price": -20 },
  { "name": "Subscription Ride Credit Applied", "price": -90 },
  { "name": "Holiday Ride Redemption", "price": -60 },
  { "name": "Minimum Fare Guarantee Balance", "price": 0 },
  { "name": "Refund Process Handling Fee", "price": 20 },
  { "name": "Real-Time ETA Premium Service", "price": 25 },
  { "name": "Trip Review Credit", "price": -15 },
  { "name": "Ride Delay Compensation", "price": -25 },
  { "name": "Driver Courtesy Gift Applied", "price": -50 },
  { "name": "Rider Loyalty Reward", "price": -75 },

  { "name": "Multi-Stop Journey Fee", "price": 45 },
  { "name": "Intercity Ride Base Fare", "price": 150 },
  { "name": "Premium Vehicle Booking Fee", "price": 90 },
  { "name": "Driver Navigation Tool Access", "price": 10 },
  { "name": "Local Permit Charges", "price": 35 },
  { "name": "Driver Tip (User-Defined)", "price": 50 },
  { "name": "Advance Booking Fee", "price": 30 },
  { "name": "Ride Summary SMS Service", "price": 5 },
  { "name": "Parking Charges (Actuals)", "price": 40 },
  { "name": "Outstation Driver Allowance", "price": 100 },
  { "name": "Wait and Return Fee", "price": 85 },
  { "name": "Onboarding Platform Support Fee", "price": 20 },
  { "name": "Real-Time Navigation Premium", "price": 15 },
  { "name": "Customer Loyalty Adjustment", "price": -30 },
  { "name": "Rewards Redemption Credit", "price": -50 },
  { "name": "Instant Booking Confirmation Fee", "price": 20 },
  { "name": "Wallet Recharge Applied", "price": -60 },
  { "name": "Promo Ride Fare Waiver", "price": -90 },
  { "name": "Referral Code Discount", "price": -40 },
  { "name": "Platform Partner Commission", "price": 55 },
  { "name": "Live Support Agent Fee", "price": 25 },
  { "name": "Ride Verification SMS Fee", "price": 10 },
  { "name": "Interstate Toll Tax", "price": 95 },
  { "name": "Night Express Premium Service", "price": 65 },
  { "name": "Fleet Management Cost Recovery", "price": 15 },
  { "name": "Ride Bonus Cashback", "price": -20 },
  { "name": "Flat Rate City Ride Benefit", "price": -25 },
  { "name": "Advance ETA Priority Access", "price": 30 },
  { "name": "Ride Quality Guarantee Fee", "price": 20 },
  { "name": "Smart Route Mapping Fee", "price": 10 },
  { "name": "Rider Preferences Configuration", "price": 5 },
  { "name": "Driver Profile Access Charge", "price": 5 },
  { "name": "Lost Item Inquiry Charge", "price": 20 },
  { "name": "Platform Technology Fee", "price": 10 },
  { "name": "Cancellation Adjustment Credit", "price": -50 },
  { "name": "Advanced Ride Planner Service", "price": 35 },
  { "name": "VIP Rider Experience Fee", "price": 100 },
  { "name": "Driver Arrival Status Update", "price": 10 },
  { "name": "Festival Season Bonus Fare", "price": 85 },
  { "name": "Fuel Efficiency Charge", "price": 25 },
  { "name": "Vehicle Cleaning Surcharge", "price": 20 },
  { "name": "Safety Kit Compliance Fee", "price": 10 },
  { "name": "Digital Map Sync Premium", "price": 15 },
  { "name": "Driver Identity Verification Fee", "price": 10 },
  { "name": "Auto Fare Adjustment", "price": -15 },
  { "name": "Dynamic Distance Fare Tweak", "price": 25 },
  { "name": "Ride Feedback Incentive", "price": -10 },
  { "name": "App Notification Alert Charge", "price": 5 },
  { "name": "Custom Route Selection Fee", "price": 20 },
  { "name": "E-Receipt Generation Fee", "price": 5 },
  { "name": "Prepaid Ride Credit Utilized", "price": -100 },
  { "name": "Flexible Ride Reschedule Fee", "price": 30 },
  { "name": "Low Network Area Charge", "price": 15 },
  { "name": "Service Downtime Credit", "price": -25 },
  { "name": "Vehicle Sanitization Compliance Bonus", "price": -10 },
  { "name": "Mobile Hotspot Access", "price": 25 },
  { "name": "Driver SOS Emergency Fee", "price": 50 },
  { "name": "Driver Rating-Based Adjustment", "price": 20 },
  { "name": "Digital Invoice Archive Access", "price": 5 },
  { "name": "AI Routing Efficiency Surcharge", "price": 15 },
  { "name": "Real-Time Ride Tracking Add-On", "price": 10 },
  { "name": "Bonus Loyalty Points Credit", "price": -30 },
  { "name": "Cross-Zone Travel Fee", "price": 45 },
  { "name": "Suburban Ride Transfer Cost", "price": 35 },
  { "name": "Vehicle Size Upgrade Charge", "price": 90 },
  { "name": "Senior Citizen Discount", "price": -20 },
  { "name": "Long-Distance Ride Adjustment", "price": 70 },
  { "name": "Non-Standard Vehicle Option Fee", "price": 55 },
  { "name": "Exclusive Route Premium", "price": 40 },
  { "name": "Digital Booking Confirmation Alert", "price": 5 },
  { "name": "Holiday Bonus Fare Adjustment", "price": -60 },
  { "name": "Ride Delay Recovery Fee", "price": 25 },
  { "name": "Driver Reassignment Charge", "price": 20 },


  { "name": "Female Driver Request Charge", "price": 35 },
  { "name": "Luxury Vehicle Interior Upgrade", "price": 70 },
  { "name": "Remote Location Pickup Fee", "price": 60 },
  { "name": "Rainy Day Surge Premium", "price": 80 },
  { "name": "Driver Courtesy Notification Fee", "price": 10 },
  { "name": "Mobile Number Masking Service", "price": 5 },
  { "name": "Wheelchair Access Ride Charge", "price": 100 },
  { "name": "Trip Recap Email Service", "price": 5 },
  { "name": "Rental Ride Hourly Charge", "price": 160 },
  { "name": "In-App Language Selection Premium", "price": 10 },
  { "name": "VIP Boarding Gate Drop Fee", "price": 75 },
  { "name": "Pool Ride Matching Algorithm Fee", "price": 15 },
  { "name": "Traffic Delay Surcharge", "price": 50 },
  { "name": "Inter-Region Booking Fee", "price": 55 },
  { "name": "Vehicle Disinfection Charge", "price": 20 },
  { "name": "Carbon Offset Charge", "price": 12 },
  { "name": "Digital Wallet Promo Adjustment", "price": -45 },
  { "name": "Subscription Extension Credit", "price": -90 },
  { "name": "Road Assistance Onboard Fee", "price": 50 },
  { "name": "Driver Reallocation Service", "price": 30 },
  { "name": "Multi-Language Support Fee", "price": 10 },
  { "name": "Live Driver Tracker Fee", "price": 20 },
  { "name": "Flexible Booking Window Premium", "price": 25 },
  { "name": "Ride Completion Timestamp Service", "price": 5 },
  { "name": "Panic Button Activation Service", "price": 0 },
  { "name": "Trip Fare Lock Guarantee", "price": 15 },
  { "name": "In-Route Fuel Refill Surcharge", "price": 65 },
  { "name": "Custom Greeting Message Setup", "price": 10 },
  { "name": "Intercity Driver Lodging Cost", "price": 150 },
  { "name": "Vehicle Performance Feedback Reward", "price": -25 },
  { "name": "Late Driver Arrival Compensation", "price": -20 },
  { "name": "Auto-Generated Travel Report", "price": 5 },
  { "name": "Offline Booking Handling Fee", "price": 25 },
  { "name": "Companion Traveler Add-On", "price": 35 },
  { "name": "Safety Training Compliance Charge", "price": 20 },
  { "name": "Express Lane Ticket Charge", "price": 40 },
  { "name": "Traffic Violation Processing Fee", "price": 100 },
  { "name": "Limited Network Response Fee", "price": 15 },
  { "name": "Trip Edit Request Penalty", "price": 20 },
  { "name": "Destination Revalidation Fee", "price": 10 },
  { "name": "Digital Invoice Copy Email Fee", "price": 5 },
  { "name": "Monthly Ride Summary Fee", "price": 10 },
  { "name": "Safety Feedback Bonus", "price": -10 },
  { "name": "Taxi Permit Recovery Charge", "price": 55 },
  { "name": "Dynamic Rider Queue Adjustment", "price": 15 },
  { "name": "Neighborhood Proximity Bonus", "price": -15 },
  { "name": "Roadside Pickup Support Fee", "price": 25 },
  { "name": "Ride Auto-Scheduling Setup", "price": 30 },
  { "name": "Fleet Maintenance Premium", "price": 45 },
  { "name": "Child Booster Seat Rental", "price": 50 },
  { "name": "Flash Booking Activation Fee", "price": 20 },
  { "name": "Location Accuracy Compensation", "price": -25 },
  { "name": "Driver App Connectivity Booster", "price": 10 },
  { "name": "Trip Status Notification SMS", "price": 5 },
  { "name": "Alternate Driver Availability Service", "price": 30 },
  { "name": "On-Road ETA Correction Fee", "price": 15 },
  { "name": "Ride Rating Incentive Credit", "price": -10 },
  { "name": "Driver Mask Compliance Incentive", "price": -10 },
  { "name": "Ride Quality Monitor Charge", "price": 20 },
  { "name": "Surround Sound Entertainment Fee", "price": 25 },
  { "name": "Digital Ride History Export", "price": 10 },
  { "name": "Ride Auto-Routing Feature Access", "price": 15 },
  { "name": "Event-Based Fare Modifier", "price": 35 },
  { "name": "VIP Lounge Entry Fee", "price": 100 },
  { "name": "Scheduled Ride Reminder Alert", "price": 5 },
  { "name": "Vehicle Availability Notification", "price": 5 },
  { "name": "Trip Fare Dispute Review Fee", "price": 20 },
  { "name": "Rebooking Due to Traffic Jam", "price": 40 },
  { "name": "Driver Incentive Boost Fee", "price": 30 },
  { "name": "Energy Efficient Fleet Adjustment", "price": -20 },
  { "name": "Holiday Time Peak Fare", "price": 70 },


  { "name": "Driver Arrival Ahead of Time Bonus", "price": -20 },
  { "name": "Ride Sharing Capacity Credit", "price": -15 },
  { "name": "Location Auto-Sync Service Fee", "price": 10 },
  { "name": "Booking Change Convenience Surcharge", "price": 25 },
  { "name": "Auto Driver ID Masking Fee", "price": 5 },
  { "name": "Localized Language Chat Fee", "price": 5 },
  { "name": "Late Evening Ride Safety Premium", "price": 50 },
  { "name": "Suburban Route Service Charge", "price": 40 },
  { "name": "Promo Code Redemption Service", "price": -50 },
  { "name": "Air Purifier Onboard Usage Fee", "price": 25 },
  { "name": "Ride Queue Skipping Premium", "price": 35 },
  { "name": "Traffic Avoidance Route Access", "price": 30 },
  { "name": "Ride Comfort Level Upgrade", "price": 45 },
  { "name": "Extra Detour Mapping Fee", "price": 20 },
  { "name": "Weather Advisory Adjustment", "price": 10 },
  { "name": "Punctuality Incentive Applied", "price": -10 },
  { "name": "Vehicle Noise Cancellation Premium", "price": 25 },
  { "name": "Cleanliness Assurance Fee", "price": 15 },
  { "name": "Ride Cancellation SMS Alert", "price": 5 },
  { "name": "Digital Transaction Processing Fee", "price": 8 },
  { "name": "Advance Driver ETA Sync Charge", "price": 10 },
  { "name": "Contactless Ride Bonus", "price": -20 },
  { "name": "Vehicle Maintenance Recovery", "price": 30 },
  { "name": "Shared Ride Drop Order Optimization", "price": 15 },
  { "name": "Fare Confirmation Double Check", "price": 5 },
  { "name": "Passenger Volume Monitor Fee", "price": 10 },
  { "name": "App Optimization Infrastructure Charge", "price": 12 },
  { "name": "Taxi Permit Extension Surcharge", "price": 65 },
  { "name": "Last-Minute Booking Fee", "price": 30 },
  { "name": "Missed Ride Driver Compensation", "price": 45 },
  { "name": "Trip ETA Accuracy Bonus", "price": -10 },
  { "name": "Alternate Payment Gateway Fee", "price": 5 },
  { "name": "Driver Location Sharing Premium", "price": 8 },
  { "name": "Weather Delay Fare Buffer", "price": -25 },
  { "name": "High Demand Area Entry Surcharge", "price": 50 },
  { "name": "Rider Behavior Rating Credit", "price": -15 },
  { "name": "Personal Assistant Booking Fee", "price": 20 },
  { "name": "Live Ride Commentary Service", "price": 15 },
  { "name": "Driver Profile Enhancement Bonus", "price": -10 },
  { "name": "Location Fetch Retry Fee", "price": 5 },
  { "name": "Map Data Refresh Charge", "price": 10 },
  { "name": "Vehicle Temperature Regulation Premium", "price": 20 },
  { "name": "Extra Seat Reservation Fee", "price": 35 },
  { "name": "In-App Ride Type Comparison Tool Fee", "price": 5 },
  { "name": "Trip Resumption Service", "price": 20 },
  { "name": "Dynamic Fare Cap Adjustment", "price": 15 },
  { "name": "Passenger Group Ride Incentive", "price": -20 },
  { "name": "Driver Break Time Recovery Fee", "price": 25 },
  { "name": "Trip Directional Match Credit", "price": -10 },
  { "name": "GPS Boost Add-On", "price": 15 },
  { "name": "Multi-Lane Routing Option", "price": 12 },
  { "name": "Fare History Comparison Access", "price": 5 },
  { "name": "Onboarding Digital Consent Service", "price": 5 },
  { "name": "Road Quality Surge Factor", "price": 25 },
  { "name": "Digital Voice Assistant Fee", "price": 10 },
  { "name": "Trip Summary Export to PDF", "price": 5 },
  { "name": "Vehicle Fuel-Type Preference Surcharge", "price": 10 },
  { "name": "Pothole Tracker Usage", "price": 10 },
  { "name": "Ride Expansion Fee (Manual Extension)", "price": 20 },
  { "name": "Region Exit Fee (Geo-Fence Breach)", "price": 30 },
  { "name": "E-Wallet Conversion Cost", "price": 10 },
  { "name": "Address Geocoding Premium", "price": 5 },
  { "name": "Carpool Slot Guarantee Charge", "price": 25 },
  { "name": "Crowd Density Adjustment", "price": 15 },
  { "name": "Ride Pause Availability Bonus", "price": -15 },
  { "name": "Pre-Vetted Driver Service Charge", "price": 35 },
  { "name": "Map Lag Compensation", "price": -10 },
  { "name": "Scheduled Arrival Compliance Reward", "price": -20 },
  { "name": "In-Ride Entertainment Streaming", "price": 25 },
  { "name": "Smart Fare Meter Sync Service", "price": 10 },


                  ],
          "Vehicle detailing and cleaning": [

    { "name": "Basic Exterior Wash", "price": 400 },
  { "name": "Interior Vacuum Cleaning", "price": 350 },
  { "name": "Full Body Waterless Wash", "price": 600 },
  { "name": "Dashboard Shine Treatment", "price": 250 },
  { "name": "Seat Fabric Shampooing", "price": 950 },
  { "name": "Leather Seat Conditioning", "price": 1100 },
  { "name": "Underbody Cleaning", "price": 700 },
  { "name": "Engine Bay Detailing", "price": 850 },
  { "name": "Alloy Wheel Polishing", "price": 400 },
  { "name": "Tire Dressing", "price": 200 },
  { "name": "Glass Cleaning (Inside & Out)", "price": 300 },
  { "name": "Windshield Bug Remover Treatment", "price": 350 },
  { "name": "Ceramic Coating (Exterior)", "price": 5500 },
  { "name": "Wax Sealant Application", "price": 900 },
  { "name": "Paint Decontamination Clay Bar", "price": 950 },
  { "name": "Headlight Restoration", "price": 750 },
  { "name": "Taillight Polishing", "price": 550 },
  { "name": "Door Jamb Cleaning", "price": 300 },
  { "name": "Roof Cleaning", "price": 450 },
  { "name": "Sunroof Track Cleaning", "price": 600 },
  { "name": "Floor Mat Shampooing", "price": 400 },
  { "name": "Trunk Vacuuming", "price": 350 },
  { "name": "Carpet Steam Cleaning", "price": 1200 },
  { "name": "Pet Hair Removal Service", "price": 700 },
  { "name": "Odor Neutralizing Spray", "price": 500 },
  { "name": "AC Vent Disinfection", "price": 650 },
  { "name": "Smoke Smell Removal Treatment", "price": 1000 },
  { "name": "Exterior Tar Spot Removal", "price": 450 },
  { "name": "Bug & Bird Dropping Removal", "price": 350 },
  { "name": "Wheel Well Detailing", "price": 400 },
  { "name": "Chrome Trim Buffing", "price": 450 },
  { "name": "Scratch Detection Scan", "price": 250 },
  { "name": "Minor Paint Touch-Up", "price": 950 },
  { "name": "Plastic Trim Revival", "price": 600 },
  { "name": "Windshield Water Repellent Coating", "price": 650 },
  { "name": "Rain Guard Installation", "price": 1200 },
  { "name": "Detailing Clay Lubricant Application", "price": 350 },
  { "name": "Door Panel Polish", "price": 400 },
  { "name": "Dashboard Deep Clean", "price": 500 },
  { "name": "Instrument Panel Dusting", "price": 250 },
  { "name": "Cup Holder Cleaning", "price": 150 },
  { "name": "Interior Trim Coating", "price": 550 },
  { "name": "Leather Steering Wheel Cleaning", "price": 350 },
  { "name": "Rear Window Tint Polish", "price": 400 },
  { "name": "Fabric Roof Liner Spot Cleaning", "price": 800 },
  { "name": "Child Seat Cleaning", "price": 600 },
  { "name": "Mobile Detailing Equipment Charge", "price": 250 },
  { "name": "Eco-Friendly Shampoo Surcharge", "price": 150 },
  { "name": "Fragrance Add-On", "price": 200 },
  { "name": "Manual Hand Wash Premium", "price": 500 },
  { "name": "Rims Acid Wash", "price": 700 },
  { "name": "In-Car Entertainment Screen Polish", "price": 300 },
  { "name": "Ambient Light Area Cleaning", "price": 350 },
  { "name": "Sunshade Cleaning", "price": 250 },
  { "name": "Interior Leather Panel Buff", "price": 550 },
  { "name": "Windshield Seal Inspection", "price": 400 },
  { "name": "Exterior Decal Cleaning", "price": 300 },
  { "name": "Touchscreen Sanitization", "price": 150 },
  { "name": "Glove Box Detailing", "price": 250 },
  { "name": "Battery Cover Dusting", "price": 200 },
  { "name": "License Plate Frame Cleaning", "price": 150 },
  { "name": "Mud Flap Shine", "price": 250 },
  { "name": "Wheel Nut Polish", "price": 300 },
  { "name": "Exhaust Tip Detailing", "price": 350 },
  { "name": "Windshield Washer Nozzle Clean", "price": 200 },
  { "name": "AC Filter Surface Dusting", "price": 250 },
  { "name": "Smart Key Fob Detailing", "price": 150 },
  { "name": "Exterior Mirror Polish", "price": 300 },
  { "name": "Dashboard Button Dusting", "price": 150 },
  { "name": "Ambient Light Strip Polish", "price": 250 },
  { "name": "Trunk Seal Cleaning", "price": 200 },


  { "name": "Exterior Foam Pre-Wash", "price": 500 },
  { "name": "Door Seal Conditioning", "price": 350 },
  { "name": "Interior UV Protectant Application", "price": 400 },
  { "name": "Plastic Fender Shine", "price": 300 },
  { "name": "Rubber Floor Mat Scrub", "price": 250 },
  { "name": "Windshield Streak-Free Finish", "price": 350 },
  { "name": "Bug Guard Polish", "price": 400 },
  { "name": "Microfiber Towel Cleaning Fee", "price": 150 },
  { "name": "Leather Dashboard Rejuvenation", "price": 550 },
  { "name": "Paint Swirl Removal", "price": 1200 },
  { "name": "Exterior Polish Prep Treatment", "price": 600 },
  { "name": "Anti-Fog Glass Coating", "price": 500 },
  { "name": "Fabric Protection Spray", "price": 650 },
  { "name": "Eco-Friendly Polish Upgrade", "price": 200 },
  { "name": "Exterior Mirror Frame Cleaning", "price": 300 },
  { "name": "Custom Decal Shine", "price": 350 },
  { "name": "Detailer's Accessory Kit Charge", "price": 250 },
  { "name": "Door Handle Crevice Cleaning", "price": 300 },
  { "name": "Exhaust Carbon Residue Removal", "price": 400 },
  { "name": "Pet Smell Neutralizer Service", "price": 700 },
  { "name": "Fabric Roof Steam Sanitation", "price": 850 },
  { "name": "Wheel Lug Nut Dust Extraction", "price": 300 },
  { "name": "Spare Tire Compartment Cleaning", "price": 450 },
  { "name": "Center Console Deep Clean", "price": 500 },
  { "name": "Rear Seat Detailing", "price": 600 },
  { "name": "Windshield Water Spot Elimination", "price": 400 },
  { "name": "Paint Overspray Removal", "price": 950 },
  { "name": "Child Seat Sanitization", "price": 550 },
  { "name": "Interior Stain Guard Treatment", "price": 800 },
  { "name": "AC Vent Dust Removal", "price": 350 },
  { "name": "Digital Display Polish", "price": 300 },
  { "name": "Fuel Cap Area Detailing", "price": 250 },
  { "name": "Battery Terminal Dust-Off", "price": 200 },
  { "name": "License Plate Rust Protection", "price": 350 },
  { "name": "Exterior Trim Ceramic Sealer", "price": 750 },
  { "name": "Sunshade Sanitizing", "price": 250 },
  { "name": "Windshield Rubber Polish", "price": 300 },
  { "name": "Alloy Wheel Ceramic Coat", "price": 950 },
  { "name": "Gear Knob Shine Treatment", "price": 200 },
  { "name": "Steering Column Dusting", "price": 250 },
  { "name": "Rear Windshield Spot Treatment", "price": 400 },
  { "name": "Floor Carpet Edge Vacuuming", "price": 350 },
  { "name": "Engine Cover Plastic Polish", "price": 300 },
  { "name": "Rear AC Vent Cleaning", "price": 250 },
  { "name": "Seat Belt Buckle Cleaning", "price": 150 },
  { "name": "Roof Rail Shine", "price": 400 },
  { "name": "Side Skirt Detailing", "price": 450 },
  { "name": "Mud Guard Power Rinse", "price": 300 },
  { "name": "Trunk Lid Hinges Detailing", "price": 250 },
  { "name": "Ambient Lighting Diffuser Polish", "price": 300 },
  { "name": "Window Channel Dust Removal", "price": 250 },
  { "name": "Cabin Air Odor Assessment", "price": 200 },
  { "name": "Rearview Camera Lens Clean", "price": 300 },
  { "name": "Tailgate Seal Wipe", "price": 250 },
  { "name": "Cup Holder Steam Flush", "price": 300 },
  { "name": "Leather Armrest Buffing", "price": 350 },
  { "name": "Fabric Seat Crease Cleaning", "price": 400 },
  { "name": "Windshield Washer Line Flush", "price": 300 },
  { "name": "Driver Footwell Detailing", "price": 300 },
  { "name": "Cargo Net Sanitization", "price": 200 },
  { "name": "Ambient Temperature Sensor Clean", "price": 150 },
  { "name": "Gear Shift Panel Dust-Off", "price": 250 },
  { "name": "Instrument Display Smudge Removal", "price": 200 },
  { "name": "Rain Sill Polish", "price": 250 },
  { "name": "Rear Parcel Shelf Cleaning", "price": 400 },
  { "name": "Dashboard Vents Micro-Scrub", "price": 300 },
  { "name": "Trunk Lid Logo Shine", "price": 200 },
  { "name": "Rearview Mirror Base Wipe", "price": 250 },
  { "name": "Side Step Dirt Removal", "price": 350 },


  { "name": "Front Grille Degreasing", "price": 350 },
  { "name": "Door Sill Brightening", "price": 300 },
  { "name": "Fabric Upholstery Spot Extraction", "price": 600 },
  { "name": "Interior Window Fog Remover", "price": 250 },
  { "name": "AC Blower Vent Sterilization", "price": 400 },
  { "name": "Chrome Surface Anti-Haze Polish", "price": 350 },
  { "name": "Trunk Cargo Liner Deep Clean", "price": 450 },
  { "name": "Leather Dashboard Buff", "price": 500 },
  { "name": "Wiper Blade Rubber Shine", "price": 200 },
  { "name": "License Plate Screw Rust-Off", "price": 150 },
  { "name": "Sunshade Clip Dust Extraction", "price": 200 },
  { "name": "Roof Edge Moulding Detailing", "price": 350 },
  { "name": "Exhaust Chrome Polish", "price": 450 },
  { "name": "Rear Fog Lamp Lens Cleaning", "price": 300 },
  { "name": "Trunk Carpet Spot Treatment", "price": 400 },
  { "name": "Sunroof Interior Dusting", "price": 300 },
  { "name": "Dashboard Screen Anti-Glare Clean", "price": 250 },
  { "name": "Exterior Trim Detail Brush Cleaning", "price": 400 },
  { "name": "Passenger Door Storage Bin Cleaning", "price": 250 },
  { "name": "Rear Seatbelt Retractor Clean", "price": 300 },
  { "name": "Seat Track Vacuum Extraction", "price": 350 },
  { "name": "Emergency Brake Handle Dusting", "price": 250 },
  { "name": "Window Tint Film Buffing", "price": 400 },
  { "name": "Corner Panel Dirt Rinse", "price": 300 },
  { "name": "Rear Spoiler Power Clean", "price": 450 },
  { "name": "Side Mirror Housing Wipe", "price": 300 },
  { "name": "Rear Door Handle Polishing", "price": 250 },
  { "name": "Trunk Lid Water Seal Inspection", "price": 300 },
  { "name": "Windshield Wiper Arm Detailing", "price": 250 },
  { "name": "Steering Wheel Button Deep Clean", "price": 350 },
  { "name": "Fuel Door Frame Dust-Off", "price": 200 },
  { "name": "Rear Seat Headrest Spot Clean", "price": 300 },
  { "name": "Roof Lining Mold Removal", "price": 650 },
  { "name": "Smart Key Sensor Pad Buff", "price": 150 },
  { "name": "Dashboard AC Control Panel Shine", "price": 300 },
  { "name": "Footrest Rubber Conditioning", "price": 200 },
  { "name": "Trunk Corner Residue Cleaning", "price": 350 },
  { "name": "Interior Door Trim Steam Detail", "price": 400 },
  { "name": "Rear Bumper Polish", "price": 450 },
  { "name": "Lower Side Skirt Foam Wash", "price": 400 },
  { "name": "Window Rubber Channel Treatment", "price": 250 },
  { "name": "Rearview Mirror Outer Shell Clean", "price": 300 },
  { "name": "Ambient Light Port Dusting", "price": 250 },
  { "name": "Fuel Filler Neck Detail", "price": 350 },
  { "name": "Hatchback Window Crevice Wash", "price": 300 },
  { "name": "Spare Wheel Space Wipe Down", "price": 350 },
  { "name": "Rear AC Controls Dust-Off", "price": 250 },
  { "name": "Front Door Speaker Grill Cleaning", "price": 300 },
  { "name": "Tailgate Sensor Port Wipe", "price": 250 },
  { "name": "Brake Light Lens Dust Removal", "price": 300 },
  { "name": "Gear Shift Surround Polish", "price": 200 },
  { "name": "Child Lock Handle Area Clean", "price": 250 },
  { "name": "Side Door Step Edge Wash", "price": 350 },
  { "name": "Cargo Net Frame Clean", "price": 200 },
  { "name": "Rear Windshield Defroster Grid Clean", "price": 400 },
  { "name": "Front Pillar Trim Cleaning", "price": 300 },
  { "name": "Car Key Housing Shine", "price": 150 },
  { "name": "Emergency Exit Sticker Wipe", "price": 200 },
  { "name": "Tailgate Dampers Spot Cleaning", "price": 250 },
  { "name": "Window Frame Interior Dust-Off", "price": 300 },
  { "name": "Rear Seat Center Console Detailing", "price": 400 },
  { "name": "Dashboard Edge Dirt Blasting", "price": 350 },
  { "name": "Sunshade Mount Dusting", "price": 200 },
  { "name": "Trunk Mat Anti-Fungal Spray", "price": 500 },
  { "name": "Windshield Top Seal Conditioning", "price": 350 },
  { "name": "Rear Mirror Glass Spot Polish", "price": 250 },
  { "name": "Cargo Tray Spot Vacuum", "price": 300 },
  { "name": "Headliner Edge Spot Cleaning", "price": 400 },
  { "name": "Rear Tow Hook Cover Buff", "price": 200 },
  { "name": "Windshield Washer Fluid Nozzle Clean", "price": 300 },


  { "name": "Interior Reading Light Lens Cleaning", "price": 200 },
  { "name": "Rear Speaker Grill Detailing", "price": 250 },
  { "name": "Fuel Lid Inner Surface Cleaning", "price": 300 },
  { "name": "Ambient Dashboard Accent Wipe", "price": 250 },
  { "name": "Rear Roof Spoiler Edge Buff", "price": 350 },
  { "name": "Front Bumper Crevice Detailing", "price": 400 },
  { "name": "Rear AC Duct Sanitization", "price": 300 },
  { "name": "Side Indicator Lens Polish", "price": 250 },
  { "name": "Rear License Plate Light Buff", "price": 150 },
  { "name": "Sunroof Outer Rim Cleaning", "price": 350 },
  { "name": "Front Pillar Surface Wipe", "price": 300 },
  { "name": "Rear Window Demister Strip Cleaning", "price": 250 },
  { "name": "Trunk Tail Light Panel Buffing", "price": 300 },
  { "name": "Armrest Storage Compartment Clean", "price": 250 },
  { "name": "Gear Lever Housing Detail", "price": 250 },
  { "name": "Rear Door Kick Plate Cleaning", "price": 200 },
  { "name": "Cabin Roof Fabric Odor Treatment", "price": 500 },
  { "name": "Mirror Control Switch Surface Wipe", "price": 200 },
  { "name": "Windshield Edge Molding Polish", "price": 300 },
  { "name": "Rear Glass Shade Surface Buff", "price": 400 },
  { "name": "Front Fender Arch Detail", "price": 350 },
  { "name": "Rear Cabin Speaker Dust-Off", "price": 250 },
  { "name": "Tailgate Latch Housing Clean", "price": 300 },
  { "name": "Steering Wheel Stitch Detailing", "price": 300 },
  { "name": "Sunshade Pivot Point Cleaning", "price": 250 },
  { "name": "Front Grill Mesh Debris Removal", "price": 400 },
  { "name": "Backup Camera Lens Dust-Off", "price": 300 },
  { "name": "Parking Brake Lever Area Polish", "price": 300 },
  { "name": "Side Glass Edge Buff", "price": 250 },
  { "name": "Trunk Lid Rubber Lip Cleaning", "price": 300 },
  { "name": "Rear Bumper Sensor Wipe", "price": 250 },
  { "name": "Sunroof Drain Channel Flush", "price": 400 },
  { "name": "Dashboard Lower Panel Dust Removal", "price": 250 },
  { "name": "Child Lock Mechanism Detail", "price": 200 },
  { "name": "Keyhole Polish and Sanitize", "price": 150 },
  { "name": "Airbag Badge Surface Cleaning", "price": 200 },
  { "name": "Tailpipe Exterior Carbon Removal", "price": 400 },
  { "name": "Wheel Arch Lip Detailing", "price": 300 },
  { "name": "Interior Panel Gap Cleaning", "price": 350 },
  { "name": "Console Cup Insert Sanitization", "price": 250 },
  { "name": "Cabin Sound Insulator Buff", "price": 350 },
  { "name": "License Plate Screw Polish", "price": 150 },
  { "name": "Front Door Latch Panel Wipe", "price": 250 },
  { "name": "Rear Glass Water Spot Treatment", "price": 300 },
  { "name": "Driver Door Pocket Debris Vacuum", "price": 250 },
  { "name": "Rearview Mirror Pivot Cleaning", "price": 200 },
  { "name": "Rear Windshield Washer Nozzle Detail", "price": 250 },
  { "name": "Cabin Light Control Panel Buff", "price": 300 },
  { "name": "Rear Seat ISOFIX Bracket Cleaning", "price": 250 },
  { "name": "AC Control Knob Dust Removal", "price": 200 },
  { "name": "Glove Compartment Seal Conditioning", "price": 300 },
  { "name": "Ambient Light Sensor Detailing", "price": 250 },
  { "name": "Trunk Access Handle Sanitize", "price": 250 },
  { "name": "Footwell Light Panel Polish", "price": 300 },
  { "name": "Seat Adjustment Lever Clean", "price": 250 },
  { "name": "Windscreen Wiper Nozzle Polish", "price": 200 },
  { "name": "Cabin Door Stopper Cleaning", "price": 200 },
  { "name": "Plastic Mud Flap Shine", "price": 250 },
  { "name": "Side Step Protective Film Cleaning", "price": 250 },
  { "name": "Driver Side Floor Mat Retainer Clean", "price": 200 },
  { "name": "Remote Key Button Sanitization", "price": 150 },
  { "name": "Rear Glass Defog Indicator Polish", "price": 250 },
  { "name": "Sunroof Frame Spot Buff", "price": 300 },
  { "name": "Dashboard Ambient Light Buff", "price": 200 },
  { "name": "Rear Quarter Window Seal Polish", "price": 300 },
  { "name": "Window Rain Channel Rinse", "price": 250 },
  { "name": "Side Mirror Indicator Housing Clean", "price": 250 },
  { "name": "Sunshade Vanity Mirror Lens Wipe", "price": 200 },
  { "name": "Windshield Corner Polish", "price": 300 },


                  ],
              "Towing and roadside assistance": [

    { "name": "Local Towing (Up to 10 km)", "price": 800 },
  { "name": "Long Distance Towing (Per km)", "price": 65 },
  { "name": "Flatbed Towing Service", "price": 1200 },
  { "name": "Wheel-Lift Tow Service", "price": 950 },
  { "name": "Motorcycle Towing", "price": 700 },
  { "name": "SUV/4x4 Towing", "price": 1100 },
  { "name": "Vehicle Winching (Basic)", "price": 650 },
  { "name": "Vehicle Winching (Heavy Duty)", "price": 1200 },
  { "name": "Accident Recovery Tow", "price": 1500 },
  { "name": "Breakdown Pickup – Urban Zone", "price": 900 },
  { "name": "Breakdown Pickup – Remote Area", "price": 1300 },
  { "name": "Roadside Battery Jump Start", "price": 400 },
  { "name": "Battery Replacement On-Site", "price": 1800 },
  { "name": "Flat Tire Change Assistance", "price": 350 },
  { "name": "Tire Inflation Service", "price": 250 },
  { "name": "On-Site Spare Tire Installation", "price": 400 },
  { "name": "Fuel Delivery (Up to 5 liters)", "price": 600 },
  { "name": "Engine Overheating Help", "price": 500 },
  { "name": "Lockout Assistance", "price": 650 },
  { "name": "Key Retrieval from Locked Vehicle", "price": 750 },
  { "name": "Mobile Mechanic Diagnosis", "price": 850 },
  { "name": "Coolant Top-Up Roadside", "price": 300 },
  { "name": "Oil Top-Up Roadside", "price": 350 },
  { "name": "Transmission Fluid Top-Up", "price": 400 },
  { "name": "Emergency Headlight Repair", "price": 500 },
  { "name": "Electrical Issue Assessment", "price": 600 },
  { "name": "On-Road Engine Stall Repair", "price": 900 },
  { "name": "Stuck Vehicle Sand Recovery", "price": 1000 },
  { "name": "Mud Recovery Assistance", "price": 950 },
  { "name": "Snow Recovery Assistance", "price": 1050 },
  { "name": "Roadside Radiator Hose Replacement", "price": 750 },
  { "name": "Emergency Brake Pad Repair", "price": 950 },
  { "name": "Tail Light Replacement Roadside", "price": 500 },
  { "name": "Tow Dolly Rental (Per Hour)", "price": 450 },
  { "name": "Emergency Roadside Welding", "price": 1200 },
  { "name": "Axle Support Recovery", "price": 1400 },
  { "name": "Towing Hook Installation", "price": 700 },
  { "name": "On-Spot Drive Belt Fix", "price": 850 },
  { "name": "Towing Standby Fee (Per 30 min)", "price": 200 },
  { "name": "Emergency Highway Dispatch", "price": 1600 },
  { "name": "Battery Terminal Tightening", "price": 300 },
  { "name": "Tailgate Lifting Help", "price": 500 },
  { "name": "Windshield Crack Tape Service", "price": 300 },
  { "name": "Jump Start via Power Bank", "price": 350 },
  { "name": "Emergency Hazard Reflector Setup", "price": 150 },
  { "name": "Oil Leak Inspection", "price": 450 },
  { "name": "Emergency Water Pump Assist", "price": 700 },
  { "name": "Mobile Air Pump Service", "price": 250 },
  { "name": "On-Demand Wheel Nut Tightening", "price": 200 },
  { "name": "Trunk Jam Unlock Service", "price": 400 },
  { "name": "Side Mirror Fix Roadside", "price": 300 },
  { "name": "Tow Vehicle Repositioning", "price": 500 },
  { "name": "Lift-Up Tow for Multi-Level Parking", "price": 1300 },
  { "name": "Emergency Trailer Hitch Install", "price": 750 },
  { "name": "Windshield Washer Top-Up", "price": 200 },
  { "name": "On-Spot Sensor Diagnostics", "price": 600 },
  { "name": "Tow Bar Installation Support", "price": 950 },
  { "name": "Tow Coordination via Call Center", "price": 100 },
  { "name": "Emergency Fuse Replacement", "price": 250 },
  { "name": "Roadside Bumper Reinforcement", "price": 800 },
  { "name": "Drive Shaft Recovery Service", "price": 1250 },
  { "name": "Tow Crew PPE Sanitization Fee", "price": 100 },
  { "name": "Service Scheduling Platform Access", "price": 50 },
  { "name": "Weekend Roadside Service Fee", "price": 200 },
  { "name": "Rainy Season Response Surcharge", "price": 150 },
  { "name": "Rural Area Response Premium", "price": 300 },
  { "name": "Highway Toll Advance Recovery", "price": 100 },
  { "name": "Emergency Direction Assistance", "price": 50 },
  { "name": "Tow Vehicle Mileage Surcharge", "price": 10 },
  { "name": "Vehicle Pick-Up & Drop Coordination", "price": 100 },


  { "name": "Vehicle Rollback Tow Service", "price": 1150 },
  { "name": "Car Recovery from Ditch", "price": 1300 },
  { "name": "Motorhome Towing Support", "price": 1800 },
  { "name": "Dead Battery Diagnosis", "price": 450 },
  { "name": "Roadside Fuel Filter Fix", "price": 500 },
  { "name": "Emergency Tire Patch", "price": 350 },
  { "name": "Electric Car Flatbed Service", "price": 1350 },
  { "name": "SUV Emergency Pull-Out", "price": 950 },
  { "name": "Tow Truck Arrival Delay Compensation", "price": -100 },
  { "name": "Remote Breakdown Coordination Fee", "price": 200 },
  { "name": "Electric Vehicle Battery Swap", "price": 1800 },
  { "name": "Roadside Battery Cable Fix", "price": 300 },
  { "name": "Emergency Lug Nut Removal", "price": 250 },
  { "name": "Low Clearance Garage Tow", "price": 1400 },
  { "name": "Trailer Hauling Assistance", "price": 1200 },
  { "name": "Motorbike Recovery Platform Support", "price": 750 },
  { "name": "Heavy-Duty Recovery Winch Setup", "price": 1300 },
  { "name": "Tow Scheduling via App", "price": 50 },
  { "name": "On-Road Sensor Reset", "price": 450 },
  { "name": "Vehicle Tilt Recovery", "price": 950 },
  { "name": "Luxury Car Flatbed Tow", "price": 1450 },
  { "name": "Roadside ECU Reset", "price": 600 },
  { "name": "Emergency Fan Belt Fix", "price": 800 },
  { "name": "Roadside Valve Cover Leak Seal", "price": 850 },
  { "name": "Starter Motor Kick-Start Service", "price": 900 },
  { "name": "Tow Crew Travel Charge", "price": 100 },
  { "name": "Roadside Jump Lead Rental", "price": 150 },
  { "name": "Premium Hazard Light Setup", "price": 200 },
  { "name": "Multi-Car Flatbed Deployment Fee", "price": 1700 },
  { "name": "Roadside Steering Fluid Refill", "price": 400 },
  { "name": "Truck Tire Inflation Assistance", "price": 350 },
  { "name": "Flatbed Reservation Booking Fee", "price": 100 },
  { "name": "Emergency Roadside Thermostat Inspection", "price": 500 },
  { "name": "Tow Truck Route Optimization Charge", "price": 75 },
  { "name": "Vehicle Alignment for Winch Entry", "price": 600 },
  { "name": "Roadside Drive Shaft Fix", "price": 1250 },
  { "name": "GPS-Based Breakdown Response Fee", "price": 90 },
  { "name": "Cold Crank Battery Boost", "price": 450 },
  { "name": "Tow Crew Availability Update Alert", "price": 30 },
  { "name": "Exhaust Leak Temporary Roadside Patch", "price": 550 },
  { "name": "Lock Jam Relief Service", "price": 600 },
  { "name": "Towing Night Vision Dispatch Fee", "price": 200 },
  { "name": "Rainy Season Tow Preparation", "price": 150 },
  { "name": "Roadside Differential Fluid Check", "price": 300 },
  { "name": "Tow Fleet Driver PPE Fee", "price": 50 },
  { "name": "Tow Zone Permit Retrieval Charge", "price": 100 },
  { "name": "Vehicle Identification Number (VIN) Relay Service", "price": 75 },
  { "name": "Vehicle Tilt Sensor Activation Check", "price": 400 },
  { "name": "Flatbed Tie-Down Strap Refit", "price": 300 },
  { "name": "Wheel Rotation for Towing Setup", "price": 250 },
  { "name": "Tow Hook Bolt Tightening", "price": 200 },
  { "name": "Windshield Visibility Spray Fee", "price": 100 },
  { "name": "Battery Voltage Level Report", "price": 200 },
  { "name": "Rear Axle Lift Tow Support", "price": 1100 },
  { "name": "Tire Air Pressure Monitoring Fee", "price": 150 },
  { "name": "Mobile Emergency Mechanic Coordination", "price": 180 },
  { "name": "Wheel Chock Placement Fee", "price": 120 },
  { "name": "Flatbed Loading Ramp Deployment", "price": 300 },
  { "name": "Tow Signal Light Installation Fee", "price": 200 },
  { "name": "Cargo Weight Balance Check", "price": 250 },
  { "name": "Tow Crew Directional Light Setup", "price": 180 },
  { "name": "Roadside Speed Sensor Reset", "price": 350 },
  { "name": "Vehicle Hazard Assessment Report", "price": 250 },
  { "name": "Tow Driver Availability Check Fee", "price": 75 },
  { "name": "Emergency Roadside Power Steering Assist", "price": 500 },
  { "name": "Fuel Tank Pressure Cap Check", "price": 200 },
  { "name": "Tow Route Risk Analysis Fee", "price": 100 },
  { "name": "Tail Light Lens Temporary Fix", "price": 300 },
  { "name": "Tow Bed Hydraulic System Prep", "price": 350 },
  { "name": "Roadside Jack Stand Support", "price": 250 },
  { "name": "Tow Crew Safety Briefing Fee", "price": 50 },
  { "name": "Battery Cable Heat Shrink Wrap", "price": 150 },


  { "name": "Roadside Alternator Belt Fix", "price": 850 },
  { "name": "Emergency Tow Signal Deployment", "price": 200 },
  { "name": "Tow Truck Dispatch Coordination", "price": 100 },
  { "name": "Flatbed Loading Assistance", "price": 350 },
  { "name": "Emergency Coolant Hose Patch", "price": 500 },
  { "name": "Roadside Engine Timing Inspection", "price": 750 },
  { "name": "Brake Fluid Pressure Check", "price": 300 },
  { "name": "Mobile Diagnostic Tool Fee", "price": 150 },
  { "name": "Heavy Vehicle Recovery Tow", "price": 1800 },
  { "name": "Remote Valley Recovery Support", "price": 1450 },
  { "name": "Tow Equipment Clean-Up Fee", "price": 100 },
  { "name": "Emergency Rear Brake Release", "price": 650 },
  { "name": "Vehicle Heat Soak Prevention Service", "price": 400 },
  { "name": "Tow Setup Site Safety Evaluation", "price": 250 },
  { "name": "Trailer Recovery from Soft Ground", "price": 1350 },
  { "name": "Roadside Alternator Check", "price": 450 },
  { "name": "Emergency Rearview Mirror Fix", "price": 300 },
  { "name": "Remote Starter Override Setup", "price": 350 },
  { "name": "Tow Vehicle Safety Inspection", "price": 200 },
  { "name": "Transmission Sensor Roadside Reset", "price": 600 },
  { "name": "Tow Hook Bracket Refit", "price": 250 },
  { "name": "Roadside Parking Brake Adjustment", "price": 300 },
  { "name": "Breakaway Cable Installation", "price": 400 },
  { "name": "Underbody Panel Fastening Repair", "price": 550 },
  { "name": "Tow Crew Real-Time Navigation Charge", "price": 50 },
  { "name": "Roadside Dashboard Warning Reset", "price": 300 },
  { "name": "Vehicle Recovery from Ice Patch", "price": 1050 },
  { "name": "Flatbed Angle Ramp Setup", "price": 300 },
  { "name": "Roadside Wiper Motor Diagnosis", "price": 500 },
  { "name": "Fuel Injector Cleaning Roadside", "price": 750 },
  { "name": "Tow Crew Emergency Briefing", "price": 100 },
  { "name": "Suspension Quick-Check On-Road", "price": 400 },
  { "name": "Tow Location Geo-Tagging Fee", "price": 25 },
  { "name": "Tow Chain Hook Reposition", "price": 200 },
  { "name": "Roadside Hood Latch Release", "price": 250 },
  { "name": "Emergency Cabin Unlock Service", "price": 450 },
  { "name": "Power Window Jam Relief", "price": 300 },
  { "name": "Mobile Cooling Fan Repair", "price": 700 },
  { "name": "Vehicle Keypad Reset Assistance", "price": 200 },
  { "name": "Digital OBD Reading Fee", "price": 150 },
  { "name": "Tow Truck Brake Light Setup", "price": 250 },
  { "name": "Roadside Exhaust Bracket Repair", "price": 400 },
  { "name": "Tow Hitch Stabilizer Install", "price": 600 },
  { "name": "Roadside Gear Shift Link Adjustment", "price": 500 },
  { "name": "Tow Platform Load Securing Charge", "price": 350 },
  { "name": "Emergency Undercarriage Review", "price": 450 },
  { "name": "Spare Wheel Air Valve Fix", "price": 250 },
  { "name": "Battery Pack Heat Level Check", "price": 300 },
  { "name": "Emergency Clutch Release Tool Use", "price": 400 },
  { "name": "Tow Crew Route Diversion Fee", "price": 100 },
  { "name": "On-Road Speed Sensor Calibration", "price": 350 },
  { "name": "Tow Vehicle Cabin Filter Cleaning", "price": 200 },
  { "name": "Roadside Trunk Seal Refit", "price": 250 },
  { "name": "Drive Belt Slack Adjustment", "price": 450 },
  { "name": "Axle Grease Replenishment", "price": 400 },
  { "name": "Emergency Load Balancer Assessment", "price": 550 },
  { "name": "Flatbed Turn Radius Parking Assist", "price": 100 },
  { "name": "Mobile Climate Control Diagnosis", "price": 300 },
  { "name": "Electric Vehicle Isolation Safety Check", "price": 600 },
  { "name": "Tow Hitch Receiver Bolt Tightening", "price": 200 },
  { "name": "Wheel Hub Quick Lubrication", "price": 250 },
  { "name": "Trailer Brake Wire Repair", "price": 300 },
  { "name": "Mobile Hazard Triangle Setup", "price": 150 },
  { "name": "Air Suspension Leak Check", "price": 400 },
  { "name": "Tow Scheduling Confirmation SMS Fee", "price": 25 },
  { "name": "On-Road GPS Coordination Charge", "price": 50 },
  { "name": "Bumper Edge Tape Application", "price": 200 },
  { "name": "Roadside Fob Battery Replacement", "price": 250 },
  { "name": "Tow Crew Sanitization Add-On", "price": 100 },
  { "name": "Vehicle Weight Distribution Review", "price": 350 },
  { "name": "Flat Tire Rim Damage Inspection", "price": 300 },
  { "name": "Tow Platform Wash-Down Fee", "price": 150 },



  { "name": "Roadside Thermostat Replacement", "price": 750 },
  { "name": "Tow Vehicle Entry Ramp Refit", "price": 400 },
  { "name": "Mobile Engine Control Module Inspection", "price": 650 },
  { "name": "Powertrain Sensor Diagnosis", "price": 550 },
  { "name": "Emergency Steering Column Unlock", "price": 350 },
  { "name": "Tow Operator Location Update Fee", "price": 30 },
  { "name": "Tow Mirror Visibility Inspection", "price": 250 },
  { "name": "Tow Truck Hydraulic Fluid Check", "price": 200 },
  { "name": "Roadside Ignition Coil Scan", "price": 450 },
  { "name": "Vehicle Tilt Stabilization Blocks", "price": 300 },
  { "name": "Tow Route Compliance Confirmation", "price": 100 },
  { "name": "Brake Caliper Inspection Roadside", "price": 500 },
  { "name": "Emergency Engine Crank Assist", "price": 600 },
  { "name": "Mobile Fuse Box Refit", "price": 350 },
  { "name": "Tailgate Load Balance Adjustment", "price": 300 },
  { "name": "Tow Rig Suspension Tension Check", "price": 250 },
  { "name": "Roadside Engine Cover Panel Refit", "price": 400 },
  { "name": "Mobile Windshield Washer Line Clear", "price": 200 },
  { "name": "Roadside Cabin Noise Source Inspection", "price": 300 },
  { "name": "Tow Ramp Extension Fitting", "price": 350 },
  { "name": "Emergency Antifreeze Top-Up", "price": 300 },
  { "name": "On-Road Starter Relay Testing", "price": 450 },
  { "name": "Tow Bed Lock Pin Setup", "price": 250 },
  { "name": "Mobile Engine Mount Visual Check", "price": 300 },
  { "name": "Tow Vehicle Electrical Relay Check", "price": 200 },
  { "name": "Roadside Coolant Reservoir Sealing", "price": 350 },
  { "name": "Wheel Hub Grease Pack Refill", "price": 300 },
  { "name": "Flatbed Ramp Angle Adjustment Fee", "price": 200 },
  { "name": "Mobile Cabin Filter Panel Removal", "price": 250 },
  { "name": "Tow Team Backup Signal Test", "price": 200 },
  { "name": "Emergency Pulley Alignment Service", "price": 400 },
  { "name": "Mobile Axle Nut Tightening", "price": 250 },
  { "name": "Vehicle Body Panel Securement", "price": 350 },
  { "name": "Roadside Cabin Leak Check", "price": 300 },
  { "name": "Tow Dashboard Alert Light Scan", "price": 150 },
  { "name": "Fuel Cap Vent Clearance Service", "price": 200 },
  { "name": "Wheel Alignment Prep for Towing", "price": 400 },
  { "name": "Brake Drum Exterior Dust Off", "price": 250 },
  { "name": "Tow Shackles Quick Inspection", "price": 150 },
  { "name": "Gear Linkage Test Roadside", "price": 350 },
  { "name": "Windshield Wiper Washer Nozzle Replace", "price": 200 },
  { "name": "Emergency Cabin Smoke Ventilation", "price": 250 },
  { "name": "Tow Crew Real-Time ETA Report", "price": 50 },
  { "name": "Mobile Fog Lamp Relay Check", "price": 300 },
  { "name": "Vehicle Driveline Component Scan", "price": 400 },
  { "name": "Tow Operator Dispatch Status Sync", "price": 30 },
  { "name": "Radiator Overflow Pipe Securement", "price": 250 },
  { "name": "On-Road Tail Light Circuit Inspection", "price": 300 },
  { "name": "Emergency Trunk Hydraulic Piston Support", "price": 450 },
  { "name": "Trailer Safety Cable Hookup", "price": 350 },
  { "name": "Roadside Ignition Switch Reset", "price": 400 },
  { "name": "Tow Path Clearance Setup", "price": 200 },
  { "name": "Axle Support Beam Torque Check", "price": 300 },
  { "name": "Tow Crew Shift Rotation Fee", "price": 50 },
  { "name": "Cabin Vibration Source Diagnosis", "price": 350 },
  { "name": "Roadside Gearbox Fluid Pressure Check", "price": 300 },
  { "name": "Tow Signal Equipment Synchronization", "price": 200 },
  { "name": "Emergency Hood Pin Realignment", "price": 250 },
  { "name": "On-Demand Vehicle Push Assist", "price": 200 },
  { "name": "Trailer Axle Movement Clearance", "price": 300 },
  { "name": "Tow Truck Stabilizer Beam Inspection", "price": 250 },
  { "name": "Roadside RPM Sensor Reading", "price": 300 },
  { "name": "Emergency Cabin Unlock Code Entry", "price": 200 },
  { "name": "Tow Bed Exit Path Setup", "price": 150 },
  { "name": "Mobile Transmission Mount Check", "price": 400 },
  { "name": "Tow Equipment Sanitization Fee", "price": 100 },
  { "name": "Roadside Headlamp Focus Test", "price": 250 },
  { "name": "Tow Crew Dispatch Form Processing", "price": 50 },
  { "name": "Wiring Harness Routing Inspection", "price": 300 },
  { "name": "Tire Tread Emergency Assessment", "price": 250 },


                  ],
              "Plumbing and electrical services": [

      { "name": "Bathroom Tap Installation", "price": 850 },
  { "name": "Kitchen Sink Drain Repair", "price": 950 },
  { "name": "Flush Tank Replacement", "price": 1350 },
  { "name": "Shower Head Upgrade", "price": 750 },
  { "name": "Leakage Detection and Seal", "price": 900 },
  { "name": "Water Heater Wiring and Fitting", "price": 1800 },
  { "name": "Toilet Seat Installation", "price": 600 },
  { "name": "Pressure Pump Setup", "price": 2200 },
  { "name": "Geyser Safety Valve Replacement", "price": 400 },
  { "name": "Wall Mixer Installation", "price": 950 },
  { "name": "Copper Pipe Rerouting", "price": 1800 },
  { "name": "Hand Shower Fitting", "price": 450 },
  { "name": "Washbasin Waste Coupling Install", "price": 300 },
  { "name": "Drain Trap Cleaning", "price": 500 },
  { "name": "Angle Valve Replacement", "price": 350 },
  { "name": "CPVC Pipe Leakage Fix", "price": 950 },
  { "name": "Wall Faucet Realignment", "price": 550 },
  { "name": "Floor Drain Grating Install", "price": 400 },
  { "name": "Water Tank Overflow Pipe Refit", "price": 600 },
  { "name": "Main Supply Line Inspection", "price": 750 },
  { "name": "Inlet Hose Pipe Replacement", "price": 300 },
  { "name": "Bathroom Jet Spray Setup", "price": 350 },
  { "name": "Water Tap Threading Service", "price": 250 },
  { "name": "Electrical Switch Box Install", "price": 800 },
  { "name": "LED Bulb Replacement", "price": 150 },
  { "name": "Ceiling Fan Mounting", "price": 900 },
  { "name": "Tube Light Repair and Refitting", "price": 650 },
  { "name": "Exhaust Fan Electrical Install", "price": 850 },
  { "name": "Electrical Conduit Laying", "price": 1200 },
  { "name": "Outdoor Light Fixture Install", "price": 700 },
  { "name": "Main MCB Replacement", "price": 950 },
  { "name": "Power Outlet Wiring Setup", "price": 750 },
  { "name": "Three-Pin Socket Install", "price": 450 },
  { "name": "Switch Board Upgrade", "price": 850 },
  { "name": "Door Bell Wiring and Fitting", "price": 400 },
  { "name": "Electrical Junction Box Fix", "price": 650 },
  { "name": "Cable Tray Installation", "price": 950 },
  { "name": "Light Dimmer Fitting", "price": 500 },
  { "name": "Chandelier Setup and Wiring", "price": 1600 },
  { "name": "AC Power Point Installation", "price": 850 },
  { "name": "Stabilizer Wiring Setup", "price": 750 },
  { "name": "Bathroom Light Switch Repair", "price": 300 },
  { "name": "Modular Switch Panel Setup", "price": 900 },
  { "name": "Water Pump Electrical Connection", "price": 1000 },
  { "name": "UPS Input Wiring and Termination", "price": 1200 },
  { "name": "Inverter Battery Cable Replacement", "price": 650 },
  { "name": "Digital Meter Installation", "price": 1100 },
  { "name": "Electrical Earthing Check", "price": 750 },
  { "name": "Service Wire Replacement", "price": 1800 },
  { "name": "Plastic Box Concealed Wiring", "price": 700 },
  { "name": "Split AC Power Cable Installation", "price": 850 },
  { "name": "Water Motor Starter Repair", "price": 600 },
  { "name": "Light Fixture Height Adjustment", "price": 400 },
  { "name": "Wiring Phase Identifier Tagging", "price": 300 },
  { "name": "Home Distribution Board Audit", "price": 1000 },
  { "name": "Doorbell Circuit Test", "price": 250 },
  { "name": "Light Circuit Load Balancing", "price": 850 },
  { "name": "Generator Plug Point Setup", "price": 950 },
  { "name": "Corridor Light Cabling", "price": 400 },
  { "name": "Bathroom Floor Leakage Grout", "price": 800 },
  { "name": "Water Pressure Regulator Fit", "price": 700 },
  { "name": "Plumbing Pipe Insulation Wrap", "price": 500 },
  { "name": "Toilet Water Seal Leak Fix", "price": 600 },
  { "name": "Basin Tap Thread Joint Reinforce", "price": 300 },
  { "name": "Water Tank Electric Float Valve Install", "price": 850 },
  { "name": "Copper Wire Earth Rod Setup", "price": 650 },
  { "name": "MCB Tripping Diagnosis", "price": 400 },
  { "name": "Toilet Flush Button Assembly Fix", "price": 500 },
  { "name": "Wall Outlet Load Test", "price": 350 },
  { "name": "Digital Timer Switch Installation", "price": 600 },


  { "name": "Wall-Hung Wash Basin Setup", "price": 950 },
  { "name": "PVC Floor Trap Replacement", "price": 600 },
  { "name": "Flexible Waste Pipe Installation", "price": 300 },
  { "name": "Rainwater Outlet Repositioning", "price": 850 },
  { "name": "Flush Valve Internal Seal Change", "price": 450 },
  { "name": "Outdoor Garden Tap Installation", "price": 500 },
  { "name": "Bathroom Floor Grouting & Waterproofing", "price": 1400 },
  { "name": "Solar Water Heater Line Setup", "price": 2200 },
  { "name": "Angle Cock Thread Reinforce", "price": 350 },
  { "name": "Overhead Tank Pipe Realignment", "price": 900 },
  { "name": "Underground Drain Line Leak Fix", "price": 1600 },
  { "name": "Concealed Tap Access Hole Rework", "price": 550 },
  { "name": "Bidet Jet Pipe Fitting", "price": 400 },
  { "name": "Bathroom Partition Pipe Hole Sealing", "price": 350 },
  { "name": "Double Bowl Sink Plumbing", "price": 1200 },
  { "name": "Gravity Drain Hose Install", "price": 300 },
  { "name": "Water Meter Supply Line Connection", "price": 950 },
  { "name": "Balcony Floor Drain Cover Fit", "price": 250 },
  { "name": "Gully Trap Clear & Refit", "price": 850 },
  { "name": "Tank Lid with Overflow Pipe Combo Install", "price": 750 },
  { "name": "Wall Concealed Pipe Joint Rework", "price": 950 },
  { "name": "Solar Heater Return Pipe Fix", "price": 400 },
  { "name": "Handwash Station Line Testing", "price": 300 },
  { "name": "Sump Water Outlet Valve Install", "price": 550 },
  { "name": "Roof Drainage Pipe Leak Fix", "price": 650 },
  { "name": "Pressure Valve Line T-Joint Fix", "price": 300 },
  { "name": "Water Tank Level Sensor Wiring", "price": 700 },
  { "name": "LED Strip Lighting Setup", "price": 950 },
  { "name": "Motion Sensor Light Install", "price": 850 },
  { "name": "Corridor Auto-Switch Wiring", "price": 600 },
  { "name": "Ceiling Light False Panel Fitting", "price": 650 },
  { "name": "Inverter Earth Line Routing", "price": 400 },
  { "name": "Digital Thermostat Power Feed", "price": 950 },
  { "name": "Waterproof Outdoor Socket Install", "price": 750 },
  { "name": "AC Copper Cable Routing", "price": 800 },
  { "name": "Electrical Distribution Block Fit", "price": 650 },
  { "name": "LED Panel Light False Ceiling Mount", "price": 1000 },
  { "name": "Lan Wire Point Creation", "price": 400 },
  { "name": "External Bell Siren Wiring", "price": 550 },
  { "name": "Smart Plug Power Point Setup", "price": 800 },
  { "name": "Panel Board Wiring Cleanup", "price": 650 },
  { "name": "Electrical Load Report & Correction", "price": 1250 },
  { "name": "Switch Loop Conversion", "price": 500 },
  { "name": "Smart Home Hub Connection Support", "price": 1000 },
  { "name": "Dimmer with Remote Setup", "price": 900 },
  { "name": "TV Power Outlet Position Shift", "price": 450 },
  { "name": "Single-Phase Motor Starter Wiring", "price": 850 },
  { "name": "LAN Cable Termination & Crimping", "price": 300 },
  { "name": "Recessed Light Cut-Out & Fit", "price": 600 },
  { "name": "Under-Cabinet Light Strip Setup", "price": 700 },
  { "name": "Switchboard Wall Cut Box Mount", "price": 550 },
  { "name": "Electric Geyser Socket Wiring", "price": 650 },
  { "name": "Electrical Load Shift Testing", "price": 800 },
  { "name": "Miniature Circuit Breaker Box Mount", "price": 750 },
  { "name": "Fan Regulator Wall Flush Fix", "price": 350 },
  { "name": "Smart Home Switch Module Fit", "price": 950 },
  { "name": "Wall Niche Concealed Electrical Support", "price": 800 },
  { "name": "Aesthetic Light Highlight Installation", "price": 900 },
  { "name": "Neutral Wire Load Path Check", "price": 300 },
  { "name": "Electrical Socket Height Correction", "price": 400 },
  { "name": "Outdoor Shed Light Wiring", "price": 700 },
  { "name": "Water Pump Float Switch Circuit", "price": 750 },
  { "name": "Fan Capacitor Fit and Test", "price": 500 },
  { "name": "AC Wall Power Routing", "price": 850 },
  { "name": "Main Panel Surge Protector Install", "price": 950 },
  { "name": "Washing Machine Outlet Wiring", "price": 600 },
  { "name": "Digital Switch Timer Programming", "price": 450 },
  { "name": "Light Loop Neutral Conversion", "price": 550 },
  { "name": "Split MCB Dual Line Setup", "price": 850 },
  { "name": "Bathroom Mirror LED Backlight Install", "price": 950 },


  { "name": "Floor-Mounted Commode Installation", "price": 850 },
  { "name": "Rainwater Pipe Cap Fitment", "price": 250 },
  { "name": "Geyser Outlet Pipe Extension", "price": 600 },
  { "name": "Flush Valve Dual-Mode Conversion", "price": 700 },
  { "name": "Utility Sink Plumbing Setup", "price": 1200 },
  { "name": "Drain Inspection Chamber Cleaning", "price": 950 },
  { "name": "Wall Tap Rethreading", "price": 350 },
  { "name": "Underground Plumbing Leak Excavation", "price": 1800 },
  { "name": "Overhead Tank Inlet Valve Replacement", "price": 500 },
  { "name": "Rainwater Harvesting Pipe Routing", "price": 1350 },
  { "name": "Bathroom Line Pressure Test", "price": 400 },
  { "name": "Double Handle Faucet Install", "price": 750 },
  { "name": "Kitchen Sink Strainer Basket Replacement", "price": 300 },
  { "name": "Wall Shower Mixer Cartridge Change", "price": 550 },
  { "name": "Bathtub Overflow Pipe Setup", "price": 1200 },
  { "name": "Drain Sludge Clearance & Flushing", "price": 850 },
  { "name": "Hand Faucet CP Extension Fit", "price": 300 },
  { "name": "Geyser Inlet Tee Connector Install", "price": 450 },
  { "name": "Pressure Control Valve Calibration", "price": 700 },
  { "name": "Plumbing Line Airlock Removal", "price": 500 },
  { "name": "Pop-Up Waste Mechanism Install", "price": 650 },
  { "name": "Toilet Floor Collar Sealing", "price": 400 },
  { "name": "Wall Cut Pipe Access Panel Setup", "price": 750 },
  { "name": "Cold/Hot Indicator Button Replace", "price": 200 },
  { "name": "Water Tank Float Ball Assembly", "price": 450 },
  { "name": "Bathroom Vertical Jet Spray Retrofit", "price": 500 },
  { "name": "External Garden Line Split Install", "price": 650 },
  { "name": "Heater Water Supply Check Valve Setup", "price": 900 },
  { "name": "Electrical Switch Indicator Light Fit", "price": 300 },
  { "name": "Multi-Gang Switch Panel Expansion", "price": 800 },
  { "name": "Electric Bell Push Point Rework", "price": 400 },
  { "name": "Switch Panel Recessed Mount Upgrade", "price": 600 },
  { "name": "Earth Leakage Circuit Breaker Install", "price": 1050 },
  { "name": "Fan Point Wall Wiring Correction", "price": 450 },
  { "name": "AC Stabilizer Socket Refit", "price": 600 },
  { "name": "Three-Pin Extension Box Setup", "price": 250 },
  { "name": "Lighting Fixture Height Realignment", "price": 350 },
  { "name": "TV Point Back Box Insert", "price": 300 },
  { "name": "Split Phase MCB Cabling", "price": 950 },
  { "name": "Circuit Breaker Test with Tools", "price": 500 },
  { "name": "Smart Doorbell Transformer Wiring", "price": 700 },
  { "name": "False Ceiling Downlight Wiring Kit Install", "price": 850 },
  { "name": "Fan Dimmer Regulator Conversion", "price": 400 },
  { "name": "Outdoor Sensor Light Dual Feed Wiring", "price": 950 },
  { "name": "Switch Module Depth Correction", "price": 300 },
  { "name": "Digital Voltage Display Panel Setup", "price": 650 },
  { "name": "AC Remote Sensor Wiring", "price": 550 },
  { "name": "Electrical Trunking Refitting", "price": 700 },
  { "name": "Solar Panel Inverter Wire Kit Setup", "price": 1600 },
  { "name": "Power Cable Routing through Wall Cutout", "price": 750 },
  { "name": "WiFi Router Power Point Installation", "price": 500 },
  { "name": "UPS Load Sharing Setup", "price": 950 },
  { "name": "Electrical Panel Labeling and Sorting", "price": 450 },
  { "name": "Automatic Light Sensor Calibration", "price": 300 },
  { "name": "Electrical Back Box Alignment", "price": 400 },
  { "name": "Modular Switch Redesign & Wire Merge", "price": 850 },
  { "name": "USB Wall Port Fitting", "price": 550 },
  { "name": "Electric Kettle Power Socket Fit", "price": 250 },
  { "name": "Voltage Stabilizer Earth Rod Connection", "price": 700 },
  { "name": "Generator Backfeed Breaker Setup", "price": 1200 },
  { "name": "Smart Lighting Control Panel Mount", "price": 1100 },
  { "name": "AC Condenser Cable Termination", "price": 500 },
  { "name": "Weatherproof Socket Outdoor Recess", "price": 600 },
  { "name": "Motion-Sensor Stair Light Wiring", "price": 850 },
  { "name": "Surge Protected Board Fit", "price": 950 },
  { "name": "Mainline Neutral Link Inspection", "price": 300 },
  { "name": "Waterproof Junction Box Install", "price": 700 },
  { "name": "Digital Timer Circuit Box Mounting", "price": 600 },
  { "name": "Under-Stair LED Strip Wire Management", "price": 500 },
  { "name": "Earth Pit Testing & Rod Refit", "price": 750 },
  { "name": "Dual Inverter System Synchronization", "price": 1250 },
  { "name": "LED Driver Module Setup", "price": 450 },


  { "name": "Ceiling Rose Electric Connection Setup", "price": 300 },
  { "name": "Plumbing Line Air Release Valve Fit", "price": 550 },
  { "name": "Bathroom Tap Wall Flange Refit", "price": 250 },
  { "name": "Smart Water Timer Valve Installation", "price": 950 },
  { "name": "Toilet Flush Leak Seal with Washer Kit", "price": 450 },
  { "name": "Water Tank PVC Ball Valve Replace", "price": 500 },
  { "name": "Pipe Sleeve Expansion Joint Install", "price": 600 },
  { "name": "Electrical Cable Fault Trace & Patch", "price": 850 },
  { "name": "Thermostat Wire Strip and Reconnect", "price": 350 },
  { "name": "Rainwater Downspout Diverter Setup", "price": 650 },
  { "name": "Water Tap Aerator Install", "price": 300 },
  { "name": "Sink Overflow Pipe Reposition", "price": 400 },
  { "name": "Electric Panel Lug Tightening Service", "price": 300 },
  { "name": "Smart Power Socket Wall Flush Mount", "price": 750 },
  { "name": "Digital Bell Circuit Installation", "price": 550 },
  { "name": "Kitchen RO Water Drain Tap Install", "price": 600 },
  { "name": "Electrical DB Earth Link Fitting", "price": 400 },
  { "name": "Geyser Wall Bracket Reinforcement", "price": 500 },
  { "name": "Fan Hook Ceiling Anchor Refit", "price": 350 },
  { "name": "Battery-Backup Emergency Light Wiring", "price": 850 },
  { "name": "False Ceiling Junction Box Inspection", "price": 300 },
  { "name": "Water Meter Gland Nut Tightening", "price": 250 },
  { "name": "AC Circuit Breaker Wall Integration", "price": 700 },
  { "name": "Hose Bib Leak Proof Reinforcement", "price": 400 },
  { "name": "Modular Plate Replacement with Loop Wiring", "price": 800 },
  { "name": "Water Pressure Booster Pipe Coupling", "price": 650 },
  { "name": "Automatic Sensor Light Wall Fixture", "price": 900 },
  { "name": "Basement Drain Valve Mounting", "price": 750 },
  { "name": "Load Distribution Phase Correction", "price": 950 },
  { "name": "Sink Flexible Connector Alignment", "price": 350 },
  { "name": "Electrical Load Path Simulation Report", "price": 600 },
  { "name": "Two-Way Switch Conversion Circuit Setup", "price": 700 },
  { "name": "Toilet Cistern Bottom Seal Assembly Fix", "price": 300 },
  { "name": "Outdoor IP Rated Electrical Box Mount", "price": 800 },
  { "name": "PVC Tap Body Leak Stop", "price": 250 },
  { "name": "LED Ceiling Light Housing Retrofit", "price": 650 },
  { "name": "Copper Terminal Connector Replacement", "price": 350 },
  { "name": "Water Heater Pressure Relief Pipe Fix", "price": 600 },
  { "name": "Wall Switch Phase Tester Service", "price": 450 },
  { "name": "AC Drain Line Pipe Extension", "price": 500 },
  { "name": "Bathroom Exhaust Cover Mounting", "price": 300 },
  { "name": "Water Filter Inlet Line Junction Setup", "price": 550 },
  { "name": "Electrical Appliance Earth Continuity Check", "price": 300 },
  { "name": "Sink P-Trap Realignment with Seal Kit", "price": 450 },
  { "name": "Wall Box Backplate Adjustment", "price": 250 },
  { "name": "Electric Geyser Miniature Breaker Fit", "price": 650 },
  { "name": "Tap Spindle Grease Reapplication Service", "price": 200 },
  { "name": "Three-Core Cable Termination with Gland", "price": 750 },
  { "name": "Pop-Up Basin Drain Mechanism Refit", "price": 500 },
  { "name": "Switch Point Load Testing Service", "price": 400 },
  { "name": "Water Line Tee Fit for Extension", "price": 300 },
  { "name": "Microwave Socket Power Rating Upgrade", "price": 600 },
  { "name": "Water Seal Ring Replacement for Tank", "price": 350 },
  { "name": "Electrical Conduit Bracket Refixing", "price": 300 },
  { "name": "Pressure Pump Sensor Circuit Wiring", "price": 800 },
  { "name": "LED Spotlight False Ceiling Integration", "price": 850 },
  { "name": "Service Wire Midpoint Loop Setup", "price": 700 },
  { "name": "Basin Counter Hole Cutout Finish", "price": 500 },
  { "name": "Water Tank Outlet Pipe Rework", "price": 450 },
  { "name": "Smart Switchboard Wi-Fi Sync Assist", "price": 950 },
  { "name": "Kitchen Sink Coupling Leakage Repair", "price": 400 },
  { "name": "Electric Wire Casing Slot Refinish", "price": 600 },
  { "name": "Floor Level Pipe Slope Correction", "price": 550 },
  { "name": "Digital Load Analyser Input Setup", "price": 700 },
  { "name": "Floor Gully Cover Cut & Fit", "price": 350 },
  { "name": "Electrical Shock Protection Advice Session", "price": 200 },
  { "name": "Plumbing Air Pressure Gauge Line Attach", "price": 400 },
  { "name": "Outlet Socket to Concealed Box Extension", "price": 450 },
  { "name": "Valve Stem Packing Reinforcement", "price": 300 },
  { "name": "Split AC External Box Feed Connection", "price": 850 },
  { "name": "Tap Thread Collar Ring Replace", "price": 200 },


                  ],
                  "Salon and grooming services": [
  { "name": "Haircut - Women's Classic", "price": 350 },
  { "name": "Haircut - Men's Executive", "price": 250 },
  { "name": "Hair Spa - Nourishing", "price": 800 },
  { "name": "Facial - Gold Radiance", "price": 1200 },
  { "name": "Facial - Fruit Glow", "price": 650 },
  { "name": "Manicure - Classic", "price": 400 },
  { "name": "Pedicure - Deluxe", "price": 550 },
  { "name": "Waxing - Full Arms", "price": 450 },
  { "name": "Waxing - Full Legs", "price": 600 },
  { "name": "Threading - Eyebrows", "price": 80 },
  { "name": "Threading - Upper Lip", "price": 50 },
  { "name": "Hair Coloring - Global", "price": 1800 },
  { "name": "Hair Coloring - Highlights", "price": 2200 },
  { "name": "Hair Straightening", "price": 3500 },
  { "name": "Hair Smoothening", "price": 3200 },
  { "name": "Keratin Treatment", "price": 4000 },
  { "name": "Botox Hair Therapy", "price": 4500 },
  { "name": "Beard Styling", "price": 200 },
  { "name": "Shaving - Classic", "price": 150 },
  { "name": "Head Massage - Oil", "price": 300 },
  { "name": "Body Massage - Relaxation", "price": 1500 },
  { "name": "Body Bleach", "price": 700 },
  { "name": "Detan - Face", "price": 500 },
  { "name": "Cleanup - Herbal", "price": 550 },
  { "name": "Bridal Makeup - HD", "price": 8500 },
  { "name": "Reception Makeup", "price": 6500 },
  { "name": "Saree Draping", "price": 400 },
  { "name": "Eye Makeup", "price": 1200 },
  { "name": "Nail Art - Basic", "price": 300 },
  { "name": "Nail Extensions - Gel", "price": 1800 },
  { "name": "Eyelash Extensions", "price": 2500 },
  { "name": "Hair Wash & Blow Dry", "price": 350 },
  { "name": "Hair Styling - Curls", "price": 600 },
  { "name": "Hair Styling - Straight", "price": 500 },
  { "name": "Hair Cut - Kids", "price": 200 },
  { "name": "Facial - Anti-Aging", "price": 1500 },
  { "name": "Facial - Acne Control", "price": 1000 },
  { "name": "Facial - Whitening", "price": 1100 },
  { "name": "Facial - Hydrating", "price": 950 },
  { "name": "Manicure - French", "price": 500 },
  { "name": "Pedicure - Spa", "price": 700 },
  { "name": "Waxing - Bikini", "price": 850 },
  { "name": "Waxing - Underarms", "price": 250 },
  { "name": "Threading - Chin", "price": 60 },
  { "name": "Threading - Forehead", "price": 70 },
  { "name": "Hair Coloring - Root Touch-Up", "price": 900 },
  { "name": "Hair Coloring - Balayage", "price": 2800 },
  { "name": "Hair Coloring - Ombre", "price": 2600 },
  { "name": "Hair Treatment - Dandruff", "price": 750 },
  { "name": "Hair Treatment - Hair Fall", "price": 850 },
  { "name": "Hair Treatment - Scalp Detox", "price": 950 },
  { "name": "Body Polish", "price": 1300 },
  { "name": "Body Wrap", "price": 1600 },
  { "name": "Back Facial", "price": 1000 },
  { "name": "Foot Massage", "price": 500 },
  { "name": "Hand Massage", "price": 400 },
  { "name": "Makeup - Party", "price": 3000 },
  { "name": "Makeup - Day", "price": 2500 },
  { "name": "Makeup - Night", "price": 2800 },
  { "name": "Hair Cut - Layered", "price": 450 },
  { "name": "Hair Cut - Feather", "price": 400 },
  { "name": "Hair Cut - Bob", "price": 350 },
  { "name": "Hair Cut - Pixie", "price": 300 },
  { "name": "Hair Cut - Undercut", "price": 500 },
  { "name": "Hair Cut - Fade", "price": 400 },
  { "name": "Hair Cut - Crew", "price": 350 },
  { "name": "Hair Cut - Taper", "price": 300 },
  { "name": "Hair Cut - Fringe", "price": 320 },
  { "name": "Hair Cut - Asymmetrical", "price": 480 },
  { "name": "Hair Cut - Razor", "price": 420 },
  { "name": "Hair Cut - Shag", "price": 390 },
  { "name": "Hair Cut - Mullet", "price": 370 },
  { "name": "Hair Cut - Buzz", "price": 280 },


  { "name": "Hair Spa - Anti-Dandruff", "price": 850 },
  { "name": "Hair Spa - Repair & Restore", "price": 900 },
  { "name": "Hair Spa - Color Protection", "price": 950 },
  { "name": "Facial - Pearl Glow", "price": 1000 },
  { "name": "Facial - Diamond Shine", "price": 1300 },
  { "name": "Facial - Oxygen Boost", "price": 1150 },
  { "name": "Manicure - Spa", "price": 650 },
  { "name": "Manicure - Gel Polish", "price": 700 },
  { "name": "Pedicure - French", "price": 750 },
  { "name": "Pedicure - Paraffin", "price": 850 },
  { "name": "Waxing - Half Arms", "price": 300 },
  { "name": "Waxing - Half Legs", "price": 350 },
  { "name": "Waxing - Face", "price": 400 },
  { "name": "Threading - Full Face", "price": 200 },
  { "name": "Threading - Sideburns", "price": 90 },
  { "name": "Hair Coloring - Crown Highlights", "price": 2400 },
  { "name": "Hair Coloring - Peekaboo Highlights", "price": 2300 },
  { "name": "Hair Coloring - Money Piece", "price": 2100 },
  { "name": "Hair Treatment - Split Ends", "price": 700 },
  { "name": "Hair Treatment - Volume Boost", "price": 950 },
  { "name": "Hair Treatment - Shine Therapy", "price": 1000 },
  { "name": "Body Massage - Deep Tissue", "price": 1800 },
  { "name": "Body Massage - Aromatherapy", "price": 2000 },
  { "name": "Body Massage - Swedish", "price": 1700 },
  { "name": "Body Bleach - Herbal", "price": 750 },
  { "name": "Detan - Full Body", "price": 1200 },
  { "name": "Cleanup - Charcoal", "price": 600 },
  { "name": "Bridal Makeup - Airbrush", "price": 9500 },
  { "name": "Engagement Makeup", "price": 7000 },
  { "name": "Haldi Ceremony Makeup", "price": 4000 },
  { "name": "Nail Art - Glitter", "price": 400 },
  { "name": "Nail Art - 3D", "price": 600 },
  { "name": "Nail Extensions - Acrylic", "price": 1600 },
  { "name": "Eyelash Lift", "price": 1800 },
  { "name": "Eyelash Tint", "price": 1000 },
  { "name": "Hair Wash - Herbal", "price": 300 },
  { "name": "Hair Styling - Braids", "price": 550 },
  { "name": "Hair Styling - Updo", "price": 700 },
  { "name": "Hair Cut - V-Cut", "price": 420 },
  { "name": "Hair Cut - U-Cut", "price": 400 },
  { "name": "Hair Cut - Step Cut", "price": 430 },
  { "name": "Hair Cut - Graduated Bob", "price": 380 },
  { "name": "Hair Cut - Long Bob", "price": 390 },
  { "name": "Hair Cut - Blunt Cut", "price": 360 },
  { "name": "Hair Cut - Curly Layers", "price": 470 },
  { "name": "Hair Cut - Taper Fade", "price": 320 },
  { "name": "Hair Cut - Skin Fade", "price": 340 },
  { "name": "Hair Cut - Mohawk", "price": 500 },
  { "name": "Hair Cut - Faux Hawk", "price": 480 },
  { "name": "Hair Cut - Caesar", "price": 310 },
  { "name": "Hair Cut - Ivy League", "price": 330 },
  { "name": "Hair Cut - Flat Top", "price": 350 },
  { "name": "Hair Cut - Hard Part", "price": 370 },
  { "name": "Hair Cut - Comb Over", "price": 390 },
  { "name": "Hair Cut - Slick Back", "price": 410 },
  { "name": "Hair Cut - Pompadour", "price": 430 },
  { "name": "Hair Cut - Quiff", "price": 450 },
  { "name": "Hair Cut - Spiky", "price": 400 },
  { "name": "Hair Cut - Side Part", "price": 380 },
  { "name": "Hair Cut - Messy", "price": 360 },
  { "name": "Hair Cut - Textured", "price": 440 },
  { "name": "Hair Cut - Layered Bob", "price": 420 },
  { "name": "Hair Cut - Inverted Bob", "price": 410 },
  { "name": "Hair Cut - A-Line Bob", "price": 430 },
  { "name": "Hair Cut - Wavy Lob", "price": 450 },
  { "name": "Hair Cut - Tousled Layers", "price": 470 },
  { "name": "Hair Cut - Choppy Cut", "price": 490 },
  { "name": "Hair Cut - Long Shag", "price": 510 },
  { "name": "Hair Cut - Curtain Bangs", "price": 530 },
  { "name": "Hair Cut - Wispy Bangs", "price": 550 },


  { "name": "Hair Spa - Moroccan Oil", "price": 1000 },
  { "name": "Hair Spa - Kerastase Ritual", "price": 1200 },
  { "name": "Hair Spa - Anti-Frizz", "price": 950 },
  { "name": "Facial - Vitamin C Boost", "price": 1250 },
  { "name": "Facial - Collagen Repair", "price": 1400 },
  { "name": "Facial - Seaweed Detox", "price": 1350 },
  { "name": "Manicure - Paraffin", "price": 750 },
  { "name": "Manicure - Organic", "price": 800 },
  { "name": "Pedicure - Organic", "price": 850 },
  { "name": "Pedicure - Crystal Spa", "price": 900 },
  { "name": "Waxing - Brazilian", "price": 950 },
  { "name": "Waxing - Hollywood", "price": 1000 },
  { "name": "Waxing - Chest", "price": 500 },
  { "name": "Threading - Neck", "price": 100 },
  { "name": "Threading - Nose", "price": 80 },
  { "name": "Hair Coloring - Foil Highlights", "price": 2700 },
  { "name": "Hair Coloring - Lowlights", "price": 2500 },
  { "name": "Hair Coloring - Color Melt", "price": 2900 },
  { "name": "Hair Treatment - Protein Boost", "price": 1100 },
  { "name": "Hair Treatment - Bond Repair", "price": 1300 },
  { "name": "Hair Treatment - Hydration Therapy", "price": 1200 },
  { "name": "Body Massage - Hot Stone", "price": 2200 },
  { "name": "Body Massage - Thai", "price": 2000 },
  { "name": "Body Massage - Balinese", "price": 2100 },
  { "name": "Body Bleach - Gold", "price": 800 },
  { "name": "Detan - Back", "price": 700 },
  { "name": "Cleanup - Vitamin E", "price": 650 },
  { "name": "Bridal Makeup - Traditional", "price": 9000 },
  { "name": "Mehendi Application - Bridal", "price": 3500 },
  { "name": "Mehendi Application - Simple", "price": 800 },
  { "name": "Nail Art - Chrome", "price": 500 },
  { "name": "Nail Art - Matte Finish", "price": 450 },
  { "name": "Nail Extensions - Fiberglass", "price": 1900 },
  { "name": "Eyelash Perming", "price": 1600 },
  { "name": "Eyelash Volumizing", "price": 2700 },
  { "name": "Hair Wash - Volumizing", "price": 350 },
  { "name": "Hair Styling - Retro Waves", "price": 750 },
  { "name": "Hair Styling - Messy Bun", "price": 600 },
  { "name": "Hair Cut - Spiral Layers", "price": 460 },
  { "name": "Hair Cut - Tucked Bob", "price": 400 },
  { "name": "Hair Cut - Long Layers", "price": 480 },
  { "name": "Hair Cut - Shoulder Shag", "price": 420 },
  { "name": "Hair Cut - Textured Lob", "price": 440 },
  { "name": "Hair Cut - Cropped Pixie", "price": 390 },
  { "name": "Hair Cut - Tapered Bob", "price": 410 },
  { "name": "Hair Cut - Layered Bangs", "price": 430 },
  { "name": "Hair Cut - Tousled Bob", "price": 450 },
  { "name": "Hair Cut - Slick Pixie", "price": 370 },
  { "name": "Hair Cut - Modern Mullet", "price": 390 },
  { "name": "Hair Cut - Shattered Layers", "price": 470 },
  { "name": "Hair Cut - Sculpted Fade", "price": 350 },
  { "name": "Hair Cut - Burst Fade", "price": 360 },
  { "name": "Hair Cut - Drop Fade", "price": 340 },
  { "name": "Hair Cut - Temple Fade", "price": 330 },
  { "name": "Hair Cut - Shadow Fade", "price": 320 },
  { "name": "Hair Cut - High Top Fade", "price": 370 },
  { "name": "Hair Cut - French Crop", "price": 310 },
  { "name": "Hair Cut - Brush Up", "price": 300 },
  { "name": "Hair Cut - Blowout", "price": 380 },
  { "name": "Hair Cut - Fringe Fade", "price": 400 },
  { "name": "Hair Cut - Burst Mohawk", "price": 420 },
  { "name": "Hair Cut - Taper Mohawk", "price": 430 },
  { "name": "Hair Cut - Undercut Quiff", "price": 440 },
  { "name": "Hair Cut - Razor Fade", "price": 450 },
  { "name": "Hair Cut - Side Swept", "price": 460 },
  { "name": "Hair Cut - Angular Fringe", "price": 470 },
  { "name": "Hair Cut - Layered Undercut", "price": 480 },
  { "name": "Hair Cut - Textured Crop", "price": 490 },
  { "name": "Hair Cut - Disconnected Undercut", "price": 500 },



  { "name": "Hair Spa - Green Tea Therapy", "price": 1050 },
  { "name": "Hair Spa - Aloe Vera Hydration", "price": 980 },
  { "name": "Hair Spa - Cysteine Infusion", "price": 1150 },
  { "name": "Facial - Papaya Enzyme", "price": 950 },
  { "name": "Facial - Coffee Detox", "price": 1100 },
  { "name": "Facial - Saffron Brightening", "price": 1250 },
  { "name": "Manicure - Chocolate Indulgence", "price": 850 },
  { "name": "Manicure - Wine Therapy", "price": 900 },
  { "name": "Pedicure - Mint Cool", "price": 950 },
  { "name": "Pedicure - Rose Petal Spa", "price": 1000 },
  { "name": "Waxing - Stomach", "price": 600 },
  { "name": "Waxing - Back", "price": 700 },
  { "name": "Waxing - Full Face", "price": 500 },
  { "name": "Threading - Ears", "price": 70 },
  { "name": "Threading - Jawline", "price": 90 },
  { "name": "Hair Coloring - Rainbow Streaks", "price": 3000 },
  { "name": "Hair Coloring - Pastel Ombre", "price": 3200 },
  { "name": "Hair Coloring - Sunset Blend", "price": 3100 },
  { "name": "Hair Treatment - Collagen Boost", "price": 1400 },
  { "name": "Hair Treatment - Stem Cell Therapy", "price": 1500 },
  { "name": "Hair Treatment - Anti-Grey", "price": 1350 },
  { "name": "Body Massage - Bamboo Therapy", "price": 2300 },
  { "name": "Body Massage - Lomi Lomi", "price": 2400 },
  { "name": "Body Massage - Reflexology", "price": 1900 },
  { "name": "Body Bleach - Diamond", "price": 850 },
  { "name": "Detan - Arms", "price": 600 },
  { "name": "Cleanup - Aloe Vera", "price": 700 },
  { "name": "Bridal Makeup - Contemporary", "price": 9200 },
  { "name": "Reception Makeup - Glitter Glam", "price": 6800 },
  { "name": "Sangeet Makeup", "price": 6200 },
  { "name": "Nail Art - Foil", "price": 550 },
  { "name": "Nail Art - Floral", "price": 600 },
  { "name": "Nail Extensions - Hybrid", "price": 2000 },
  { "name": "Eyelash - Hybrid Extensions", "price": 2800 },
  { "name": "Eyelash - Russian Volume", "price": 3000 },
  { "name": "Hair Wash - Anti-Frizz", "price": 400 },
  { "name": "Hair Styling - Fishtail Braid", "price": 650 },
  { "name": "Hair Styling - Sleek Ponytail", "price": 600 },
  { "name": "Hair Cut - Layered Lob", "price": 460 },
  { "name": "Hair Cut - Textured Shag", "price": 480 },
  { "name": "Hair Cut - Razor Bob", "price": 420 },
  { "name": "Hair Cut - Tousled Pixie", "price": 400 },
  { "name": "Hair Cut - Long Fringe", "price": 430 },
  { "name": "Hair Cut - Sculpted Bob", "price": 450 },
  { "name": "Hair Cut - Classic Taper", "price": 370 },
  { "name": "Hair Cut - Mid Fade", "price": 360 },
  { "name": "Hair Cut - Low Fade", "price": 350 },
  { "name": "Hair Cut - Drop Mohawk", "price": 390 },
  { "name": "Hair Cut - Curly Fade", "price": 400 },
  { "name": "Hair Cut - Side Fade", "price": 410 },
  { "name": "Hair Cut - Undercut Fade", "price": 420 },
  { "name": "Hair Cut - Layered Fade", "price": 430 },
  { "name": "Hair Cut - Textured Fade", "price": 440 },
  { "name": "Hair Cut - Classic Crew", "price": 350 },
  { "name": "Hair Cut - Ivy Fade", "price": 360 },
  { "name": "Hair Cut - Brushed Quiff", "price": 470 },
  { "name": "Hair Cut - Side Swept Undercut", "price": 480 },
  { "name": "Hair Cut - Angular Bob", "price": 490 },
  { "name": "Hair Cut - Choppy Lob", "price": 500 },
  { "name": "Hair Cut - Feathered Layers", "price": 510 },
  { "name": "Hair Cut - Wispy Shag", "price": 520 },
  { "name": "Hair Cut - Blunt Fringe", "price": 530 },
  { "name": "Hair Cut - Curtain Layers", "price": 540 },
  { "name": "Hair Cut - Sculpted Pixie", "price": 550 },
  { "name": "Hair Cut - Tousled Fringe", "price": 560 },
  { "name": "Hair Cut - Sleek Lob", "price": 570 },
  { "name": "Hair Cut - Voluminous Bob", "price": 580 },
  { "name": "Hair Cut - Layered Curls", "price": 590 },
  { "name": "Hair Cut - Textured Waves", "price": 600 },

    

                  ],
                  "Photographers & Videographers ": [

      { "name": "Wedding Photography - Candid", "price": 25000 },
  { "name": "Wedding Videography - Cinematic", "price": 30000 },
  { "name": "Pre-Wedding Shoot - Outdoor", "price": 18000 },
  { "name": "Engagement Photography", "price": 15000 },
  { "name": "Haldi Ceremony Coverage", "price": 12000 },
  { "name": "Sangeet Videography", "price": 16000 },
  { "name": "Reception Photography", "price": 20000 },
  { "name": "Drone Coverage - Wedding", "price": 10000 },
  { "name": "Live Streaming - Event", "price": 8000 },
  { "name": "Corporate Event Photography", "price": 22000 },
  { "name": "Corporate Event Videography", "price": 25000 },
  { "name": "Product Launch Coverage", "price": 20000 },
  { "name": "Conference Photography", "price": 18000 },
  { "name": "Seminar Videography", "price": 17000 },
  { "name": "Award Ceremony Coverage", "price": 21000 },
  { "name": "Birthday Party Photography", "price": 12000 },
  { "name": "Birthday Party Videography", "price": 14000 },
  { "name": "Baby Shower Shoot", "price": 10000 },
  { "name": "Maternity Shoot - Indoor", "price": 13000 },
  { "name": "Maternity Shoot - Outdoor", "price": 15000 },
  { "name": "Newborn Photography", "price": 16000 },
  { "name": "Family Portrait Session", "price": 9000 },
  { "name": "Couple Shoot - Studio", "price": 11000 },
  { "name": "Couple Shoot - Destination", "price": 20000 },
  { "name": "Fashion Photography - Editorial", "price": 25000 },
  { "name": "Fashion Videography - Runway", "price": 28000 },
  { "name": "Portfolio Shoot - Model", "price": 15000 },
  { "name": "Portfolio Shoot - Actor", "price": 18000 },
  { "name": "Music Video Production", "price": 35000 },
  { "name": "Dance Performance Coverage", "price": 16000 },
  { "name": "School Annual Day Photography", "price": 14000 },
  { "name": "College Fest Videography", "price": 18000 },
  { "name": "Graduation Ceremony Coverage", "price": 17000 },
  { "name": "Documentary Filming", "price": 40000 },
  { "name": "Short Film Production", "price": 45000 },
  { "name": "Ad Film Shoot", "price": 50000 },
  { "name": "Brand Promo Video", "price": 30000 },
  { "name": "Real Estate Photography", "price": 20000 },
  { "name": "Real Estate Videography", "price": 22000 },
  { "name": "Interior Shoot - Residential", "price": 18000 },
  { "name": "Interior Shoot - Commercial", "price": 20000 },
  { "name": "Food Photography", "price": 15000 },
  { "name": "Restaurant Promo Video", "price": 25000 },
  { "name": "Product Photography - E-commerce", "price": 12000 },
  { "name": "Product Videography - Demo", "price": 18000 },
  { "name": "Jewelry Shoot", "price": 16000 },
  { "name": "Makeup Artist Portfolio Shoot", "price": 14000 },
  { "name": "Fitness Shoot - Gym", "price": 13000 },
  { "name": "Fitness Shoot - Outdoor", "price": 15000 },
  { "name": "Pet Photography", "price": 10000 },
  { "name": "Pet Video Shoot", "price": 12000 },
  { "name": "Drone Aerial Photography", "price": 10000 },
  { "name": "Drone Aerial Videography", "price": 12000 },
  { "name": "360° Virtual Tour - Property", "price": 25000 },
  { "name": "360° Virtual Tour - Venue", "price": 27000 },
  { "name": "Time-lapse Video Production", "price": 22000 },
  { "name": "Slow Motion Video Shoot", "price": 20000 },
  { "name": "Green Screen Shoot", "price": 18000 },
  { "name": "Studio Rental - Photography", "price": 8000 },
  { "name": "Studio Rental - Videography", "price": 10000 },
  { "name": "Video Editing - Basic", "price": 5000 },
  { "name": "Video Editing - Advanced", "price": 10000 },
  { "name": "Photo Editing - Basic", "price": 3000 },
  { "name": "Photo Editing - High-End", "price": 7000 },
  { "name": "Motion Graphics - Intro", "price": 8000 },
  { "name": "Motion Graphics - Explainer", "price": 12000 },
  { "name": "Voice Over Recording", "price": 6000 },
  { "name": "Subtitling & Captioning", "price": 4000 },
  { "name": "Color Grading - Video", "price": 9000 },
  { "name": "Sound Design - Event Video", "price": 10000 },
  { "name": "Highlight Reel Creation", "price": 7000 },
  { "name": "Teaser Video Production", "price": 8000 },


  { "name": "Wedding Photography - Traditional", "price": 22000 },
  { "name": "Wedding Videography - Documentary Style", "price": 28000 },
  { "name": "Pre-Wedding Shoot - Studio", "price": 15000 },
  { "name": "Engagement Videography", "price": 17000 },
  { "name": "Haldi Ceremony Photography", "price": 10000 },
  { "name": "Sangeet Photography", "price": 14000 },
  { "name": "Reception Videography", "price": 22000 },
  { "name": "Drone Coverage - Pre-Wedding", "price": 9000 },
  { "name": "Live Streaming - Wedding", "price": 8500 },
  { "name": "Corporate Headshot Photography", "price": 6000 },
  { "name": "Corporate Interview Videography", "price": 12000 },
  { "name": "Product Demo Video", "price": 20000 },
  { "name": "Conference Videography", "price": 19000 },
  { "name": "Seminar Photography", "price": 16000 },
  { "name": "Award Ceremony Videography", "price": 23000 },
  { "name": "Birthday Party Candid Photography", "price": 13000 },
  { "name": "Birthday Party Highlight Video", "price": 15000 },
  { "name": "Baby Shower Videography", "price": 11000 },
  { "name": "Maternity Video Shoot", "price": 14000 },
  { "name": "Newborn Videography", "price": 17000 },
  { "name": "Family Video Portrait", "price": 10000 },
  { "name": "Couple Shoot - Beach", "price": 16000 },
  { "name": "Couple Shoot - Mountain", "price": 18000 },
  { "name": "Fashion Photography - Catalog", "price": 22000 },
  { "name": "Fashion Videography - Behind the Scenes", "price": 26000 },
  { "name": "Portfolio Shoot - Dancer", "price": 14000 },
  { "name": "Portfolio Shoot - Influencer", "price": 16000 },
  { "name": "Music Video Editing", "price": 12000 },
  { "name": "Dance Video Editing", "price": 10000 },
  { "name": "School Annual Day Videography", "price": 15000 },
  { "name": "College Fest Photography", "price": 17000 },
  { "name": "Graduation Ceremony Videography", "price": 18000 },
  { "name": "Documentary Editing", "price": 20000 },
  { "name": "Short Film Editing", "price": 22000 },
  { "name": "Ad Film Editing", "price": 25000 },
  { "name": "Brand Promo Editing", "price": 18000 },
  { "name": "Real Estate Video Editing", "price": 15000 },
  { "name": "Interior Video Editing", "price": 14000 },
  { "name": "Food Video Shoot", "price": 17000 },
  { "name": "Restaurant Photography", "price": 16000 },
  { "name": "Product Photography - Lifestyle", "price": 14000 },
  { "name": "Product Videography - Social Media", "price": 16000 },
  { "name": "Jewelry Video Shoot", "price": 18000 },
  { "name": "Makeup Artist Video Portfolio", "price": 15000 },
  { "name": "Fitness Video - Gym Workout", "price": 14000 },
  { "name": "Fitness Video - Yoga Session", "price": 16000 },
  { "name": "Pet Video Editing", "price": 9000 },
  { "name": "Pet Photography - Studio", "price": 11000 },
  { "name": "Drone Coverage - Corporate Event", "price": 9500 },
  { "name": "Drone Coverage - Real Estate", "price": 10500 },
  { "name": "360° Virtual Tour - Hotel", "price": 28000 },
  { "name": "360° Virtual Tour - School", "price": 26000 },
  { "name": "Time-lapse Photography", "price": 20000 },
  { "name": "Slow Motion Editing", "price": 15000 },
  { "name": "Green Screen Editing", "price": 13000 },
  { "name": "Studio Rental - Green Screen", "price": 9000 },
  { "name": "Studio Rental - Podcast Setup", "price": 11000 },
  { "name": "Video Editing - Wedding Highlights", "price": 8000 },
  { "name": "Video Editing - Corporate Promo", "price": 12000 },
  { "name": "Photo Editing - Fashion", "price": 6000 },
  { "name": "Photo Editing - Product", "price": 5000 },
  { "name": "Motion Graphics - Branding", "price": 10000 },
  { "name": "Motion Graphics - Event Intro", "price": 9000 },
  { "name": "Voice Over - Corporate Video", "price": 7000 },
  { "name": "Voice Over - Documentary", "price": 8000 },
  { "name": "Subtitling - Multilingual", "price": 6000 },
  { "name": "Captioning - Social Media", "price": 4000 },
  { "name": "Color Grading - Fashion Film", "price": 10000 },
  { "name": "Sound Design - Music Video", "price": 12000 },
  { "name": "Highlight Reel - Corporate Event", "price": 9000 },
  { "name": "Teaser Video - Product Launch", "price": 10000 },



  { "name": "Wedding Photography - Destination", "price": 35000 },
  { "name": "Wedding Videography - Traditional", "price": 32000 },
  { "name": "Pre-Wedding Shoot - Heritage Location", "price": 20000 },
  { "name": "Engagement Shoot - Drone Combo", "price": 18000 },
  { "name": "Haldi Ceremony - Highlight Reel", "price": 14000 },
  { "name": "Sangeet - Multi-Cam Setup", "price": 20000 },
  { "name": "Reception - Cinematic Trailer", "price": 24000 },
  { "name": "Drone Coverage - Reception", "price": 9500 },
  { "name": "Live Streaming - Multi-Platform", "price": 10000 },
  { "name": "Corporate Training Video", "price": 22000 },
  { "name": "Corporate Branding Shoot", "price": 18000 },
  { "name": "Product Launch - Teaser Video", "price": 25000 },
  { "name": "Conference - Panel Highlights", "price": 20000 },
  { "name": "Seminar - Speaker Portraits", "price": 15000 },
  { "name": "Award Ceremony - Red Carpet Coverage", "price": 23000 },
  { "name": "Birthday Party - Instant Prints", "price": 12000 },
  { "name": "Birthday Party - Slow Motion Booth", "price": 16000 },
  { "name": "Baby Shower - Cinematic Edit", "price": 13000 },
  { "name": "Maternity Shoot - Water Theme", "price": 17000 },
  { "name": "Newborn - Lifestyle Session", "price": 15000 },
  { "name": "Family Shoot - Outdoor Park", "price": 11000 },
  { "name": "Couple Shoot - Vintage Theme", "price": 14000 },
  { "name": "Couple Shoot - Rainy Day Concept", "price": 16000 },
  { "name": "Fashion Photography - Street Style", "price": 20000 },
  { "name": "Fashion Videography - BTS", "price": 22000 },
  { "name": "Portfolio Shoot - Fitness Model", "price": 17000 },
  { "name": "Portfolio Shoot - Artist", "price": 15000 },
  { "name": "Music Video - Lyric Overlay", "price": 28000 },
  { "name": "Dance Video - Choreography Focus", "price": 20000 },
  { "name": "School Event - Group Portraits", "price": 13000 },
  { "name": "College Fest - Drone Highlights", "price": 19000 },
  { "name": "Graduation - Cap Toss Slow Motion", "price": 16000 },
  { "name": "Documentary - Voiceover Integration", "price": 30000 },
  { "name": "Short Film - Scripted Shoot", "price": 35000 },
  { "name": "Ad Film - Influencer Collab", "price": 40000 },
  { "name": "Brand Promo - Animated Intro", "price": 22000 },
  { "name": "Real Estate - Twilight Shoot", "price": 18000 },
  { "name": "Real Estate - Walkthrough Video", "price": 20000 },
  { "name": "Interior - Mood Lighting Capture", "price": 17000 },
  { "name": "Interior - Drone Flythrough", "price": 19000 },
  { "name": "Food Photography - Styled Setup", "price": 16000 },
  { "name": "Restaurant - Chef Interview Video", "price": 21000 },
  { "name": "Product Photography - Macro Focus", "price": 13000 },
  { "name": "Product Videography - 360 Spin", "price": 17000 },
  { "name": "Jewelry - Sparkle Enhancement", "price": 19000 },
  { "name": "Makeup Artist - Behind the Scenes", "price": 15000 },
  { "name": "Fitness - Transformation Video", "price": 18000 },
  { "name": "Fitness - Outdoor Challenge Shoot", "price": 16000 },
  { "name": "Pet - Action Shots", "price": 12000 },
  { "name": "Pet - Owner Interaction Video", "price": 14000 },
  { "name": "Drone - Sunset Aerials", "price": 11000 },
  { "name": "Drone - Crowd Coverage", "price": 12000 },
  { "name": "360° Tour - Wedding Venue", "price": 29000 },
  { "name": "360° Tour - Office Space", "price": 27000 },
  { "name": "Time-lapse - Setup to Event", "price": 24000 },
  { "name": "Slow Motion - Dance Highlights", "price": 18000 },
  { "name": "Green Screen - Interactive Booth", "price": 15000 },
  { "name": "Studio Rental - Fashion Setup", "price": 12000 },
  { "name": "Studio Rental - Interview Setup", "price": 13000 },
  { "name": "Video Editing - Music Sync", "price": 9000 },
  { "name": "Video Editing - Transitions & Effects", "price": 11000 },
  { "name": "Photo Editing - Background Blur", "price": 4000 },
  { "name": "Photo Editing - Color Pop", "price": 5000 },
  { "name": "Motion Graphics - Logo Reveal", "price": 10000 },
  { "name": "Motion Graphics - Lower Thirds", "price": 7000 },
  { "name": "Voice Over - Event Highlights", "price": 6000 },
  { "name": "Voice Over - Brand Story", "price": 8000 },
  { "name": "Subtitling - Wedding Film", "price": 5000 },
  { "name": "Captioning - Instagram Reels", "price": 3000 },
  { "name": "Color Grading - Cinematic Look", "price": 11000 },
  { "name": "Sound Design - Corporate Film", "price": 13000 },
  { "name": "Highlight Reel - Fashion Show", "price": 10000 },
  { "name": "Teaser Video - Engagement", "price": 9000 },


  { "name": "Wedding Photography - Black & White Theme", "price": 26000 },
  { "name": "Wedding Videography - Highlights Only", "price": 28000 },
  { "name": "Pre-Wedding Shoot - Vintage Car Setup", "price": 22000 },
  { "name": "Engagement Shoot - Floral Backdrop", "price": 17000 },
  { "name": "Haldi Ceremony - Drone Combo", "price": 15000 },
  { "name": "Sangeet - Live Performance Coverage", "price": 21000 },
  { "name": "Reception - Couple Entry Highlights", "price": 23000 },
  { "name": "Drone Coverage - Haldi Ceremony", "price": 9000 },
  { "name": "Live Streaming - YouTube & Facebook", "price": 9500 },
  { "name": "Corporate Event - Panel Discussion Highlights", "price": 19000 },
  { "name": "Corporate Event - Networking Moments", "price": 17000 },
  { "name": "Product Launch - Crowd Reactions", "price": 20000 },
  { "name": "Conference - Speaker Close-Ups", "price": 18000 },
  { "name": "Seminar - Audience Engagement Shots", "price": 16000 },
  { "name": "Award Ceremony - Trophy Presentation", "price": 22000 },
  { "name": "Birthday Party - Balloon Decor Focus", "price": 13000 },
  { "name": "Birthday Party - Cake Cutting Slow Motion", "price": 15000 },
  { "name": "Baby Shower - Family Portraits", "price": 12000 },
  { "name": "Maternity Shoot - Floral Theme", "price": 16000 },
  { "name": "Newborn - Props & Setup", "price": 14000 },
  { "name": "Family Shoot - Indoor Studio", "price": 10000 },
  { "name": "Couple Shoot - Sunset Beach", "price": 17000 },
  { "name": "Couple Shoot - Forest Trail", "price": 18000 },
  { "name": "Fashion Photography - Monochrome Editorial", "price": 23000 },
  { "name": "Fashion Videography - Model Walks", "price": 25000 },
  { "name": "Portfolio Shoot - Actor Headshots", "price": 16000 },
  { "name": "Portfolio Shoot - Creative Concepts", "price": 18000 },
  { "name": "Music Video - Studio Performance", "price": 30000 },
  { "name": "Dance Video - Stage Lighting Effects", "price": 22000 },
  { "name": "School Event - Award Distribution", "price": 14000 },
  { "name": "College Fest - Crowd Interaction", "price": 16000 },
  { "name": "Graduation - Group Photo Montage", "price": 15000 },
  { "name": "Documentary - Interview Series", "price": 32000 },
  { "name": "Short Film - Location Shoot", "price": 37000 },
  { "name": "Ad Film - Product Focus", "price": 42000 },
  { "name": "Brand Promo - Customer Testimonials", "price": 20000 },
  { "name": "Real Estate - Interior Details", "price": 17000 },
  { "name": "Real Estate - Exterior Drone Sweep", "price": 19000 },
  { "name": "Interior - Furniture Highlights", "price": 16000 },
  { "name": "Interior - Lighting Showcase", "price": 18000 },
  { "name": "Food Photography - Ingredient Focus", "price": 15000 },
  { "name": "Restaurant - Ambience Video", "price": 20000 },
  { "name": "Product Photography - Flat Lay", "price": 12000 },
  { "name": "Product Videography - Assembly Process", "price": 16000 },
  { "name": "Jewelry - Close-Up Detailing", "price": 17000 },
  { "name": "Makeup Artist - Transformation Video", "price": 14000 },
  { "name": "Fitness - Personal Trainer Promo", "price": 15000 },
  { "name": "Fitness - Group Workout Coverage", "price": 17000 },
  { "name": "Pet - Grooming Session Shoot", "price": 11000 },
  { "name": "Pet - Playtime Highlights", "price": 13000 },
  { "name": "Drone - Crowd Panoramic", "price": 10000 },
  { "name": "Drone - Venue Flyover", "price": 11000 },
  { "name": "360° Tour - Art Gallery", "price": 26000 },
  { "name": "360° Tour - Fitness Studio", "price": 25000 },
  { "name": "Time-lapse - Construction Progress", "price": 23000 },
  { "name": "Slow Motion - Entry Walks", "price": 17000 },
  { "name": "Green Screen - Product Demo", "price": 14000 },
  { "name": "Studio Rental - Product Setup", "price": 10000 },
  { "name": "Studio Rental - Lifestyle Setup", "price": 11000 },
  { "name": "Video Editing - Voice Sync", "price": 8000 },
  { "name": "Video Editing - Color Correction", "price": 9000 },
  { "name": "Photo Editing - Skin Retouch", "price": 6000 },
  { "name": "Photo Editing - Object Removal", "price": 5000 },
  { "name": "Motion Graphics - Event Countdown", "price": 9000 },
  { "name": "Motion Graphics - Social Media Templates", "price": 7000 },
  { "name": "Voice Over - Explainer Video", "price": 7500 },
  { "name": "Voice Over - Promo Trailer", "price": 8500 },
  { "name": "Subtitling - Corporate Film", "price": 5500 },
  { "name": "Captioning - YouTube Shorts", "price": 3500 },
  { "name": "Color Grading - Wedding Film", "price": 10000 },
  { "name": "Sound Design - Short Film", "price": 12000 },
  { "name": "Highlight Reel - Birthday Bash", "price": 9000 },
  { "name": "Teaser Video - College Fest", "price": 9500 },


                  ],
                  "Legal Consultants": [

      { "name": "Contract Drafting - Employment Agreement", "price": 5000 },
  { "name": "Contract Drafting - Vendor Agreement", "price": 6000 },
  { "name": "Contract Drafting - Non-Disclosure Agreement (NDA)", "price": 4000 },
  { "name": "Contract Drafting - Service Level Agreement (SLA)", "price": 6500 },
  { "name": "Contract Drafting - Partnership Agreement", "price": 7000 },
  { "name": "Contract Drafting - Franchise Agreement", "price": 8500 },
  { "name": "Contract Drafting - Technology Licensing", "price": 9000 },
  { "name": "Contract Drafting - Software Development Agreement", "price": 7500 },
  { "name": "Contract Drafting - Joint Venture Agreement", "price": 9500 },
  { "name": "Contract Drafting - Shareholder Agreement", "price": 8000 },
  { "name": "Contract Drafting - Investment Agreement", "price": 10000 },
  { "name": "Contract Drafting - Loan Agreement", "price": 5500 },
  { "name": "Contract Drafting - Lease Agreement", "price": 6000 },
  { "name": "Contract Drafting - Licensing Agreement", "price": 7000 },
  { "name": "Contract Drafting - Distribution Agreement", "price": 6500 },
  { "name": "Contract Drafting - Consultancy Agreement", "price": 5000 },
  { "name": "Contract Drafting - Employment Offer Letter", "price": 3500 },
  { "name": "Contract Drafting - Termination Letter", "price": 3000 },
  { "name": "Contract Drafting - Memorandum of Understanding (MoU)", "price": 4500 },
  { "name": "Contract Drafting - Confidentiality Agreement", "price": 4000 },
  { "name": "Contract Drafting - Data Processing Agreement (DPA)", "price": 6000 },
  { "name": "Contract Drafting - Outsourcing Agreement", "price": 7000 },
  { "name": "Contract Drafting - Agency Agreement", "price": 5500 },
  { "name": "Contract Drafting - Commission Agreement", "price": 5000 },
  { "name": "Contract Drafting - Employment Bond", "price": 4500 },
  { "name": "Contract Drafting - Internship Agreement", "price": 3500 },
  { "name": "Contract Drafting - Retainer Agreement", "price": 4000 },
  { "name": "Contract Drafting - Event Management Agreement", "price": 6000 },
  { "name": "Contract Drafting - Sponsorship Agreement", "price": 6500 },
  { "name": "Contract Drafting - Marketing Agreement", "price": 5500 },
  { "name": "Contract Drafting - Advertising Agreement", "price": 5000 },
  { "name": "Contract Drafting - Influencer Agreement", "price": 4800 },
  { "name": "Contract Drafting - Freelance Agreement", "price": 4500 },
  { "name": "Contract Drafting - Content Creation Agreement", "price": 4700 },
  { "name": "Contract Drafting - Website Development Agreement", "price": 6000 },
  { "name": "Contract Drafting - App Development Agreement", "price": 6200 },
  { "name": "Contract Drafting - Cloud Services Agreement", "price": 7000 },
  { "name": "Contract Drafting - Cybersecurity Agreement", "price": 7500 },
  { "name": "Contract Drafting - Intellectual Property Assignment", "price": 8000 },
  { "name": "Contract Drafting - Trademark Licensing", "price": 8500 },
  { "name": "Contract Drafting - Patent Licensing", "price": 9000 },
  { "name": "Contract Drafting - Copyright Licensing", "price": 7000 },
  { "name": "Contract Drafting - Royalty Agreement", "price": 6500 },
  { "name": "Contract Drafting - Publishing Agreement", "price": 6000 },
  { "name": "Contract Drafting - Artist Management Agreement", "price": 5500 },
  { "name": "Contract Drafting - Music Distribution Agreement", "price": 5800 },
  { "name": "Contract Drafting - Film Production Agreement", "price": 9000 },
  { "name": "Contract Drafting - Talent Release Form", "price": 4000 },
  { "name": "Contract Drafting - Model Release Form", "price": 3500 },
  { "name": "Contract Drafting - Photography Agreement", "price": 5000 },
  { "name": "Contract Drafting - Videography Agreement", "price": 5200 },
  { "name": "Contract Drafting - Rental Agreement", "price": 4500 },
  { "name": "Contract Drafting - Equipment Lease Agreement", "price": 4800 },
  { "name": "Contract Drafting - Maintenance Agreement", "price": 5000 },
  { "name": "Contract Drafting - Facility Management Agreement", "price": 5500 },
  { "name": "Contract Drafting - Logistics Agreement", "price": 6000 },
  { "name": "Contract Drafting - Transportation Agreement", "price": 5800 },
  { "name": "Contract Drafting - Warehousing Agreement", "price": 6200 },
  { "name": "Contract Drafting - Supply Chain Agreement", "price": 7000 },
  { "name": "Contract Drafting - Procurement Agreement", "price": 6500 },
  { "name": "Contract Drafting - Sales Agreement", "price": 6000 },
  { "name": "Contract Drafting - Purchase Agreement", "price": 5800 },
  { "name": "Contract Drafting - Reseller Agreement", "price": 6200 },
  { "name": "Contract Drafting - Affiliate Agreement", "price": 5000 },
  { "name": "Contract Drafting - Referral Agreement", "price": 4800 },
  { "name": "Contract Drafting - Commission Sharing Agreement", "price": 5200 },
  { "name": "Contract Drafting - Escrow Agreement", "price": 7000 },
  { "name": "Contract Drafting - Settlement Agreement", "price": 7500 },
  { "name": "Contract Drafting - Arbitration Agreement", "price": 8000 },
  { "name": "Contract Drafting - Mediation Agreement", "price": 6500 },
  { "name": "Contract Drafting - Legal Opinion Letter", "price": 5500 },

  { "name": "Contract Advisory - Mergers & Acquisitions", "price": 12000 },
  { "name": "Contract Advisory - Private Equity", "price": 11000 },
  { "name": "Contract Advisory - Venture Capital", "price": 10000 },
  { "name": "Contract Advisory - Cross-Border Transactions", "price": 13000 },
  { "name": "Contract Advisory - Real Estate Transactions", "price": 9500 },
  { "name": "Contract Advisory - Infrastructure Projects", "price": 12500 },
  { "name": "Contract Advisory - Renewable Energy Projects", "price": 11500 },
  { "name": "Contract Advisory - Telecom Agreements", "price": 10500 },
  { "name": "Contract Advisory - Media & Entertainment", "price": 9800 },
  { "name": "Contract Advisory - Healthcare Compliance", "price": 10200 },
  { "name": "Contract Advisory - Pharma Licensing", "price": 10800 },
  { "name": "Contract Advisory - E-commerce Regulations", "price": 9500 },
  { "name": "Contract Advisory - Fintech Agreements", "price": 9900 },
  { "name": "Contract Advisory - Cryptocurrency Compliance", "price": 12000 },
  { "name": "Contract Advisory - ESG Clauses", "price": 8800 },
  { "name": "Contract Advisory - Anti-Bribery Clauses", "price": 8700 },
  { "name": "Contract Advisory - GDPR Compliance", "price": 9400 },
  { "name": "Contract Advisory - CCPA Compliance", "price": 9200 },
  { "name": "Contract Advisory - Data Sharing Agreements", "price": 8900 },
  { "name": "Contract Advisory - Cloud Hosting Agreements", "price": 9700 },
  { "name": "Contract Advisory - SaaS Agreements", "price": 9800 },
  { "name": "Contract Advisory - PaaS Agreements", "price": 9600 },
  { "name": "Contract Advisory - IT Outsourcing", "price": 9900 },
  { "name": "Contract Advisory - Cybersecurity Clauses", "price": 10100 },
  { "name": "Contract Advisory - Disaster Recovery Agreements", "price": 9500 },
  { "name": "Contract Advisory - Business Continuity Agreements", "price": 9400 },
  { "name": "Contract Advisory - Risk Allocation Clauses", "price": 8800 },
  { "name": "Contract Advisory - Indemnity Clauses", "price": 8700 },
  { "name": "Contract Advisory - Limitation of Liability", "price": 8600 },
  { "name": "Contract Advisory - Force Majeure Clauses", "price": 8500 },
  { "name": "Contract Advisory - Termination Clauses", "price": 8400 },
  { "name": "Contract Advisory - Governing Law Clauses", "price": 8300 },
  { "name": "Contract Advisory - Arbitration Clauses", "price": 8200 },
  { "name": "Contract Advisory - Jurisdiction Clauses", "price": 8100 },
  { "name": "Contract Advisory - Severability Clauses", "price": 8000 },
  { "name": "Contract Advisory - Entire Agreement Clauses", "price": 7900 },
  { "name": "Contract Advisory - Amendment Clauses", "price": 7800 },
  { "name": "Contract Advisory - Assignment Clauses", "price": 7700 },
  { "name": "Contract Advisory - Waiver Clauses", "price": 7600 },
  { "name": "Contract Advisory - Notice Clauses", "price": 7500 },
  { "name": "Contract Advisory - Confidentiality Clauses", "price": 7400 },
  { "name": "Contract Advisory - Non-Compete Clauses", "price": 7300 },
  { "name": "Contract Advisory - Non-Solicitation Clauses", "price": 7200 },
  { "name": "Contract Advisory - Intellectual Property Clauses", "price": 7100 },
  { "name": "Contract Advisory - Licensing Clauses", "price": 7000 },
  { "name": "Contract Advisory - Royalty Clauses", "price": 6900 },
  { "name": "Contract Advisory - Payment Terms", "price": 6800 },
  { "name": "Contract Advisory - Delivery Terms", "price": 6700 },
  { "name": "Contract Advisory - Acceptance Criteria", "price": 6600 },
  { "name": "Contract Advisory - Warranty Clauses", "price": 6500 },
  { "name": "Contract Advisory - Support & Maintenance", "price": 6400 },
  { "name": "Contract Advisory - Service Credits", "price": 6300 },
  { "name": "Contract Advisory - Escalation Matrix", "price": 6200 },
  { "name": "Contract Advisory - Key Performance Indicators", "price": 6100 },
  { "name": "Contract Advisory - Penalty Clauses", "price": 6000 },
  { "name": "Contract Advisory - Liquidated Damages", "price": 5900 },
  { "name": "Contract Advisory - Audit Rights", "price": 5800 },
  { "name": "Contract Advisory - Compliance Clauses", "price": 5700 },
  { "name": "Contract Advisory - Ethics Clauses", "price": 5600 },
  { "name": "Contract Advisory - Diversity Clauses", "price": 5500 },
  { "name": "Contract Advisory - Sustainability Clauses", "price": 5400 },
  { "name": "Contract Advisory - Accessibility Clauses", "price": 5300 },
  { "name": "Contract Advisory - Environmental Clauses", "price": 5200 },
  { "name": "Contract Advisory - Social Responsibility Clauses", "price": 5100 },
  { "name": "Contract Advisory - Governance Clauses", "price": 5000 },
  { "name": "Contract Advisory - Anti-Money Laundering", "price": 4900 },
  { "name": "Contract Advisory - Know Your Customer (KYC)", "price": 4800 },
  { "name": "Contract Advisory - Sanctions Clauses", "price": 4700 },
  { "name": "Contract Advisory - Export Control Clauses", "price": 4600 },
  { "name": "Contract Advisory - Tax Clauses", "price": 4500 },


  { "name": "Contract Drafting - Joint Development Agreement", "price": 9500 },
  { "name": "Contract Drafting - Business Transfer Agreement", "price": 9800 },
  { "name": "Contract Drafting - Sale Deed", "price": 8700 },
  { "name": "Contract Drafting - Gift Deed", "price": 6500 },
  { "name": "Contract Drafting - Power of Attorney", "price": 6000 },
  { "name": "Contract Drafting - Will & Testament", "price": 7000 },
  { "name": "Contract Drafting - Trust Deed", "price": 7500 },
  { "name": "Contract Drafting - Mortgage Agreement", "price": 8000 },
  { "name": "Contract Drafting - Hypothecation Agreement", "price": 7200 },
  { "name": "Contract Drafting - Guarantee Agreement", "price": 6800 },
  { "name": "Contract Drafting - Indemnity Bond", "price": 6200 },
  { "name": "Contract Drafting - Escrow Arrangement", "price": 8500 },
  { "name": "Contract Drafting - Settlement Deed", "price": 7800 },
  { "name": "Contract Drafting - Release Deed", "price": 7400 },
  { "name": "Contract Drafting - Partition Deed", "price": 7600 },
  { "name": "Contract Drafting - Development Agreement", "price": 8800 },
  { "name": "Contract Drafting - Construction Agreement", "price": 9000 },
  { "name": "Contract Drafting - Maintenance Contract", "price": 6700 },
  { "name": "Contract Drafting - Facility Service Agreement", "price": 6900 },
  { "name": "Contract Drafting - Security Services Agreement", "price": 7100 },
  { "name": "Contract Drafting - Catering Agreement", "price": 6400 },
  { "name": "Contract Drafting - Event Planning Agreement", "price": 6600 },
  { "name": "Contract Drafting - Travel Services Agreement", "price": 6300 },
  { "name": "Contract Drafting - Hotel Booking Agreement", "price": 6100 },
  { "name": "Contract Drafting - Tour Operator Agreement", "price": 6000 },
  { "name": "Contract Drafting - Educational Services Agreement", "price": 6200 },
  { "name": "Contract Drafting - Training Services Agreement", "price": 6500 },
  { "name": "Contract Drafting - Coaching Agreement", "price": 5800 },
  { "name": "Contract Drafting - Mentorship Agreement", "price": 5700 },
  { "name": "Contract Drafting - Research Collaboration Agreement", "price": 7300 },
  { "name": "Contract Drafting - Clinical Trial Agreement", "price": 8000 },
  { "name": "Contract Drafting - Hospital Services Agreement", "price": 8500 },
  { "name": "Contract Drafting - Medical Equipment Lease", "price": 7800 },
  { "name": "Contract Drafting - Pharmacy Supply Agreement", "price": 7400 },
  { "name": "Contract Drafting - Ambulance Services Agreement", "price": 7200 },
  { "name": "Contract Drafting - Insurance Policy Agreement", "price": 9000 },
  { "name": "Contract Drafting - Claim Settlement Agreement", "price": 8800 },
  { "name": "Contract Drafting - Reinsurance Agreement", "price": 9500 },
  { "name": "Contract Drafting - Brokerage Agreement", "price": 6700 },
  { "name": "Contract Drafting - Investment Advisory Agreement", "price": 7000 },
  { "name": "Contract Drafting - Wealth Management Agreement", "price": 7300 },
  { "name": "Contract Drafting - Portfolio Management Agreement", "price": 7600 },
  { "name": "Contract Drafting - Mutual Fund Distribution Agreement", "price": 7900 },
  { "name": "Contract Drafting - Stock Broking Agreement", "price": 8200 },
  { "name": "Contract Drafting - Derivatives Trading Agreement", "price": 8500 },
  { "name": "Contract Drafting - Commodity Trading Agreement", "price": 8700 },
  { "name": "Contract Drafting - Forex Trading Agreement", "price": 8900 },
  { "name": "Contract Drafting - Banking Services Agreement", "price": 9100 },
  { "name": "Contract Drafting - Loan Syndication Agreement", "price": 9400 },
  { "name": "Contract Drafting - Credit Facility Agreement", "price": 9600 },
  { "name": "Contract Drafting - Escrow Instructions", "price": 9800 },
  { "name": "Contract Drafting - Promissory Note", "price": 6000 },
  { "name": "Contract Drafting - Bill of Exchange", "price": 6200 },
  { "name": "Contract Drafting - Letter of Credit", "price": 6400 },
  { "name": "Contract Drafting - Bank Guarantee", "price": 6600 },
  { "name": "Contract Drafting - Trade Finance Agreement", "price": 6800 },
  { "name": "Contract Drafting - Export Agreement", "price": 7000 },
  { "name": "Contract Drafting - Import Agreement", "price": 7200 },
  { "name": "Contract Drafting - Customs Clearance Agreement", "price": 7400 },
  { "name": "Contract Drafting - Shipping Agreement", "price": 7600 },
  { "name": "Contract Drafting - Freight Forwarding Agreement", "price": 7800 },
  { "name": "Contract Drafting - Warehousing Services Agreement", "price": 8000 },
  { "name": "Contract Drafting - Logistics Support Agreement", "price": 8200 },
  { "name": "Contract Drafting - Transport Agreement", "price": 8400 },
  { "name": "Contract Drafting - Aviation Services Agreement", "price": 8600 },
  { "name": "Contract Drafting - Maritime Services Agreement", "price": 8800 },
  { "name": "Contract Drafting - Rail Cargo Agreement", "price": 9000 },
  { "name": "Contract Drafting - Courier Services Agreement", "price": 9200 },


  { "name": "Legal Retainer - Monthly Corporate Advisory", "price": 25000 },
  { "name": "Legal Retainer - Startup Package", "price": 15000 },
  { "name": "Legal Retainer - SME Compliance", "price": 18000 },
  { "name": "Legal Retainer - Real Estate Advisory", "price": 22000 },
  { "name": "Legal Retainer - IP Portfolio Management", "price": 27000 },
  { "name": "Legal Retainer - Litigation Support", "price": 30000 },
  { "name": "Legal Retainer - Family Law Advisory", "price": 12000 },
  { "name": "Legal Retainer - Tax Advisory", "price": 20000 },
  { "name": "Legal Retainer - Employment Law", "price": 16000 },
  { "name": "Legal Retainer - Contract Review", "price": 14000 },
  { "name": "Legal Retainer - Regulatory Compliance", "price": 19000 },
  { "name": "Legal Retainer - NGO Legal Support", "price": 10000 },
  { "name": "Legal Retainer - Cyber Law Advisory", "price": 21000 },
  { "name": "Legal Retainer - Banking & Finance", "price": 23000 },
  { "name": "Legal Retainer - Insurance Law", "price": 17000 },
  { "name": "Legal Retainer - Environmental Law", "price": 18000 },
  { "name": "Legal Retainer - Education Sector", "price": 15000 },
  { "name": "Legal Retainer - Healthcare Sector", "price": 20000 },
  { "name": "Legal Retainer - Infrastructure Projects", "price": 28000 },
  { "name": "Legal Retainer - Technology Sector", "price": 24000 },
  { "name": "Legal Retainer - Arbitration Support", "price": 26000 },
  { "name": "Legal Retainer - International Trade", "price": 30000 },
  { "name": "Legal Retainer - Customs & Excise", "price": 22000 },
  { "name": "Legal Retainer - Competition Law", "price": 25000 },
  { "name": "Legal Retainer - M&A Transactions", "price": 32000 },
  { "name": "Legal Retainer - Private Equity", "price": 31000 },
  { "name": "Legal Retainer - Venture Capital", "price": 29000 },
  { "name": "Legal Retainer - Securities Law", "price": 27000 },
  { "name": "Legal Retainer - Insolvency & Bankruptcy", "price": 28000 },
  { "name": "Legal Retainer - White Collar Crimes", "price": 26000 },
  { "name": "Legal Retainer - Anti-Money Laundering", "price": 25000 },
  { "name": "Legal Retainer - Data Protection", "price": 23000 },
  { "name": "Legal Retainer - GDPR Compliance", "price": 24000 },
  { "name": "Legal Retainer - CCPA Compliance", "price": 22000 },
  { "name": "Legal Retainer - Technology Licensing", "price": 21000 },
  { "name": "Legal Retainer - Franchise Law", "price": 20000 },
  { "name": "Legal Retainer - Sports Law", "price": 18000 },
  { "name": "Legal Retainer - Entertainment Law", "price": 19000 },
  { "name": "Legal Retainer - Media Law", "price": 17000 },
  { "name": "Legal Retainer - Aviation Law", "price": 26000 },
  { "name": "Legal Retainer - Maritime Law", "price": 27000 },
  { "name": "Legal Retainer - Immigration Law", "price": 16000 },
  { "name": "Legal Retainer - Human Rights Advisory", "price": 15000 },
  { "name": "Legal Retainer - Constitutional Law", "price": 14000 },
  { "name": "Legal Retainer - Election Law", "price": 13000 },
  { "name": "Legal Retainer - Public Policy Advisory", "price": 12000 },
  { "name": "Legal Retainer - Government Contracts", "price": 25000 },
  { "name": "Legal Retainer - Defence Procurement", "price": 28000 },
  { "name": "Legal Retainer - Municipal Law", "price": 10000 },
  { "name": "Legal Retainer - Urban Development", "price": 11000 },
  { "name": "Legal Retainer - Land Acquisition", "price": 15000 },
  { "name": "Legal Retainer - Property Disputes", "price": 16000 },
  { "name": "Legal Retainer - Succession Planning", "price": 17000 },
  { "name": "Legal Retainer - Estate Planning", "price": 18000 },
  { "name": "Legal Retainer - Trust Management", "price": 19000 },
  { "name": "Legal Retainer - Probate Advisory", "price": 20000 },
  { "name": "Legal Retainer - Guardianship Advisory", "price": 14000 },
  { "name": "Legal Retainer - Adoption Law", "price": 13000 },
  { "name": "Legal Retainer - Domestic Violence Cases", "price": 12000 },
  { "name": "Legal Retainer - Child Custody Advisory", "price": 11000 },
  { "name": "Legal Retainer - Divorce Proceedings", "price": 10000 },
  { "name": "Legal Retainer - Alimony Advisory", "price": 9000 },
  { "name": "Legal Retainer - Civil Litigation", "price": 15000 },
  { "name": "Legal Retainer - Criminal Litigation", "price": 16000 },
  { "name": "Legal Retainer - Bail Applications", "price": 8000 },
  { "name": "Legal Retainer - FIR Advisory", "price": 7000 },
  { "name": "Legal Retainer - Police Complaints", "price": 6000 },
  { "name": "Legal Retainer - Legal Notices", "price": 5000 },
  { "name": "Legal Retainer - Court Appearances", "price": 10000 },


                  ],
                  "Craftspeople & Artisans": [

     { "name": "Sutradhar Sheesham Wood Coffee Table", "price": 7499 },
  { "name": "Kalapuri Handwoven Cotton Dhurrie", "price": 1899 },
  { "name": "Rustic Rasoi Mango Wood Dining Bench", "price": 5999 },
  { "name": "Artisans Crest Brass Nandi Figurine", "price": 1299 },
  { "name": "Channapatna Lacquered Toy Set", "price": 899 },
  { "name": "Kaarigar Copper Water Dispenser", "price": 2199 },
  { "name": "Madhubani Painted Wooden Tray", "price": 799 },
  { "name": "Saanjh Handloom Wool Throw Blanket", "price": 2499 },
  { "name": "Dharohar Handcarved Teak Mirror Frame", "price": 3499 },
  { "name": "Bharat Haat Brass Ganesha Wall Hanging", "price": 1599 },
  { "name": "Kutch Embroidered Cushion Cover Set", "price": 999 },
  { "name": "Sikki Grass Coiled Basket", "price": 499 },
  { "name": "Sanskriti Handmade Terracotta Vase", "price": 699 },
  { "name": "Craftroots Bamboo Pendant Lamp", "price": 1399 },
  { "name": "Gaatha Handpainted Wooden Coasters", "price": 599 },
  { "name": "Industree Natural Jute Storage Bin", "price": 899 },
  { "name": "Tula Organic Cotton Table Runner", "price": 1199 },
  { "name": "Sirohi Upcycled Rope Ottoman", "price": 3499 },
  { "name": "Kashmir Box Walnut Wood Jewelry Box", "price": 1799 },
  { "name": "Porgai Lambadi Embroidered Tote", "price": 1499 },
  { "name": "Kritarth Handmade Ceramic Planter", "price": 799 },
  { "name": "Sambalpuri Ikat Cotton Curtain Panel", "price": 1399 },
  { "name": "Studio Coppre Brass Serving Bowl", "price": 999 },
  { "name": "Thar Artisan Handwoven Wool Rug", "price": 4999 },
  { "name": "Khamir Kala Cotton Bedspread", "price": 2899 },
  { "name": "Kashmir Loom Pashmina Shawl", "price": 6999 },
  { "name": "Varnam Handturned Wooden Lamp Base", "price": 1599 },
  { "name": "Sadhna Appliqué Wall Hanging", "price": 1299 },
  { "name": "Sasha Fair Trade Handloom Napkin Set", "price": 899 },
  { "name": "Kalighat Painted Wooden Panel", "price": 1999 },
  { "name": "Bamboo Pecker Foldable Laptop Table", "price": 2499 },
  { "name": "Kriti Kala Handwoven Sabai Grass Mat", "price": 999 },
  { "name": "Antaran Eri Silk Cushion Cover", "price": 1199 },
  { "name": "Chitrahandicrafts Wooden Spice Box", "price": 799 },
  { "name": "Dastkar Andhra Natural Dyed Tablecloth", "price": 1499 },
  { "name": "Kilmora Woolen Shawl", "price": 1799 },
  { "name": "Sasha Handmade Clay Dinner Plate", "price": 499 },
  { "name": "Sirohi Cane & Cotton Side Table", "price": 3999 },
  { "name": "Gaatha Handpainted Terracotta Diya Set", "price": 599 },
  { "name": "Kaarigar Copper Pitcher", "price": 1299 },
  { "name": "Sutradhar Reclaimed Wood Bookshelf", "price": 8999 },
  { "name": "Craftroots Sabai Grass Laundry Basket", "price": 1499 },
  { "name": "Rustic Rasoi Mango Wood Bar Stool", "price": 3499 },
  { "name": "Studio Coppre Brass Tumbler Set", "price": 1199 },
  { "name": "Porgai Embroidered Wall Art", "price": 999 },
  { "name": "Saanjh Handloom Cotton Quilt", "price": 2999 },
  { "name": "Industree Banana Fiber Table Mat", "price": 699 },
  { "name": "Thar Artisan Woolen Pouf", "price": 2499 },
  { "name": "Kashmir Box Papier-Mâché Vase", "price": 899 },
  { "name": "Sirohi Upcycled Rope Planter Stand", "price": 1799 },
  { "name": "Craftroots Bamboo Fruit Basket", "price": 799 },
  { "name": "Khamir Kala Cotton Cushion Cover", "price": 799 },
  { "name": "Sanskriti Terracotta Hanging Bell", "price": 499 },
  { "name": "Sadhna Appliqué Tote Bag", "price": 1199 },
  { "name": "Kalapuri Handwoven Wool Rug", "price": 3999 },
  { "name": "Channapatna Wooden Napkin Holder", "price": 599 },
  { "name": "Gaatha Handpainted Clay Mug Set", "price": 899 },
  { "name": "Kritarth Ceramic Oil Diffuser", "price": 699 },
  { "name": "Craftroots Sabai Grass Wall Decor", "price": 999 },
  { "name": "Sirohi Cotton Rope Magazine Rack", "price": 1499 },
  { "name": "Studio Coppre Brass Tray", "price": 1399 },
  { "name": "Kaarigar Copper Bottle", "price": 999 },
  { "name": "Sutradhar Sheesham Wood Console Table", "price": 7999 },
  { "name": "Rustic Rasoi Mango Wood Shoe Rack", "price": 4999 },
  { "name": "Industree Jute Hanging Planter", "price": 599 },
  { "name": "Saanjh Handloom Cotton Tablecloth", "price": 1599 },
  { "name": "Kashmir Loom Handwoven Wool Scarf", "price": 2499 },
  { "name": "Porgai Embroidered Cushion Cover", "price": 899 },
  { "name": "Craftroots Bamboo Coaster Set", "price": 499 },
  { "name": "Sasha Handmade Clay Bowl Set", "price": 799 },
  { "name": "Kriti Kala Sabai Grass Wall Basket", "price": 699 },


  { "name": "Artisaga Longpi Pottery Rectangle Platter", "price": 1299 },
  { "name": "Crafts Heaven Bone Inlay Bedside Table", "price": 8499 },
  { "name": "Handkrafted Reclaimed Teak Dining Table", "price": 18999 },
  { "name": "Artisaga Herbal Dyed Cushion Cover", "price": 999 },
  { "name": "Crafts Heaven Horn Napkin Ring Set", "price": 599 },
  { "name": "Handkrafted Walnut Wood Rocking Chair", "price": 9999 },
  { "name": "Artisaga Longpi Pottery Dip Bowl", "price": 699 },
  { "name": "Crafts Heaven Acacia Wood Serving Bowl", "price": 1299 },
  { "name": "Handkrafted Mango Wood Console Table", "price": 7499 },
  { "name": "Artisaga Copper Enamel Wall Plate", "price": 1499 },
  { "name": "Crafts Heaven Bone Inlay Coffee Table", "price": 9999 },
  { "name": "Handkrafted Handwoven Cane Armchair", "price": 5999 },
  { "name": "Artisaga Handloom Block Printed Throw", "price": 1799 },
  { "name": "Crafts Heaven Rustic Wooden Tray", "price": 899 },
  { "name": "Handkrafted Solid Sheesham Bookshelf", "price": 8499 },
  { "name": "Artisaga Longpi Pottery Carafe", "price": 899 },
  { "name": "Crafts Heaven Rattan Table Placemat", "price": 499 },
  { "name": "Handkrafted Mahogany Bed Frame", "price": 15999 },
  { "name": "Artisaga Herbal Dyed Table Runner", "price": 1199 },
  { "name": "Crafts Heaven Brass Nandi Figurine", "price": 1399 },
  { "name": "Handkrafted Bamboo Pendant Light", "price": 1799 },
  { "name": "Artisaga Longpi Pottery Cutlery Stand", "price": 799 },
  { "name": "Crafts Heaven Bone Inlay Chest of Drawers", "price": 11999 },
  { "name": "Handkrafted Teak Wood Sideboard", "price": 9999 },
  { "name": "Artisaga Handloom Pillow Cover", "price": 899 },
  { "name": "Crafts Heaven Horn Mug Set", "price": 799 },
  { "name": "Handkrafted Upcycled Wood Coffee Table", "price": 6999 },
  { "name": "Artisaga Longpi Pottery Decor Stand", "price": 999 },
  { "name": "Crafts Heaven Metal & Wood Fruit Bowl", "price": 1199 },
  { "name": "Handkrafted Handcarved Mirror Frame", "price": 3499 },
  { "name": "Artisaga Handloom Table Napkin Set", "price": 799 },
  { "name": "Crafts Heaven Bone Inlay Side Table", "price": 6999 },
  { "name": "Handkrafted Solid Wood Bar Stool", "price": 2999 },
  { "name": "Artisaga Longpi Pottery Serving Bowl", "price": 1099 },
  { "name": "Crafts Heaven Rattan & Iron Decor Palm Tree", "price": 1599 },
  { "name": "Handkrafted Vintage Wooden Trunk", "price": 6499 },
  { "name": "Artisaga Handloom Block Printed Table Runner", "price": 1399 },
  { "name": "Crafts Heaven Bone Inlay Mirror Frame", "price": 2999 },
  { "name": "Handkrafted Reclaimed Wood TV Unit", "price": 7999 },
  { "name": "Artisaga Longpi Pottery Coaster Set", "price": 599 },
  { "name": "Crafts Heaven Buffalo Horn Decorative Bowl", "price": 999 },
  { "name": "Handkrafted Solid Wood Dining Chair", "price": 2499 },
  { "name": "Artisaga Handloom Herbal Dyed Napkin Set", "price": 899 },
  { "name": "Crafts Heaven Bone Inlay Tray", "price": 1499 },
  { "name": "Handkrafted Mango Wood Shoe Rack", "price": 4999 },
  { "name": "Artisaga Longpi Pottery Tumbler", "price": 499 },
  { "name": "Crafts Heaven Horn Coaster Set", "price": 699 },
  { "name": "Handkrafted Walnut Wood Writing Desk", "price": 8999 },
  { "name": "Artisaga Handblock Printed Pillow Cover", "price": 799 },
  { "name": "Crafts Heaven Bone Inlay End Table", "price": 5999 },
  { "name": "Handkrafted Sheesham Wood Bedside Table", "price": 3499 },
  { "name": "Artisaga Longpi Pottery Platter", "price": 999 },
  { "name": "Crafts Heaven Brass Lamp Base", "price": 1799 },
  { "name": "Handkrafted Handwoven Jute Rug", "price": 2999 },
  { "name": "Artisaga Handloom Block Printed Cushion Cover", "price": 899 },
  { "name": "Crafts Heaven Bone Inlay Cabinet", "price": 10999 },
  { "name": "Handkrafted Solid Wood Dining Table", "price": 11999 },
  { "name": "Artisaga Longpi Pottery Kettle", "price": 1199 },
  { "name": "Crafts Heaven Horn Photo Frame", "price": 799 },
  { "name": "Handkrafted Reclaimed Wood Wall Shelf", "price": 1999 },
  { "name": "Artisaga Handloom Throw Blanket", "price": 1499 },
  { "name": "Crafts Heaven Bone Inlay Decorative Box", "price": 999 },
  { "name": "Handkrafted Mango Wood Bookshelf", "price": 6999 },
  { "name": "Artisaga Longpi Pottery Hexagon Bowl", "price": 899 },
  { "name": "Crafts Heaven Horn Cutlery Set", "price": 1299 },
  { "name": "Handkrafted Solid Wood Wardrobe", "price": 13999 },
  { "name": "Artisaga Handloom Herbal Dyed Tablecloth", "price": 1599 },
  { "name": "Crafts Heaven Bone Inlay Wall Panel", "price": 1999 },
  { "name": "Handkrafted Teak Wood Dressing Table", "price": 8999 },


  { "name": "Kalapuri Handwoven Wool Floor Rug", "price": 4499 },
  { "name": "Rustic Rasoi Mango Wood Bookshelf", "price": 6999 },
  { "name": "Artisans Crest Brass Elephant Figurine", "price": 1399 },
  { "name": "Channapatna Wooden Toy Train", "price": 799 },
  { "name": "Kaarigar Copper Hammered Jug", "price": 1099 },
  { "name": "Madhubani Painted Wall Clock", "price": 999 },
  { "name": "Saanjh Handloom Cotton Cushion Set", "price": 1499 },
  { "name": "Dharohar Handcarved Wooden Room Divider", "price": 5999 },
  { "name": "Bharat Haat Brass Shiva Idol", "price": 1799 },
  { "name": "Kutch Embroidered Wall Hanging", "price": 1299 },
  { "name": "Sikki Grass Round Tray", "price": 599 },
  { "name": "Sanskriti Handmade Terracotta Lamp", "price": 899 },
  { "name": "Craftroots Bamboo Table Lamp", "price": 1499 },
  { "name": "Gaatha Handpainted Clay Bowl Set", "price": 799 },
  { "name": "Industree Natural Jute Wall Organizer", "price": 999 },
  { "name": "Tula Organic Cotton Napkin Set", "price": 799 },
  { "name": "Sirohi Upcycled Rope Storage Ottoman", "price": 2999 },
  { "name": "Kashmir Box Walnut Wood Pen Stand", "price": 999 },
  { "name": "Porgai Lambadi Embroidered Wall Panel", "price": 1199 },
  { "name": "Kritarth Handmade Ceramic Vase", "price": 899 },
  { "name": "Sambalpuri Ikat Cotton Tablecloth", "price": 1599 },
  { "name": "Studio Coppre Brass Serving Tray", "price": 1299 },
  { "name": "Thar Artisan Handwoven Wool Cushion", "price": 999 },
  { "name": "Khamir Kala Cotton Table Runner", "price": 1399 },
  { "name": "Kashmir Loom Pashmina Wool Throw", "price": 5999 },
  { "name": "Varnam Handturned Wooden Toy Set", "price": 999 },
  { "name": "Sadhna Appliqué Cushion Cover", "price": 799 },
  { "name": "Sasha Fair Trade Handloom Tablecloth", "price": 1299 },
  { "name": "Kalighat Painted Wooden Wall Art", "price": 1799 },
  { "name": "Bamboo Pecker Foldable Study Table", "price": 2299 },
  { "name": "Kriti Kala Handwoven Sabai Grass Basket", "price": 899 },
  { "name": "Antaran Eri Silk Table Runner", "price": 1399 },
  { "name": "Chitrahandicrafts Wooden Jewelry Box", "price": 999 },
  { "name": "Dastkar Andhra Natural Dyed Napkin Set", "price": 999 },
  { "name": "Kilmora Woolen Throw Blanket", "price": 1999 },
  { "name": "Sasha Handmade Clay Mug Set", "price": 699 },
  { "name": "Sirohi Cane & Cotton Magazine Rack", "price": 1999 },
  { "name": "Gaatha Handpainted Terracotta Vase", "price": 799 },
  { "name": "Kaarigar Copper Water Bottle", "price": 899 },
  { "name": "Sutradhar Reclaimed Wood Coffee Table", "price": 7999 },
  { "name": "Craftroots Sabai Grass Storage Bin", "price": 1299 },
  { "name": "Rustic Rasoi Mango Wood Side Table", "price": 3499 },
  { "name": "Studio Coppre Brass Bowl Set", "price": 999 },
  { "name": "Porgai Embroidered Tote Bag", "price": 1099 },
  { "name": "Saanjh Handloom Cotton Bedspread", "price": 2499 },
  { "name": "Industree Banana Fiber Hanging Basket", "price": 799 },
  { "name": "Thar Artisan Woolen Rug", "price": 3999 },
  { "name": "Kashmir Box Papier-Mâché Jewelry Box", "price": 799 },
  { "name": "Sirohi Upcycled Rope Wall Shelf", "price": 1499 },
  { "name": "Craftroots Bamboo Fruit Tray", "price": 899 },
  { "name": "Khamir Kala Cotton Napkin Set", "price": 699 },
  { "name": "Sanskriti Terracotta Wind Chime", "price": 599 },
  { "name": "Sadhna Appliqué Table Runner", "price": 999 },
  { "name": "Kalapuri Handwoven Cotton Rug", "price": 2999 },
  { "name": "Channapatna Wooden Puzzle Set", "price": 699 },
  { "name": "Gaatha Handpainted Clay Plate Set", "price": 999 },
  { "name": "Kritarth Ceramic Aroma Diffuser", "price": 799 },
  { "name": "Craftroots Sabai Grass Wall Hanging", "price": 1099 },
  { "name": "Sirohi Cotton Rope Planter Basket", "price": 1299 },
  { "name": "Studio Coppre Brass Tumbler", "price": 799 },
  { "name": "Kaarigar Copper Cup Set", "price": 999 },
  { "name": "Sutradhar Sheesham Wood Dining Bench", "price": 5999 },
  { "name": "Rustic Rasoi Mango Wood TV Unit", "price": 6499 },
  { "name": "Industree Jute Table Mat Set", "price": 699 },
  { "name": "Saanjh Handloom Cotton Pillow Cover", "price": 999 },
  { "name": "Kashmir Loom Handwoven Wool Throw", "price": 2999 },
  { "name": "Porgai Embroidered Table Runner", "price": 999 },
  { "name": "Craftroots Bamboo Coaster Set", "price": 599 },
  { "name": "Sasha Handmade Clay Bowl", "price": 499 },
  { "name": "Kriti Kala Sabai Grass Hanging Basket", "price": 799 },


  { "name": "Kalapuri Handwoven Cotton Wall Hanging", "price": 1299 },
  { "name": "Rustic Rasoi Mango Wood Coffee Table", "price": 5999 },
  { "name": "Artisans Crest Brass Peacock Figurine", "price": 1499 },
  { "name": "Channapatna Wooden Spinning Top Set", "price": 499 },
  { "name": "Kaarigar Copper Water Pitcher", "price": 1199 },
  { "name": "Madhubani Painted Wooden Clock", "price": 899 },
  { "name": "Saanjh Handloom Wool Cushion Cover", "price": 999 },
  { "name": "Dharohar Handcarved Teak Room Divider", "price": 6499 },
  { "name": "Bharat Haat Brass Krishna Idol", "price": 1699 },
  { "name": "Kutch Embroidered Table Runner", "price": 1099 },
  { "name": "Sikki Grass Oval Basket", "price": 699 },
  { "name": "Sanskriti Handmade Terracotta Candle Holder", "price": 599 },
  { "name": "Craftroots Bamboo Floor Lamp", "price": 1799 },
  { "name": "Gaatha Handpainted Clay Bowl", "price": 699 },
  { "name": "Industree Natural Jute Table Mat", "price": 799 },
  { "name": "Tula Organic Cotton Throw Blanket", "price": 1399 },
  { "name": "Sirohi Upcycled Rope Magazine Holder", "price": 1499 },
  { "name": "Kashmir Box Walnut Wood Keepsake Box", "price": 1299 },
  { "name": "Porgai Lambadi Embroidered Cushion Set", "price": 999 },
  { "name": "Kritarth Handmade Ceramic Oil Burner", "price": 699 },
  { "name": "Sambalpuri Ikat Cotton Bedspread", "price": 1899 },
  { "name": "Studio Coppre Brass Snack Bowl", "price": 899 },
  { "name": "Thar Artisan Handwoven Wool Pouf", "price": 2999 },
  { "name": "Khamir Kala Cotton Curtain Panel", "price": 1599 },
  { "name": "Kashmir Loom Pashmina Wool Scarf", "price": 4999 },
  { "name": "Varnam Handturned Wooden Toy Car", "price": 599 },
  { "name": "Sadhna Appliqué Pillow Cover", "price": 699 },
  { "name": "Sasha Fair Trade Handloom Table Runner", "price": 999 },
  { "name": "Kalighat Painted Wooden Tray", "price": 1499 },
  { "name": "Bamboo Pecker Foldable Craft Table", "price": 2199 },
  { "name": "Kriti Kala Handwoven Sabai Grass Tray", "price": 799 },
  { "name": "Antaran Eri Silk Bedspread", "price": 1999 },
  { "name": "Chitrahandicrafts Wooden Spice Rack", "price": 899 },
  { "name": "Dastkar Andhra Natural Dyed Cushion Cover", "price": 799 },
  { "name": "Kilmora Woolen Rug", "price": 2499 },
  { "name": "Sasha Handmade Clay Serving Bowl", "price": 599 },
  { "name": "Sirohi Cane & Cotton Wall Shelf", "price": 2499 },
  { "name": "Gaatha Handpainted Terracotta Lamp", "price": 999 },
  { "name": "Kaarigar Copper Flask", "price": 999 },
  { "name": "Sutradhar Reclaimed Wood Dining Table", "price": 8999 },
  { "name": "Craftroots Sabai Grass Hanging Basket", "price": 999 },
  { "name": "Rustic Rasoi Mango Wood Console Table", "price": 6999 },
  { "name": "Studio Coppre Brass Cup Set", "price": 999 },
  { "name": "Porgai Embroidered Wall Hanging", "price": 1199 },
  { "name": "Saanjh Handloom Cotton Quilt", "price": 2699 },
  { "name": "Industree Banana Fiber Storage Bin", "price": 899 },
  { "name": "Thar Artisan Woolen Cushion Cover", "price": 999 },
  { "name": "Kashmir Box Papier-Mâché Wall Plate", "price": 999 },
  { "name": "Sirohi Upcycled Rope Side Table", "price": 1999 },
  { "name": "Craftroots Bamboo Fruit Basket", "price": 899 },
  { "name": "Khamir Kala Cotton Pillow Cover", "price": 799 },
  { "name": "Sanskriti Terracotta Hanging Lamp", "price": 699 },
  { "name": "Sadhna Appliqué Bedspread", "price": 1499 },
  { "name": "Kalapuri Handwoven Wool Rug", "price": 3999 },
  { "name": "Channapatna Wooden Toy Set", "price": 699 },
  { "name": "Gaatha Handpainted Clay Mug", "price": 599 },
  { "name": "Kritarth Ceramic Planter Set", "price": 999 },
  { "name": "Craftroots Sabai Grass Wall Decor", "price": 1099 },
  { "name": "Sirohi Cotton Rope Hanging Shelf", "price": 1499 },
  { "name": "Studio Coppre Brass Tray Set", "price": 1399 },
  { "name": "Kaarigar Copper Tumbler Set", "price": 999 },
  { "name": "Sutradhar Sheesham Wood Shoe Rack", "price": 4999 },
  { "name": "Rustic Rasoi Mango Wood Bar Table", "price": 5999 },
  { "name": "Industree Jute Hanging Organizer", "price": 699 },
  { "name": "Saanjh Handloom Cotton Table Mat Set", "price": 999 },
  { "name": "Kashmir Loom Handwoven Wool Shawl", "price": 3499 },
  { "name": "Porgai Embroidered Napkin Set", "price": 799 },
  { "name": "Craftroots Bamboo Coaster Tray", "price": 599 },
  { "name": "Sasha Handmade Clay Plate", "price": 499 },
  { "name": "Kriti Kala Sabai Grass Table Mat", "price": 699 },


                  ],
                  "House construction materials": [

     { "name": "UltraTech Cement (50kg)", "price": 380 },
  { "name": "Birla White Cement (1kg)", "price": 239 },
  { "name": "Shree Cement (50kg)", "price": 370 },
  { "name": "JK Cement (50kg)", "price": 360 },
  { "name": "ACC Cement (50kg)", "price": 375 },
  { "name": "TMT Steel Bars (Fe500, 12mm)", "price": 65 },
  { "name": "TMT Steel Bars (Fe500, 8mm)", "price": 62 },
  { "name": "MS Binding Wire (1kg)", "price": 55 },
  { "name": "PVC Pipes (2 inch, 6m)", "price": 210 },
  { "name": "CPVC Pipes (1 inch, 3m)", "price": 180 },
  { "name": "UPVC Pipes (3 inch, 6m)", "price": 250 },
  { "name": "GI Pipes (1 inch, 6m)", "price": 320 },
  { "name": "Brass Ball Valve (1 inch)", "price": 280 },
  { "name": "PVC Elbow (2 inch)", "price": 35 },
  { "name": "PVC Tee (2 inch)", "price": 40 },
  { "name": "PVC Reducer (2 to 1 inch)", "price": 30 },
  { "name": "PVC Pipe Clamp", "price": 15 },
  { "name": "Stainless Steel Sink", "price": 1450 },
  { "name": "Bathroom Tap (Jaquar)", "price": 850 },
  { "name": "Kitchen Tap (Hindware)", "price": 950 },
  { "name": "Ceramic Wash Basin", "price": 1100 },
  { "name": "Western Toilet (Cera)", "price": 4200 },
  { "name": "Wall Tiles (Kajaria, 1 box)", "price": 480 },
  { "name": "Floor Tiles (Somany, 1 box)", "price": 520 },
  { "name": "Tile Adhesive (20kg)", "price": 650 },
  { "name": "Tile Spacer Clips (Pack of 200)", "price": 299 },
  { "name": "Grill Gate (Iron, 4x6 ft)", "price": 4200 },
  { "name": "Window Grill (3x4 ft)", "price": 1800 },
  { "name": "Main Door (Teak, 7x3 ft)", "price": 7500 },
  { "name": "Interior Door (WPC)", "price": 5000 },
  { "name": "Bathroom Door (PVC)", "price": 155 },
  { "name": "Aluminium Trap Door", "price": 1707 },
  { "name": "Wooden Door Frame (Sal wood)", "price": 2200 },
  { "name": "Door Hinges (Stainless Steel)", "price": 120 },
  { "name": "Door Lock Set (Godrej)", "price": 850 },
  { "name": "Window Frame (Aluminium)", "price": 1800 },
  { "name": "Glass Pane (4x4 ft)", "price": 950 },
  { "name": "Concrete Blocks (AAC)", "price": 45 },
  { "name": "Red Bricks (Per 100)", "price": 550 },
  { "name": "River Sand (1 ton)", "price": 1200 },
  { "name": "M-Sand (1 ton)", "price": 950 },
  { "name": "Aggregate 20mm (1 ton)", "price": 850 },
  { "name": "Plaster of Paris (25kg)", "price": 320 },
  { "name": "Wall Putty (Birla, 20kg)", "price": 650 },
  { "name": "Primer (Asian Paints, 10L)", "price": 950 },
  { "name": "Exterior Paint (Nerolac, 20L)", "price": 2800 },
  { "name": "Interior Paint (Asian Paints, 20L)", "price": 2600 },
  { "name": "Electrical Wire (Finolex, 90m)", "price": 1450 },
  { "name": "Switches (Anchor, 6A)", "price": 45 },
  { "name": "Sockets (Anchor, 16A)", "price": 65 },
  { "name": "MCB (Legrand, 16A)", "price": 280 },
  { "name": "Distribution Box (4 way)", "price": 650 },
  { "name": "Ceiling Fan (Usha)", "price": 1800 },
  { "name": "LED Tube Light (Philips)", "price": 450 },
  { "name": "LED Bulb (Syska, 9W)", "price": 120 },
  { "name": "Water Tank (1000L)", "price": 4200 },
  { "name": "Geyser (Racold, 15L)", "price": 5200 },
  { "name": "Solar Panel (100W)", "price": 3200 },
  { "name": "Inverter (Luminous, 900VA)", "price": 4800 },
  { "name": "Battery (Exide, 150Ah)", "price": 10500 },
  { "name": "Roof Sheet (GI, 10ft)", "price": 850 },
  { "name": "Roof Insulation Roll", "price": 1200 },
  { "name": "Waterproofing Chemical (Dr. Fixit, 10L)", "price": 950 },
  { "name": "Cement Remover (500ml)", "price": 449 },
  { "name": "Fuel Transfer Pump Kit", "price": 208 },
  { "name": "Shade Net (10x10 ft)", "price": 579 },
  { "name": "Deck Tiles (Acacia Wood, 12 pcs)", "price": 2849 },
  { "name": "Flooring Sheet (PVC, 27 sq ft)", "price": 1998 },
  { "name": "Wall Trim Strip (Stainless Steel)", "price": 799 },
  { "name": "Pegboard Organizer (Plastic)", "price": 1999 },


  { "name": "ACC Gold Cement (50kg)", "price": 445 },
  { "name": "Birla White Cement (1kg)", "price": 239 },
  { "name": "JK Lakshmi PPC Cement (50kg)", "price": 430 },
  { "name": "Ultratech Weather Plus Cement (50kg)", "price": 460 },
  { "name": "Ambuja Cement OPC 53 Grade (50kg)", "price": 455 },
  { "name": "Ramco Supercrete Cement (50kg)", "price": 470 },
  { "name": "Shree Jung Rodhak Cement (50kg)", "price": 440 },
  { "name": "TMT Steel Bar Fe500D (12mm)", "price": 78 },
  { "name": "TATA Tiscon TMT Bar (10mm)", "price": 76 },
  { "name": "JSW Neosteel TMT Bar (8mm)", "price": 74 },
  { "name": "Vizag Steel TMT Bar (16mm)", "price": 82 },
  { "name": "Kamdhenu TMT Bar (20mm)", "price": 85 },
  { "name": "Sail TMT Bar (25mm)", "price": 88 },
  { "name": "GI Pipe 1 inch (ISI Marked)", "price": 210 },
  { "name": "Ashirvad CPVC Pipe ¾ inch", "price": 145 },
  { "name": "Supreme UPVC Pipe 2 inch", "price": 260 },
  { "name": "Astral CPVC Pipe 1 inch", "price": 190 },
  { "name": "Prince PVC Pipe 3 inch", "price": 320 },
  { "name": "Finolex PVC Pipe 4 inch", "price": 390 },
  { "name": "Sintex Water Tank 1000L", "price": 5800 },
  { "name": "Grill Gate (5x7 ft, MS)", "price": 7800 },
  { "name": "Balcony Grill (10 ft, powder coated)", "price": 4200 },
  { "name": "Window Grill (3x4 ft)", "price": 1800 },
  { "name": "Main Door Grill (Designer MS)", "price": 9500 },
  { "name": "Safety Door Grill (Stainless Steel)", "price": 6200 },
  { "name": "Greenply Flush Door (7x3 ft)", "price": 2650 },
  { "name": "Century Laminated Door (7x3 ft)", "price": 3100 },
  { "name": "Teak Wood Door (6x3 ft)", "price": 21500 },
  { "name": "PVC Bathroom Door (Plantex)", "price": 5059 },
  { "name": "Mahogany Interior Door", "price": 6411 },
  { "name": "Aluminium Trap Door (EasyAccess)", "price": 1904 },
  { "name": "WPC Waterproof Door (Plantex)", "price": 5009 },
  { "name": "Shower Tube Pipe (Acetap 1.5m)", "price": 297 },
  { "name": "Butterfly Jet Spray (Acetap)", "price": 212 },
  { "name": "PVC Pipe Connector (¾ inch)", "price": 135 },
  { "name": "Fuel Transfer Pump Kit", "price": 208 },
  { "name": "Ball Valve UPVC 32mm", "price": 243 },
  { "name": "Washing Machine Drain Pipe (3m)", "price": 213 },
  { "name": "COSWARE SS Connection Pipe (18\")", "price": 216 },
  { "name": "BATHBLISS SS Hose Pipe (24\")", "price": 232 },
  { "name": "Waterproofing Compound (Dr. Fixit)", "price": 480 },
  { "name": "Plaster of Paris (25kg)", "price": 320 },
  { "name": "AAC Block (600x200x100mm)", "price": 65 },
  { "name": "Concrete Mixer (Portable)", "price": 18500 },
  { "name": "Wall Putty (Birla 20kg)", "price": 520 },
  { "name": "Tile Adhesive (Weber 20kg)", "price": 650 },
  { "name": "Ceramic Floor Tile (2x2 ft)", "price": 75 },
  { "name": "Wall Tile (12x18 inch)", "price": 55 },
  { "name": "Granite Slab (Black Galaxy)", "price": 1800 },
  { "name": "Marble Slab (Makrana)", "price": 2200 },
  { "name": "Paint Primer (Asian Paints 1L)", "price": 210 },
  { "name": "Emulsion Paint (Berger 10L)", "price": 1450 },
  { "name": "Wood Polish (PU Finish 1L)", "price": 320 },
  { "name": "Electrical Wire (Polycab 1.5 sq mm)", "price": 980 },
  { "name": "Switch Board (Anchor 6 module)", "price": 420 },
  { "name": "LED Tube Light (Philips 20W)", "price": 340 },
  { "name": "Ceiling Fan (Havells 1200mm)", "price": 2450 },
  { "name": "Exhaust Fan (Usha 9 inch)", "price": 1150 },
  { "name": "Bathroom Fittings Set (Jaquar)", "price": 7800 },
  { "name": "Kitchen Sink (Stainless Steel)", "price": 1850 },
  { "name": "Geyser (Racold 15L)", "price": 6200 },
  { "name": "Toilet Seat (Cera Floor Mounted)", "price": 3900 },
  { "name": "Wash Basin (Hindware)", "price": 1450 },
  { "name": "Mirror Cabinet (Plastic)", "price": 850 },
  { "name": "Door Handle Set (Brass)", "price": 620 },
  { "name": "Window Latch (Stainless Steel)", "price": 180 },
  { "name": "Curtain Rod (6 ft)", "price": 420 },
  { "name": "Aluminium Ladder (6 ft)", "price": 1850 },
  { "name": "Manhole Cover (PVC)", "price": 950 },
  { "name": "Waterproof Shade Net (10x10 ft)", "price": 579 },
  { "name": "Fiber Mesh Roll (50m)", "price": 1245 },


  { "name": "Nagarjuna PPC Cement (50kg)", "price": 255 },
  { "name": "CCI OPC Cement (50kg)", "price": 265 },
  { "name": "Raasi Gold PPC Cement (50kg)", "price": 460 },
  { "name": "Sugna TMT Fe-550 Bar (16mm)", "price": 53800 },
  { "name": "Jindal TMT Steel Bar (12mm)", "price": 42500 },
  { "name": "Agni Steel TMT Bar (10mm)", "price": 58000 },
  { "name": "Sunvik Steel TMT Bar (8mm)", "price": 49000 },
  { "name": "Finolex PVC Long Bend (1 inch)", "price": 26 },
  { "name": "Prince CPVC Elbow (¾ inch)", "price": 18 },
  { "name": "Astral Pipe Tee Connector (1 inch)", "price": 22 },
  { "name": "Ashirvad CPVC Coupler (½ inch)", "price": 20 },
  { "name": "Supreme UPVC Pipe Clamp", "price": 15 },
  { "name": "Karnataka Red Brick (8x3.8x2.9 inch)", "price": 14 },
  { "name": "Maharashtra Red Brick (9x4x3 inch)", "price": 15 },
  { "name": "ACB Fly Ash Brick (9x3x2 inch)", "price": 9 },
  { "name": "Greenstone AAC Block (600x200x100mm)", "price": 40 },
  { "name": "Aerobild AAC Block (600x200x230mm)", "price": 135 },
  { "name": "Leo AAC Block (4 inch)", "price": 60 },
  { "name": "Makrana Marble Slab (2x2 ft)", "price": 2200 },
  { "name": "Black Granite Slab (Galaxy)", "price": 1800 },
  { "name": "Sandstone Tile (1x1 ft)", "price": 95 },
  { "name": "Quartz Stone Panel (12x24 inch)", "price": 150 },
  { "name": "River Sand (1 ton)", "price": 3200 },
  { "name": "M Sand (Plaster grade, 1 ton)", "price": 1400 },
  { "name": "Quarry Dust (2 ton)", "price": 850 },
  { "name": "Wall Plaster Mix (Simcrete 40kg)", "price": 599 },
  { "name": "Dry-Mix Self Curing Wall Plaster", "price": 599 },
  { "name": "Wall Putty (Magic Acrylic 20L)", "price": 1350 },
  { "name": "Tile Adhesive (20kg)", "price": 650 },
  { "name": "Rebar Coupler + Rod Threading (16mm)", "price": 127 },
  { "name": "Concrete Nail (2 inch)", "price": 5 },
  { "name": "Anchor Fastener (M10)", "price": 12 },
  { "name": "Fevicol Adhesive (1kg)", "price": 210 },
  { "name": "Synthetic Sealant (Silicone)", "price": 185 },
  { "name": "Wall Setter Trowel (Steel)", "price": 240 },
  { "name": "Plastering Float (PVC)", "price": 180 },
  { "name": "Bricklaying Trowel (Wood Handle)", "price": 220 },
  { "name": "Spirit Level (12 inch)", "price": 320 },
  { "name": "Plumb Bob (Brass)", "price": 150 },
  { "name": "Masonry Hammer (1kg)", "price": 390 },
  { "name": "Grill Gate (Designer Iron)", "price": 8200 },
  { "name": "Window Grill (Powder Coated)", "price": 1900 },
  { "name": "Balcony Grill (10 ft)", "price": 4300 },
  { "name": "Main Door Grill (Stainless Steel)", "price": 9600 },
  { "name": "Safety Grill (Aluminium)", "price": 5800 },
  { "name": "Teak Wood Door (7x3 ft)", "price": 22500 },
  { "name": "PVC Bathroom Door (Plantex)", "price": 5100 },
  { "name": "WPC Waterproof Door", "price": 5050 },
  { "name": "Digital Smart Door Lock (VN-G111)", "price": 27998 },
  { "name": "Door Handle (Stainless Steel)", "price": 620 },
  { "name": "Window Latch (Brass)", "price": 180 },
  { "name": "Curtain Rod (6 ft)", "price": 420 },
  { "name": "Wall Tile (Ceramic 12x18 inch)", "price": 55 },
  { "name": "Floor Tile (Kajaria Brown Garnet)", "price": 98 },
  { "name": "Ceramic Wall Tile (3011 - 100x150mm)", "price": 75 },
  { "name": "Paint Primer (Asian Paints 1L)", "price": 210 },
  { "name": "Emulsion Paint (Berger 10L)", "price": 1450 },
  { "name": "Wood Polish (PU Finish)", "price": 320 },
  { "name": "Pipe Wrench (12 inch)", "price": 480 },
  { "name": "Hose Clamp (Stainless Steel)", "price": 35 },
  { "name": "Manhole Cover (PVC)", "price": 950 },
  { "name": "Waterproof Shade Net (10x10 ft)", "price": 579 },
  { "name": "Fiber Mesh Roll (50m)", "price": 1245 },
  { "name": "Aluminium Ladder (6 ft)", "price": 1850 },
  { "name": "Concrete Mixer (Portable)", "price": 18500 },
  { "name": "Wheelbarrow (Iron)", "price": 3200 },
  { "name": "Scaffolding Pipe (6 ft)", "price": 850 },
  { "name": "Earth Rammer (Manual)", "price": 1450 },
  { "name": "Water Level Pipe (10m)", "price": 210 },


  { "name": "Kajaria Ceramic Floor Tile (2x2 ft)", "price": 98 },
  { "name": "Somany Glazed Vitrified Tile (600x600mm)", "price": 115 },
  { "name": "Nitco Polished Vitrified Tile (800x800mm)", "price": 145 },
  { "name": "Asian Granito Double Charge Tile (600x600mm)", "price": 130 },
  { "name": "Simpolo Marble-Look Tile (600x1200mm)", "price": 185 },
  { "name": "Johnson Wood-Look Tile (195x1200mm)", "price": 160 },
  { "name": "Orientbell Ceramic Wall Tile (300x450mm)", "price": 75 },
  { "name": "Varmora Digital Wall Tile (300x600mm)", "price": 88 },
  { "name": "Rak Ceramics Floor Tile (600x600mm)", "price": 125 },
  { "name": "Cera Anti-Skid Bathroom Tile (300x300mm)", "price": 72 },
  { "name": "Granite Slab (Steel Grey)", "price": 1850 },
  { "name": "Granite Slab (Tan Brown)", "price": 1950 },
  { "name": "Granite Slab (Kashmir White)", "price": 2100 },
  { "name": "Granite Slab (Black Pearl)", "price": 1900 },
  { "name": "Granite Slab (Vizag Blue)", "price": 2000 },
  { "name": "Marble Slab (Italian Botticino)", "price": 2800 },
  { "name": "Marble Slab (Indian Green)", "price": 1600 },
  { "name": "Marble Slab (White Statuario)", "price": 3200 },
  { "name": "Quartz Stone Tile (600x600mm)", "price": 240 },
  { "name": "Sandstone Flooring Tile (1x1 ft)", "price": 95 },
  { "name": "Wooden Laminate Flooring (Per sq ft)", "price": 110 },
  { "name": "Vinyl Flooring Sheet (Per sq ft)", "price": 65 },
  { "name": "PVC Interlocking Floor Tile (12x12 inch)", "price": 85 },
  { "name": "Deck Wood Tile (Acacia 12x12 inch)", "price": 175 },
  { "name": "Terracotta Tile (300x300mm)", "price": 78 },
  { "name": "Mosaic Tile Sheet (Glass Mix)", "price": 210 },
  { "name": "Ceramic Skirting Tile (100x600mm)", "price": 45 },
  { "name": "Tile Spacer (3mm, Pack of 100)", "price": 189 },
  { "name": "Tile Leveling Clip (Pack of 200)", "price": 299 },
  { "name": "Tile Adhesive (Kerakoll 20kg)", "price": 680 },
  { "name": "Tile Grout (White 1kg)", "price": 120 },
  { "name": "Tile Cutter Machine (Manual)", "price": 1850 },
  { "name": "Tile Polish Liquid (1L)", "price": 210 },
  { "name": "Tile Gap Filler (Waterproof 280ml)", "price": 450 },
  { "name": "Floor Transition Strip (Vinyl)", "price": 554 },
  { "name": "Self-Adhesive Mirror Tile Strip", "price": 799 },
  { "name": "Rubber Flooring Mat (2x2 ft)", "price": 320 },
  { "name": "Anti-Skid Stair Tread (Rubber)", "price": 936 },
  { "name": "Wood Plastic Composite Deck Tile", "price": 499 },
  { "name": "Grass Carpet Tile (High Density)", "price": 3829 },
  { "name": "Outdoor Parking Tile (Heavy Duty)", "price": 145 },
  { "name": "Ceramic Border Tile (Decorative)", "price": 88 },
  { "name": "Tile Edge Trim (Stainless Steel)", "price": 599 },
  { "name": "Tile Visualizer Software License", "price": 1250 },
  { "name": "Tile Display Rack (Metal)", "price": 3200 },
  { "name": "Tile Sample Book (Branded)", "price": 850 },
  { "name": "Tile Cleaning Brush (Heavy Duty)", "price": 180 },
  { "name": "Tile Sealant (Silicone 300ml)", "price": 185 },
  { "name": "Tile Leveling Wedges (Pack of 100)", "price": 279 },
  { "name": "Tile Spacer Tool (Reusable)", "price": 525 },
  { "name": "Tile Remover Tool (Manual)", "price": 450 },
  { "name": "Tile Display Hook Tape (Pack of 100)", "price": 390 },
  { "name": "Tile Adhesive Remover (500ml)", "price": 449 },
  { "name": "Tile Gap Crack Filler (Ready Mix)", "price": 299 },
  { "name": "Tile Design Software (Basic)", "price": 999 },
  { "name": "Tile Sample Pack (2x2 inch, 20 pcs)", "price": 499 },
  { "name": "Ceramic Mosaic Tile (Multicolor)", "price": 473 },
  { "name": "Decorative Wall Tile (Blue Pottery)", "price": 499 },
  { "name": "Tile Display Stand (Portable)", "price": 1850 },
  { "name": "Tile Leveling System Kit (50 pcs)", "price": 378 },
  { "name": "Tile Adhesive Gun (Manual)", "price": 620 },
  { "name": "Tile Edge Moulding Strip (Gold)", "price": 799 },
  { "name": "Tile Spacer Clip (Plastic)", "price": 199 },
  { "name": "Tile Grout Remover Tool", "price": 320 },
  { "name": "Tile Polish Pad (Diamond)", "price": 906 },
  { "name": "Tile Display Board (Acrylic)", "price": 998 },
  { "name": "Tile Sample Box (Branded)", "price": 1450 },
  { "name": "Tile Adhesive Mixer (Electric)", "price": 1850 },
  { "name": "Tile Leveling Plier (Metal)", "price": 420 },
  { "name": "Tile Edge Protector Strip", "price": 599 },
  { "name": "Tile Design Catalog (Printed)", "price": 320 },
  { "name": "Tile Installation Kit (Complete)", "price": 2450 },

  { "name": "Plastic Water Drum (200L)", "price": 1150 },
  { "name": "Steel Storage Drum (100L)", "price": 1850 },
  { "name": "HDPE Chemical Drum (50L)", "price": 980 },
  { "name": "Sintex Multipurpose Drum (100L)", "price": 1450 },
  { "name": "Blue Barrel Drum (PVC, 60L)", "price": 890 },
  { "name": "Open Top Drum (Plastic, 120L)", "price": 1250 },
  { "name": "Fiber Drum with Lid (80L)", "price": 1350 },
  { "name": "Staircase Set (Concrete Precast)", "price": 18500 },
  { "name": "Steel Staircase Frame (10 steps)", "price": 14500 },
  { "name": "Wooden Stair Tread (Teak)", "price": 1850 },
  { "name": "Granite Stair Tread (Black)", "price": 2100 },
  { "name": "Anti-Skid Stair Nosing Strip", "price": 320 },
  { "name": "Stair Railing Set (MS)", "price": 5800 },
  { "name": "Staircase Baluster (Stainless Steel)", "price": 420 },
  { "name": "Ceiling PO Panel (PVC, 2x2 ft)", "price": 210 },
  { "name": "Gypsum Ceiling Panel (2x2 ft)", "price": 185 },
  { "name": "POP Ceiling Sheet (2x4 ft)", "price": 240 },
  { "name": "Fiber Ceiling Tile (Acoustic)", "price": 320 },
  { "name": "PVC Ceiling Grid (2x2 ft)", "price": 180 },
  { "name": "False Ceiling Light Panel (LED)", "price": 620 },
  { "name": "Ceiling Suspension Wire (Pack of 50)", "price": 299 },
  { "name": "Ceiling Channel (Galvanized Steel)", "price": 145 },
  { "name": "Ceiling Corner Bead (PVC)", "price": 88 },
  { "name": "Ceiling Insulation Roll (Rockwool)", "price": 1850 },
  { "name": "Ceiling Fan Mounting Kit", "price": 320 },
  { "name": "POP Moulding Strip (Decorative)", "price": 599 },
  { "name": "Ceiling Rose (Plastic)", "price": 120 },
  { "name": "Ceiling Trap Door (Aluminium)", "price": 1904 },
  { "name": "Ceiling Paint (Asian Paints 10L)", "price": 1450 },
  { "name": "Ceiling Light Fixture (Philips)", "price": 850 },
  { "name": "Ceiling Grid Connector (Pack of 20)", "price": 210 },
  { "name": "Ceiling Acoustic Panel (Foam)", "price": 620 },
  { "name": "Ceiling Decorative Panel (3D PVC)", "price": 799 },
  { "name": "Ceiling Edge Trim (Metal)", "price": 554 },
  { "name": "Ceiling Access Hatch (PVC)", "price": 950 },
  { "name": "Ceiling Panel Adhesive (5kg)", "price": 480 },
  { "name": "Ceiling Panel Cutter Tool", "price": 850 },
  { "name": "Ceiling Grid Leveling Tool", "price": 620 },
  { "name": "Ceiling Panel Display Rack", "price": 3200 },
  { "name": "Ceiling Panel Sample Book", "price": 850 },
  { "name": "Ceiling Panel Polish Liquid", "price": 210 },
  { "name": "Ceiling Panel Gap Filler", "price": 450 },
  { "name": "Ceiling Panel Edge Protector", "price": 599 },
  { "name": "Ceiling Panel Installation Kit", "price": 2450 },
  { "name": "Ceiling Panel Leveling Clip", "price": 299 },
  { "name": "Ceiling Panel Spacer Tool", "price": 525 },
  { "name": "Ceiling Panel Remover Tool", "price": 450 },
  { "name": "Ceiling Panel Display Hook Tape", "price": 390 },
  { "name": "Ceiling Panel Adhesive Remover", "price": 449 },
  { "name": "Ceiling Panel Crack Filler", "price": 299 },
  { "name": "Ceiling Panel Design Software", "price": 999 },
  { "name": "Ceiling Panel Sample Pack", "price": 499 },
  { "name": "Ceiling Panel Polish Pad", "price": 906 },
  { "name": "Ceiling Panel Display Board", "price": 998 },
  { "name": "Ceiling Panel Sample Box", "price": 1450 },
  { "name": "Ceiling Panel Adhesive Mixer", "price": 1850 },
  { "name": "Ceiling Panel Leveling Plier", "price": 420 },
  { "name": "Ceiling Panel Edge Moulding Strip", "price": 799 },
  { "name": "Ceiling Panel Spacer Clip", "price": 199 },
  { "name": "Ceiling Panel Grout Remover Tool", "price": 320 },
  { "name": "Ceiling Panel Installation Manual", "price": 320 },
  { "name": "Ceiling Panel Visualizer License", "price": 1250 },
  { "name": "Ceiling Panel Display Stand", "price": 1850 },
  { "name": "Ceiling Panel Leveling System Kit", "price": 378 },
  { "name": "Ceiling Panel Adhesive Gun", "price": 620 },
  { "name": "Ceiling Panel Edge Protector Strip", "price": 599 },
  { "name": "Ceiling Panel Design Catalog", "price": 320 },
  { "name": "Ceiling Panel Installation Kit (Complete)", "price": 2450 },


  { "name": "Safety Helmet (ISI Marked)", "price": 320 },
  { "name": "Safety Gloves (Rubber)", "price": 180 },
  { "name": "Safety Goggles (Anti-Fog)", "price": 210 },
  { "name": "Dust Mask (Pack of 5)", "price": 150 },
  { "name": "Reflective Safety Jacket", "price": 299 },
  { "name": "Construction Boots (Steel Toe)", "price": 850 },
  { "name": "Measuring Tape (5m)", "price": 180 },
  { "name": "Laser Distance Meter (Bosch)", "price": 2450 },
  { "name": "Digital Caliper (150mm)", "price": 620 },
  { "name": "Infrared Thermometer (Fluke)", "price": 1850 },
  { "name": "Concrete Moisture Meter", "price": 1450 },
  { "name": "Digital Spirit Level", "price": 980 },
  { "name": "Construction Site Sign Board", "price": 850 },
  { "name": "Warning Tape (100m)", "price": 320 },
  { "name": "Barricade Cone (PVC)", "price": 450 },
  { "name": "Site First Aid Kit", "price": 620 },
  { "name": "Fire Extinguisher (ABC 2kg)", "price": 1450 },
  { "name": "Tool Box (Plastic)", "price": 850 },
  { "name": "Hammer Drill (Bosch)", "price": 3850 },
  { "name": "Cordless Screwdriver (Black+Decker)", "price": 1850 },
  { "name": "Angle Grinder (Makita)", "price": 3200 },
  { "name": "Circular Saw (Stanley)", "price": 4200 },
  { "name": "Electric Sander (Dewalt)", "price": 2850 },
  { "name": "Paint Roller Set (5 pcs)", "price": 320 },
  { "name": "Paint Tray (Plastic)", "price": 180 },
  { "name": "Putty Knife (Steel)", "price": 120 },
  { "name": "Caulking Gun (Manual)", "price": 450 },
  { "name": "Extension Cord (15m)", "price": 620 },
  { "name": "Power Strip (6 Socket)", "price": 850 },
  { "name": "Voltage Tester Pen", "price": 210 },
  { "name": "Multimeter (Digital)", "price": 980 },
  { "name": "Wire Stripper Tool", "price": 320 },
  { "name": "Cable Ties (Pack of 100)", "price": 180 },
  { "name": "Electrical Tape (Pack of 5)", "price": 150 },
  { "name": "PVC Junction Box (4x4 inch)", "price": 88 },
  { "name": "MCB (Legrand 16A)", "price": 320 },
  { "name": "Distribution Board (4 Way)", "price": 1450 },
  { "name": "Earthing Rod (Copper)", "price": 850 },
  { "name": "Lightning Arrestor Kit", "price": 2450 },
  { "name": "Solar Panel (100W)", "price": 3850 },
  { "name": "Solar Inverter (Luminous)", "price": 6200 },
  { "name": "Battery Bank (Livguard 150Ah)", "price": 12499 },
  { "name": "Water Pump (Crompton 1HP)", "price": 4850 },
  { "name": "Pressure Pump (Grundfos)", "price": 7800 },
  { "name": "Submersible Pump (Kirloskar)", "price": 6200 },
  { "name": "Water Flow Meter (Digital)", "price": 1450 },
  { "name": "Rainwater Harvesting Filter", "price": 1850 },
  { "name": "Water Softener Unit", "price": 9800 },
  { "name": "Cleaning Mop Set (Spin Type)", "price": 850 },
  { "name": "Floor Scrubber Brush", "price": 320 },
  { "name": "Construction Waste Bin (120L)", "price": 1450 },
  { "name": "Site Dustbin (Plastic)", "price": 850 },
  { "name": "Site Lighting Pole (LED)", "price": 3200 },
  { "name": "Flood Light (50W)", "price": 1450 },
  { "name": "Portable Generator (Honda 2kVA)", "price": 28500 },
  { "name": "Site Office Cabin (Pre-Fab)", "price": 185000 },
  { "name": "Portable Toilet Cabin", "price": 62000 },
  { "name": "Site Water Tank (2000L)", "price": 7800 },
  { "name": "Site Fence Net (100 ft)", "price": 1450 },
  { "name": "Site Entry Gate (MS)", "price": 18500 },
  { "name": "Site Attendance Register", "price": 320 },
  { "name": "Site Log Book", "price": 180 },
  { "name": "Site Clock (Digital)", "price": 850 },
  { "name": "Site CCTV Camera (Hikvision)", "price": 2850 },
  { "name": "Site Wi-Fi Router", "price": 1450 },
  { "name": "Site Notice Board (Magnetic)", "price": 980 },
  { "name": "Site Whiteboard (3x4 ft)", "price": 1850 },
  { "name": "Site Chair (Plastic)", "price": 320 },
  { "name": "Site Table (Foldable)", "price": 1450 },


                  ],
                  "Fitness Equipments": [

      { "name": "Kore PVC Dumbbell Set (20kg)", "price": 1079 },
  { "name": "Symactive Adjustable Dumbbells (8kg)", "price": 729 },
  { "name": "Flexnest 24kg Adjustable Dumbbells (Pair)", "price": 15499 },
  { "name": "Cockatoo 3-in-1 Dumbbell Barbell Set", "price": 12999 },
  { "name": "Boldfit Hex Dumbbells (5kg x 2)", "price": 1599 },
  { "name": "AmazonBasics Dumbbell Grips", "price": 689 },
  { "name": "Bodyfit Dumbbell Set (16kg)", "price": 750 },
  { "name": "FitBox Sports Dumbbell Kit (20kg)", "price": 849 },
  { "name": "Lifelong PVC Dumbbell Set (20kg)", "price": 1499 },
  { "name": "SX Fitness Convertible Dumbbell Kit", "price": 836 },
  { "name": "Burnlab 6-in-1 Weight Training Kit", "price": 4355 },
  { "name": "Protoner Adjustable Dumbbells (14kg)", "price": 1220 },
  { "name": "WILORA 10kg Dumbbell Set", "price": 1289 },
  { "name": "KRX Rubber Dumbbells (10kg)", "price": 3488 },
  { "name": "Konark Rubber Dumbbells (10kg)", "price": 2105 },
  { "name": "Neulife Dumbbell Set (15kg)", "price": 1899 },
  { "name": "Aurion Dumbbells (PVC 10kg)", "price": 999 },
  { "name": "Stax X Dumbbell Kit (20kg)", "price": 1349 },
  { "name": "Glaze Dumbbells (Hex 5kg)", "price": 799 },
  { "name": "Credence Dumbbell Set (12kg)", "price": 1199 },
  { "name": "Adjustable Barbell Rod (4ft)", "price": 620 },
  { "name": "Curl Rod (3ft)", "price": 450 },
  { "name": "Weight Plates (2.5kg x 4)", "price": 980 },
  { "name": "Kettlebell (10kg)", "price": 1450 },
  { "name": "Resistance Bands (Set of 5)", "price": 620 },
  { "name": "Foam Roller (18 inch)", "price": 850 },
  { "name": "Yoga Mat (6mm)", "price": 499 },
  { "name": "Skipping Rope (Adjustable)", "price": 180 },
  { "name": "Hand Grip Strengthener", "price": 210 },
  { "name": "Ankle Weights (2kg pair)", "price": 850 },
  { "name": "Push-Up Bars (Steel)", "price": 320 },
  { "name": "Ab Roller Wheel", "price": 394 },
  { "name": "Tummy Trimmer (Double Spring)", "price": 291 },
  { "name": "Thigh Master Trainer", "price": 707 },
  { "name": "Hip & Pelvic Trainer", "price": 501 },
  { "name": "Adjustable Aerobic Stepper", "price": 1128 },
  { "name": "Gym Gloves (Leather)", "price": 352 },
  { "name": "Wrist Support Wraps", "price": 169 },
  { "name": "Weightlifting Belt (Medium)", "price": 620 },
  { "name": "Gym Bag (Waterproof)", "price": 850 },
  { "name": "Shaker Bottle (700ml)", "price": 180 },
  { "name": "Exercise Ball (65cm)", "price": 620 },
  { "name": "Balance Board", "price": 980 },
  { "name": "Stepper Machine (Manual)", "price": 1450 },
  { "name": "Mini Cycle Pedal Trainer", "price": 1850 },
  { "name": "Rowing Machine (Foldable)", "price": 6200 },
  { "name": "Elliptical Cross Trainer", "price": 17999 },
  { "name": "Treadmill (Fitkit 5.5HP)", "price": 16999 },
  { "name": "Stationary Bike (Smartbike)", "price": 15999 },
  { "name": "Multi-Gym Trainer (Home Use)", "price": 24500 },
  { "name": "Squat Rack (Adjustable)", "price": 14256 },
  { "name": "Weight Bench (Flat)", "price": 1999 },
  { "name": "Incline Bench (Adjustable)", "price": 2850 },
  { "name": "Decline Bench", "price": 3200 },
  { "name": "Leg Extension Machine", "price": 7800 },
  { "name": "Chest Press Machine", "price": 8500 },
  { "name": "Cable Pulley System", "price": 6200 },
  { "name": "Lat Pulldown Machine", "price": 9800 },
  { "name": "Smith Machine", "price": 18500 },
  { "name": "Power Tower", "price": 6200 },
  { "name": "Dip Station", "price": 3200 },
  { "name": "Pull-Up Bar (Wall Mounted)", "price": 1450 },
  { "name": "Battle Rope (9m)", "price": 1850 },
  { "name": "Medicine Ball (5kg)", "price": 850 },
  { "name": "Sandbag Trainer (20kg)", "price": 1450 },
  { "name": "Speed Ladder (6m)", "price": 620 },
  { "name": "Agility Cone Set (Pack of 20)", "price": 320 },
  { "name": "Boxing Gloves (12oz)", "price": 980 },
  { "name": "Punching Bag (Filled)", "price": 1850 },
  { "name": "Jump Trainer Harness", "price": 1450 },
  { "name": "Parallettes Bars", "price": 1850 },
  { "name": "Gym Timer Clock", "price": 2450 },

  { "name": "HRX Rubber Dumbbells (7.5kg)", "price": 1899 },
  { "name": "Durafit Hex Dumbbells (10kg)", "price": 2399 },
  { "name": "Powermax Adjustable Dumbbells (12kg)", "price": 2899 },
  { "name": "RASCO Dumbbell Set (PVC 15kg)", "price": 1499 },
  { "name": "RPM Fitness Dumbbells (Rubber 20kg)", "price": 3199 },
  { "name": "Rocket Sales Dumbbells (Cast Iron 25kg)", "price": 3499 },
  { "name": "StarX Dumbbell Kit (30kg)", "price": 3999 },
  { "name": "Ultron Dumbbells (Rubber Coated 5kg)", "price": 999 },
  { "name": "Vicky Transform Dumbbells (Hex 8kg)", "price": 1399 },
  { "name": "Neulife Dumbbells (Rubber 6kg)", "price": 1199 },
  { "name": "Boldfit Dumbbell Rack (3 Tier)", "price": 4850 },
  { "name": "Kore Dumbbell Stand (Vertical)", "price": 4200 },
  { "name": "Cockatoo Dumbbell Tree Rack", "price": 3850 },
  { "name": "FitBox Dumbbell Storage Rack", "price": 3999 },
  { "name": "Symactive Dumbbell Holder", "price": 2899 },
  { "name": "Flexnest Dumbbell Tray", "price": 2450 },
  { "name": "Bodyfit Dumbbell Organizer", "price": 3200 },
  { "name": "AmazonBasics Dumbbell Rack", "price": 3599 },
  { "name": "Glaze Dumbbell Shelf", "price": 3100 },
  { "name": "Stax X Dumbbell Tower", "price": 2750 },
  { "name": "Adjustable Weight Bench", "price": 2850 },
  { "name": "Flat Weight Bench", "price": 1999 },
  { "name": "Decline Weight Bench", "price": 3200 },
  { "name": "Incline Weight Bench", "price": 3450 },
  { "name": "Multi-Position Bench", "price": 3850 },
  { "name": "Foldable Workout Bench", "price": 2899 },
  { "name": "Olympic Weight Bench", "price": 6200 },
  { "name": "Bench Press Station", "price": 7800 },
  { "name": "Barbell Rack (Adjustable)", "price": 4200 },
  { "name": "Squat Stand (Heavy Duty)", "price": 4850 },
  { "name": "Power Cage (Full Rack)", "price": 12499 },
  { "name": "Smith Machine Combo", "price": 18500 },
  { "name": "Leg Press Machine", "price": 14500 },
  { "name": "Hack Squat Machine", "price": 15999 },
  { "name": "Calf Raise Machine", "price": 6200 },
  { "name": "Seated Row Machine", "price": 9800 },
  { "name": "Pec Deck Machine", "price": 8500 },
  { "name": "Cable Crossover Machine", "price": 18500 },
  { "name": "Functional Trainer Machine", "price": 24500 },
  { "name": "Vertical Knee Raise Station", "price": 6200 },
  { "name": "Dip Bar Station", "price": 3200 },
  { "name": "Pull-Up Tower", "price": 4850 },
  { "name": "Wall-Mounted Pull-Up Bar", "price": 1450 },
  { "name": "Ceiling-Mounted Pull-Up Bar", "price": 1850 },
  { "name": "Doorway Pull-Up Bar", "price": 850 },
  { "name": "Battle Rope Anchor", "price": 620 },
  { "name": "Medicine Ball Rack", "price": 3200 },
  { "name": "Kettlebell Rack", "price": 3999 },
  { "name": "Weight Plate Tree", "price": 2899 },
  { "name": "Barbell Holder Stand", "price": 2450 },
  { "name": "Resistance Band Anchor", "price": 850 },
  { "name": "Foam Roller Rack", "price": 1850 },
  { "name": "Yoga Mat Rack", "price": 1450 },
  { "name": "Gym Mirror Panel (4x6 ft)", "price": 6200 },
  { "name": "Wall Clock Timer (Digital)", "price": 2450 },
  { "name": "Bluetooth Speaker (Gym Use)", "price": 1850 },
  { "name": "Gym Flooring Mat (Interlocking)", "price": 1450 },
  { "name": "Rubber Gym Tiles (Pack of 4)", "price": 1850 },
  { "name": "Anti-Slip Mat Roll (10m)", "price": 3200 },
  { "name": "Wall Fan (Industrial)", "price": 2450 },
  { "name": "Air Purifier (Gym Room)", "price": 6200 },
  { "name": "Gym Sanitizer Dispenser", "price": 850 },
  { "name": "Towel Rack (Wall Mounted)", "price": 620 },
  { "name": "Locker Cabinet (6 Door)", "price": 7800 },
  { "name": "Changing Room Bench", "price": 3200 },
  { "name": "Water Dispenser (Hot & Cold)", "price": 4850 },
  { "name": "Gym Entry Scanner", "price": 1450 },
  { "name": "Membership Card Printer", "price": 6200 },


  { "name": "Cultsport Adjustable Dumbbells (40kg pair)", "price": 24499 },
  { "name": "Cultsport Compact Dumbbells (24kg pair)", "price": 15499 },
  { "name": "XTRIM Leather Gym Gloves", "price": 352 },
  { "name": "WELCARE Elliptical Cross Trainer", "price": 17999 },
  { "name": "Cockatoo CTM-05 Motorized Treadmill", "price": 14990 },
  { "name": "PRO365 Tummy Trimmer & Hand Gripper", "price": 399 },
  { "name": "Cockatoo CTM-101 Incline Treadmill", "price": 23990 },
  { "name": "KORE DM-HEXA Dumbbells Combo (5kg)", "price": 1499 },
  { "name": "Nivia Wrist Support Wraps", "price": 169 },
  { "name": "STARX 40kg PVC Weight Set", "price": 2765 },
  { "name": "DreamFit 30kg Home Gym Combo", "price": 2345 },
  { "name": "KRX 50kg PVC Gym Set", "price": 2628 },
  { "name": "BULLAR Power Squat Rack", "price": 14256 },
  { "name": "YMD Steel Plates Combo (10kg)", "price": 5514 },
  { "name": "Dr BWC Slimming Vibration Plate", "price": 8369 },
  { "name": "Bwc BWC101 Home Gym Combo", "price": 10182 },
  { "name": "AMAN FIT Convertible Dumbbells (12.5kg)", "price": 1288 },
  { "name": "KRIN PVC Dumbbell Plate Set (20kg)", "price": 1720 },
  { "name": "TheDumbbells Home Gym Combo (20kg)", "price": 3134 },
  { "name": "BULLAR Cast Iron Plates Set (10kg)", "price": 4965 },
  { "name": "WILORA Dumbbell Set (10kg)", "price": 1289 },
  { "name": "WILORA Convertible Dumbbells (12kg)", "price": 1418 },
  { "name": "Konark Rubber Dumbbells (10kg)", "price": 2105 },
  { "name": "KRX Rubber Plates (10kg)", "price": 3488 },
  { "name": "DreamFit 50kg Home Gym Combo", "price": 3188 },
  { "name": "JMB 30kg Gym Set", "price": 2297 },
  { "name": "WILORA 20kg PVC Gym Set", "price": 1432 },
  { "name": "STARX Multi Color Rubber Plates (30kg)", "price": 4896 },
  { "name": "Dr BWC Vibration Plate (35kg)", "price": 19794 },
  { "name": "KRX 40kg PVC Gym Set", "price": 2863 },
  { "name": "KRX 50kg PVC Gym Set", "price": 3242 },
  { "name": "Protoner Adjustable Dumbbells (14kg)", "price": 1220 },
  { "name": "STARX PVC Weight Set (20kg)", "price": 1541 },
  { "name": "KRX Metal Rubber Plates (10kg)", "price": 3488 },
  { "name": "BULLAR Home Gym Set (20kg)", "price": 4636 },
  { "name": "Bodyfit Convertible Dumbbells (16kg)", "price": 750 },
  { "name": "Flexnest Barbell + Dumbbells Combo", "price": 12999 },
  { "name": "Cockatoo 3-in-1 Dumbbell Set", "price": 12999 },
  { "name": "Symactive PVC Dumbbells (10kg)", "price": 549 },
  { "name": "Lifelong PVC Dumbbells (20kg)", "price": 1499 },
  { "name": "SX Fitness Convertible Dumbbells", "price": 836 },
  { "name": "FitBox Sports Dumbbell Kit (20kg)", "price": 849 },
  { "name": "AmazonBasics Thick Dumbbell Grips", "price": 689 },
  { "name": "FACTO POWER Hex Dumbbells (1kg x 2)", "price": 169 },
  { "name": "IRIS Fitness Convertible Dumbbells", "price": 899 },
  { "name": "OtG Adjustable Dumbbell Kit (20kg)", "price": 4599 },
  { "name": "Watson Dumbbell Set (12kg)", "price": 1869 },
  { "name": "Protoner PVC Dumbbells (20kg)", "price": 899 },
  { "name": "Bodyfit Dumbbells Set (10kg)", "price": 740 },
  { "name": "Symactive Dumbbells (8kg)", "price": 729 },
  { "name": "Flexnest Adjustable Dumbbells (24kg)", "price": 15499 },
  { "name": "Boldfit Hex Dumbbells (5kg x 2)", "price": 1599 },
  { "name": "Glaze Hex Dumbbells (5kg)", "price": 799 },
  { "name": "Credence Dumbbells (12kg)", "price": 1199 },
  { "name": "Stax X Dumbbell Kit (20kg)", "price": 1349 },
  { "name": "Aurion PVC Dumbbells (10kg)", "price": 999 },
  { "name": "Neulife Dumbbells (15kg)", "price": 1899 },
  { "name": "Vicky Transform Dumbbells (8kg)", "price": 1399 },
  { "name": "Ultron Rubber Dumbbells (5kg)", "price": 999 },
  { "name": "Rocket Sales Cast Iron Dumbbells (25kg)", "price": 3499 },
  { "name": "RASCO PVC Dumbbells (15kg)", "price": 1499 },
  { "name": "Durafit Hex Dumbbells (10kg)", "price": 2399 },
  { "name": "Powermax Adjustable Dumbbells (12kg)", "price": 2899 },
  { "name": "HRX Rubber Dumbbells (7.5kg)", "price": 1899 },
  { "name": "StarX Dumbbell Kit (30kg)", "price": 3999 },
  { "name": "Gym Insane Dumbbells Combo (15kg)", "price": 860 },
  { "name": "BULLAR Dumbbells Set (10kg)", "price": 1370 },
  { "name": "Lifelong Iron Adjustable Dumbbells", "price": 11999 },
  { "name": "SX Fitness Dumbbells & Barbell Set", "price": 836 },
  { "name": "FitBox Sports Intruder Dumbbells (20kg)", "price": 899 },
  { "name": "Flexnest Multi-Grip Dumbbells (19kg)", "price": 12999 },

  { "name": "Cultsport Smartbike Bari", "price": 15999 },
  { "name": "RPM Active1100DCM Treadmill", "price": 58499 },
  { "name": "Cult Apex Massage Chair", "price": 99999 },
  { "name": "Fitkit FT200M Treadmill", "price": 29999 },
  { "name": "Cult SmartStridePro Treadmill", "price": 77999 },
  { "name": "Cult WalkpadLuxe 5HP", "price": 23499 },
  { "name": "Cult SmartStrideElite AC Motor Treadmill", "price": 114999 },
  { "name": "Cult Smartcross Bern Elliptical Trainer", "price": 16499 },
  { "name": "Cult Smartbike Danville", "price": 23999 },
  { "name": "Cult Smartrun Carson Treadmill", "price": 41499 },
  { "name": "Cult Cultrun M5 Multimode Treadmill", "price": 49499 },
  { "name": "Cult Nirvana 4D Massage Chair", "price": 199999 },
  { "name": "Cult Serene Massage Chair", "price": 79999 },
  { "name": "Cult LUXE Massage Chair", "price": 124999 },
  { "name": "Cult Smartrun Davie Treadmill", "price": 67999 },
  { "name": "Cult Smartrun Dallas Treadmill", "price": 59999 },
  { "name": "Cult Cultrun M6 Nova Treadmill", "price": 54999 },
  { "name": "Cult Cultrun M4 Treadmill", "price": 29999 },
  { "name": "Cult Smartrun C2 Treadmill", "price": 33499 },
  { "name": "Cult SmartStrideSprint Treadmill", "price": 67999 },
  { "name": "Cult Smartbike Corby", "price": 16499 },
  { "name": "Cult Cult Pro 2HP Treadmill", "price": 13499 },
  { "name": "Cult RPM5000 DC Treadmill", "price": 29899 },
  { "name": "Cult SmartStrideSprint BLDC Treadmill", "price": 67999 },
  { "name": "Cult SmartStrideElite 8HP Treadmill", "price": 114999 },
  { "name": "Cult SmartStridePro BLDC Treadmill", "price": 77999 },
  { "name": "Cult Smartbike Danville Magnetic Resistance", "price": 23999 },
  { "name": "Cult Smartcross Bern Magnetic Elliptical", "price": 16499 },
  { "name": "Cult Smartbike Bari Max Weight 110kg", "price": 15999 },
  { "name": "Cult Smartbike Danville 130kg Capacity", "price": 23999 },
  { "name": "Cult SmartStridePro 18 Level Incline", "price": 77999 },
  { "name": "Cult SmartStrideElite 20 Level Incline", "price": 114999 },
  { "name": "Cult SmartStrideSprint 15 Level Incline", "price": 67999 },
  { "name": "Cult WalkpadLuxe Remote Access", "price": 23499 },
  { "name": "Cult Smartbike Corby Friction Resistance", "price": 16499 },
  { "name": "Cult Smartrun Carson 16kmph Speed", "price": 41499 },
  { "name": "Cult Smartrun Davie 20kmph Speed", "price": 67999 },
  { "name": "Cult Smartrun Dallas 20kmph Speed", "price": 59999 },
  { "name": "Cult Cultrun M6 Nova 18kmph Speed", "price": 54999 },
  { "name": "Cult Cultrun M4 14.8kmph Speed", "price": 29999 },
  { "name": "Cult Cultrun M5 18kmph Speed", "price": 49499 },
  { "name": "Cult Smartrun C2 16kmph Speed", "price": 33499 },
  { "name": "Cult SmartStrideElite 20kmph Speed", "price": 114999 },
  { "name": "Cult SmartStridePro 18kmph Speed", "price": 77999 },
  { "name": "Cult SmartStrideSprint 18kmph Speed", "price": 67999 },
  { "name": "Cult Smartbike Danville 100 Level Resistance", "price": 23999 },
  { "name": "Cult Smartcross Bern 8 Level Resistance", "price": 16499 },
  { "name": "Cult Smartbike Corby 8kg Flywheel", "price": 16499 },
  { "name": "Cult Smartbike Danville 6.5kg Flywheel", "price": 23999 },
  { "name": "Cult SmartStrideElite AC Motor", "price": 114999 },
  { "name": "Cult SmartStridePro BLDC Motor", "price": 77999 },
  { "name": "Cult SmartStrideSprint BLDC Motor", "price": 67999 },
  { "name": "Cult WalkpadLuxe Remote Control", "price": 23499 },
  { "name": "Cult Smartbike Bari Heart Rate Sensor", "price": 15999 },
  { "name": "Cult Smartbike Danville Adjustable Seat", "price": 23999 },
  { "name": "Cult Smartcross Bern Hand Pulse Sensor", "price": 16499 },
  { "name": "Cult SmartStrideElite Touch Screen", "price": 114999 },
  { "name": "Cult SmartStridePro LED Display", "price": 77999 },
  { "name": "Cult SmartStrideSprint AUX/USB", "price": 67999 },
  { "name": "Cult WalkpadLuxe Foldable Design", "price": 23499 },
  { "name": "Cult Smartbike Corby Compact Frame", "price": 16499 },
  { "name": "Cult Smartbike Danville Ergonomic Design", "price": 23999 },
  { "name": "Cult Smartcross Bern DIY Installation", "price": 16499 },
  { "name": "Cult SmartStrideElite Warranty 6 Months", "price": 114999 },
  { "name": "Cult SmartStridePro Warranty 6 Months", "price": 77999 },
  { "name": "Cult SmartStrideSprint Warranty 6 Months", "price": 67999 },
  { "name": "Cult WalkpadLuxe Warranty 6 Months", "price": 23499 },
  { "name": "Cult Smartbike Bari Warranty 6 Months", "price": 15999 },
  { "name": "Cult Smartbike Danville Warranty 6 Months", "price": 23999 },
  { "name": "Cult Smartcross Bern Warranty 6 Months", "price": 16499 },


                  ],
                  "Hardware, Pipes, sanitary ware and others": [
    
      { "name": "ALTON GRC3715 Bib Tap", "price": 1389 },
  { "name": "RSP Salon Faucet Set", "price": 1199 },
  { "name": "Jaquar Opal Prime Bathtub Spout", "price": 1686 },
  { "name": "ALTON ESA9215 Bib Cock", "price": 1175 },
  { "name": "RN PTMT 3-in-1 Wall Mixer", "price": 1469 },
  { "name": "Alton Bath Tub Spout with Button", "price": 1710 },
  { "name": "ANATOMIX Slim Brass Wall Mixer", "price": 1747 },
  { "name": "CLUB BOLLYWOOD Shower Adapter", "price": 1259 },
  { "name": "10X Brass Wall Mixer CP-9077", "price": 1496 },
  { "name": "ALTON AXN9450 Concealed Stop Cock", "price": 1282 },
  { "name": "iRiS 2-in-1 Wall Mixer Tap", "price": 1899 },
  { "name": "JAGGER JAG151 Wall Mixer", "price": 1899 },
  { "name": "Aquieen Bidet Spray Kit", "price": 1990 },
  { "name": "ANATOMIX Flora Wall Mixer", "price": 1747 },
  { "name": "RN RNG2019A19 Wall Mixer", "price": 1633 },
  { "name": "RN RNG2001A17 Double Lever Mixer", "price": 1169 },
  { "name": "Water Science SFU 717 Tap Filter", "price": 2395 },
  { "name": "Plantex Ceramic Wall Hung Commode", "price": 4199 },
  { "name": "Unique Creation Toilet Jet Spray", "price": 144 },
  { "name": "MICASHU Sink Strainer 11 cm", "price": 73 },
  { "name": "kridha Self-Adhesive Rack", "price": 102 },
  { "name": "clayplus One Piece Western Toilet", "price": 5899 },
  { "name": "PESCA NOVA Matte Black ABS Faucet", "price": 198 },
  { "name": "GLOXY Toothbrush Holder & Soap Dish", "price": 462 },
  { "name": "ARISSION Toilet Spray Jet", "price": 133 },
  { "name": "Prestige High Pressure Jet Spray", "price": 289 },
  { "name": "clayplus Floor Mounted Toilet", "price": 3599 },
  { "name": "Flipkart SmartBuy Corner Shelf", "price": 253 },
  { "name": "Rainflow Y-type Tank Filter", "price": 491 },
  { "name": "GLOXY Double Soap Dish", "price": 231 },
  { "name": "KAMAL Health Faucet Enigma", "price": 449 },
  { "name": "Unique Creation PVC Bibcock", "price": 160 },
  { "name": "Spazio Silicon Swivel Spout", "price": 646 },
  { "name": "VRPRIME Aluminium Corner Shelf", "price": 497 },
  { "name": "GLOXY Clear Soap Dish & Holder", "price": 308 },
  { "name": "Prestige SS Fusion Angle Valve", "price": 149 },
  { "name": "chirag Double Bowl Sink", "price": 4168 },
  { "name": "Prestige SS Towel Ring", "price": 149 },
  { "name": "Strength SDS-04 Towel Ring", "price": 68 },
  { "name": "kridha Iron Coated Rack", "price": 102 },
  { "name": "pizmo Double Soap Dish Shelf", "price": 613 },
  { "name": "KAMAL Sink Spray Dixy", "price": 749 },
  { "name": "ZenZone Adhesive Shelf Set", "price": 403 },
  { "name": "Prestige Jazz Swan Neck Tap", "price": 499 },
  { "name": "DRC Tap Mount Water Filter", "price": 54 },
  { "name": "KYASO Iron Wall Shelf 5-Tier", "price": 705 },
  { "name": "MAYUR ÖCICH Health Faucet HF-56", "price": 267 },
  { "name": "ProHome Brass Sink Faucet", "price": 689 },
  { "name": "KAMAL SPR-0784 Extension Spout", "price": 475 },
  { "name": "Kyari Galaxy ABS Shower", "price": 259 },
  { "name": "Prestige Drain Board Sink", "price": 2738 },
  { "name": "AKRIZA Movable Sink Faucet", "price": 177 },
  { "name": "clayplus Platinum Ceramic Closet", "price": 3299 },
  { "name": "VRPRIME Gold Shelf Rack", "price": 498 },
  { "name": "KYASO Iron Wall Shelf 2-Tier", "price": 236 },
  { "name": "kedarnath Adhesive Kitchen Rack", "price": 102 },
  { "name": "Rainflow Tank Filter 130 Micron", "price": 491 },
  { "name": "Prestige SS Towel Ring Fusion", "price": 149 },
  { "name": "GLOXY Acrylic Soap Dish", "price": 308 },
  { "name": "KAMAL Dixy Sink Spray", "price": 749 },
  { "name": "ZenZone Wall Shelf 2PCS", "price": 403 },
  { "name": "Prestige Swan Neck Basin Tap", "price": 499 },
  { "name": "DRC Water Filter Tap Mount", "price": 54 },
  { "name": "KYASO 5-Shelf Iron Rack", "price": 705 },
  { "name": "MAYUR HF-56 Health Faucet", "price": 267 },
  { "name": "ProHome Black Sink Faucet", "price": 689 },
  { "name": "KAMAL SPR-0784 Extension Pipe", "price": 475 },
  { "name": "Kyari ABS Shower Head", "price": 259 },
  { "name": "Prestige Drainboard Sink 37x18", "price": 2738 },
  { "name": "AKRIZA Anti Splash Faucet", "price": 177 },
  { "name": "clayplus Ceramic Water Closet", "price": 3299 },


  { "name": "Hindware F160013CP Health Faucet", "price": 719 },
  { "name": "Benelave Volga Pillar Tap", "price": 899 },
  { "name": "Benelave Volga Brass Wall Mixer", "price": 2719 },
  { "name": "Hindware F160027 ABS Faucet", "price": 562 },
  { "name": "Hindware ABS Rain Shower 100mm", "price": 689 },
  { "name": "Hindware Sleek Essence PVC Cistern", "price": 873 },
  { "name": "Hindware F160004CP Rain Shower Head", "price": 699 },
  { "name": "Hindware 3-Flow Polished Hand Shower", "price": 1590 },
  { "name": "Hindware Portable Handheld Bidet", "price": 2049 },
  { "name": "Hindware 5 Inch Overhead Shower", "price": 499 },
  { "name": "Hindware F160110CP Brisk Faucet", "price": 854 },
  { "name": "Benelave Multi-Purpose Shelf", "price": 698 },
  { "name": "Benelave Volga Bib Tap", "price": 839 },
  { "name": "Hindware 3-Layer Shelf", "price": 1598 },
  { "name": "Hindware F160194CP Health Faucet", "price": 1099 },
  { "name": "Hindware Ultra Thin Overhead Shower", "price": 1449 },
  { "name": "DAITORY Wall Shelves 3 Set", "price": 241 },
  { "name": "nariya Wall Rack Organizer", "price": 97 },
  { "name": "QXORE Hanging Shelf Rack", "price": 149 },
  { "name": "GRIVAN Mirror Cabinet", "price": 1299 },
  { "name": "Mocksh Vignette Sink Tap", "price": 498 },
  { "name": "ArrayStyle Pop-Up Sink Strainer", "price": 116 },
  { "name": "Frap Sticker Mounted Corner Shelf", "price": 271 },
  { "name": "SSUCA Push Down Sink Strainer", "price": 54 },
  { "name": "Ramya Premium Rain Shower Head", "price": 288 },
  { "name": "Mocksh Turbo Angle Valve", "price": 724 },
  { "name": "aerowell POLO Sink Cock", "price": 150 },
  { "name": "KAMAL Long Body Bib Tap (Set of 2)", "price": 1349 },
  { "name": "Plantex One Piece Commode", "price": 6769 },
  { "name": "Rab Screw Shelf Button (Pack of 12)", "price": 239 },
  { "name": "droptech PVC Sink Tap", "price": 101 },
  { "name": "GOLDEN LIKE Foldable Rack", "price": 373 },
  { "name": "Prestige KHL21 Health Faucet", "price": 299 },
  { "name": "Hindware Side Handle Flush Tank", "price": 899 },
  { "name": "Citrine Towel Hanger 24 inch", "price": 279 },
  { "name": "DR CARTRIDGE POINT Kitchen Sink", "price": 5910 },
  { "name": "iSTAR Mirror Cabinet Organizer", "price": 1191 },
  { "name": "olwick Sink Strainer (Set of 4)", "price": 219 },
  { "name": "Cherry Tap Extender", "price": 233 },
  { "name": "QXORE Bathroom Shelf + Soap Stand", "price": 258 },
  { "name": "Kyari Aerator Foam Flow Tap (Pack of 40)", "price": 150 },
  { "name": "clayplus Ceramic Floor Mounted Toilet", "price": 4842 },
  { "name": "droptech Red Crystal Bib Cock (Pack of 4)", "price": 121 },
  { "name": "Spazio Dual Flow Hose Faucet", "price": 483 },
  { "name": "Water Science CLEO Tap Filter", "price": 1385 },
  { "name": "Bowoze Self-Adhesive Rack", "price": 118 },
  { "name": "Unique Creation PVC Bibcock", "price": 139 },
  { "name": "Hindware Italian Collection Shower Head", "price": 699 },
  { "name": "Benelave Chrome Basin Tap", "price": 899 },
  { "name": "Hindware Chrome Wall Mixer", "price": 2719 },
  { "name": "Hindware Italian Collection Bidet", "price": 2049 },
  { "name": "Hindware Chrome Hand Shower", "price": 1590 },
  { "name": "Hindware Chrome Faucet F160027", "price": 562 },
  { "name": "Hindware Chrome Rain Shower F160004CP", "price": 699 },
  { "name": "Hindware Chrome Cistern 511209", "price": 873 },
  { "name": "Hindware Chrome Health Faucet F160013CP", "price": 719 },
  { "name": "Hindware Chrome Shower Head ABS", "price": 689 },
  { "name": "Hindware Chrome Wall Mixer F160203Cp", "price": 2719 },
  { "name": "Hindware Chrome Bib Tap Volga", "price": 839 },
  { "name": "Hindware Chrome Wall Mixer Volga", "price": 2719 },
  { "name": "Hindware Chrome Faucet F160110CP", "price": 854 },
  { "name": "Hindware Chrome Shower Head 5 Inch", "price": 499 },
  { "name": "Hindware Chrome Health Faucet F160194CP", "price": 1099 },
  { "name": "Hindware Chrome Overhead Shower", "price": 1449 },
  { "name": "Hindware Chrome Wall Mixer F160027", "price": 562 },
  { "name": "Hindware Chrome Faucet F160004CP", "price": 699 },
  { "name": "Hindware Chrome Bidet Portable", "price": 2049 },
  { "name": "Hindware Chrome Hand Shower F160203Cp", "price": 1590 },
  { "name": "Hindware Chrome Cistern Sleek Essence", "price": 873 },


  { "name": "Cera Garnet Wall Mixer", "price": 1899 },
  { "name": "Parryware Alpha Bib Tap", "price": 749 },
  { "name": "Cera Ceramic Wall Hung Closet", "price": 5299 },
  { "name": "Parryware Cascade Health Faucet", "price": 599 },
  { "name": "Cera Brass Swan Neck Tap", "price": 899 },
  { "name": "Parryware Slimline Overhead Shower", "price": 799 },
  { "name": "Cera Concealed Stop Cock", "price": 1125 },
  { "name": "Parryware PVC Cistern Tank", "price": 999 },
  { "name": "Cera Bidet Spray Kit", "price": 1299 },
  { "name": "Parryware Wall Mixer with L-Bend", "price": 1799 },
  { "name": "Cera Ceramic Floor Mounted Closet", "price": 4599 },
  { "name": "Parryware Angle Valve Chrome", "price": 349 },
  { "name": "Cera ABS Hand Shower", "price": 699 },
  { "name": "Parryware Swan Neck Basin Tap", "price": 849 },
  { "name": "Cera Wall Shelf with Soap Dish", "price": 499 },
  { "name": "Parryware Mirror Cabinet Organizer", "price": 1199 },
  { "name": "Cera Chrome Bib Cock", "price": 799 },
  { "name": "Parryware Ceramic Wash Basin", "price": 1899 },
  { "name": "Cera Chrome Basin Mixer", "price": 1499 },
  { "name": "Parryware Chrome Shower Arm", "price": 299 },
  { "name": "Cera Wall Mounted Toothbrush Holder", "price": 399 },
  { "name": "Parryware Chrome Sink Faucet", "price": 999 },
  { "name": "Cera Chrome Extension Spout", "price": 499 },
  { "name": "Parryware Chrome Bidet Spray", "price": 699 },
  { "name": "Cera Chrome Towel Ring", "price": 299 },
  { "name": "Parryware Chrome Soap Dish", "price": 349 },
  { "name": "Cera Chrome Shower Head", "price": 899 },
  { "name": "Parryware Chrome Wall Mixer", "price": 1699 },
  { "name": "Cera Chrome Health Faucet", "price": 799 },
  { "name": "Parryware Chrome Basin Mixer", "price": 1399 },
  { "name": "Cera Chrome Wall Mixer with Bend", "price": 1799 },
  { "name": "Parryware Chrome Bib Tap", "price": 749 },
  { "name": "Cera Chrome Sink Tap", "price": 999 },
  { "name": "Parryware Chrome Extension Pipe", "price": 499 },
  { "name": "Cera Chrome Shower Arm", "price": 299 },
  { "name": "Parryware Chrome Toothbrush Holder", "price": 399 },
  { "name": "Cera Chrome Soap Dish", "price": 349 },
  { "name": "Parryware Chrome Towel Ring", "price": 299 },
  { "name": "Cera Chrome Bidet Spray", "price": 699 },
  { "name": "Parryware Chrome Health Faucet", "price": 799 },
  { "name": "Cera Chrome Wall Mixer", "price": 1699 },
  { "name": "Parryware Chrome Shower Head", "price": 899 },
  { "name": "Cera Chrome Basin Mixer", "price": 1399 },
  { "name": "Parryware Chrome Wall Mixer with Bend", "price": 1799 },
  { "name": "Cera Chrome Bib Tap", "price": 749 },
  { "name": "Parryware Chrome Sink Tap", "price": 999 },
  { "name": "Cera Chrome Extension Pipe", "price": 499 },
  { "name": "Parryware Chrome Shower Arm", "price": 299 },
  { "name": "Cera Chrome Toothbrush Holder", "price": 399 },
  { "name": "Parryware Chrome Soap Dish", "price": 349 },
  { "name": "Cera Chrome Towel Ring", "price": 299 },
  { "name": "Parryware Chrome Bidet Spray", "price": 699 },
  { "name": "Cera Chrome Health Faucet", "price": 799 },
  { "name": "Parryware Chrome Wall Mixer", "price": 1699 },
  { "name": "Cera Chrome Shower Head", "price": 899 },
  { "name": "Parryware Chrome Basin Mixer", "price": 1399 },
  { "name": "Cera Chrome Wall Mixer with Bend", "price": 1799 },
  { "name": "Parryware Chrome Bib Tap", "price": 749 },
  { "name": "Cera Chrome Sink Tap", "price": 999 },
  { "name": "Parryware Chrome Extension Pipe", "price": 499 },
  { "name": "Cera Chrome Shower Arm", "price": 299 },
  { "name": "Parryware Chrome Toothbrush Holder", "price": 399 },
  { "name": "Cera Chrome Soap Dish", "price": 349 },
  { "name": "Parryware Chrome Towel Ring", "price": 299 },
  { "name": "Cera Chrome Bidet Spray", "price": 699 },
  { "name": "Parryware Chrome Health Faucet", "price": 799 },
  { "name": "Cera Chrome Wall Mixer", "price": 1699 },
  { "name": "Parryware Chrome Shower Head", "price": 899 },


  { "name": "Jaquar Florentine Wall Mixer", "price": 2899 },
  { "name": "Jaquar Continental Bib Tap", "price": 799 },
  { "name": "Jaquar Health Faucet with Hose", "price": 999 },
  { "name": "Jaquar Rain Shower Head 200mm", "price": 1499 },
  { "name": "Jaquar Concealed Stop Cock", "price": 1199 },
  { "name": "Jaquar Swan Neck Basin Tap", "price": 899 },
  { "name": "Jaquar Wall Mounted Shower Arm", "price": 499 },
  { "name": "Jaquar Chrome Soap Dish", "price": 349 },
  { "name": "Jaquar Chrome Towel Ring", "price": 299 },
  { "name": "Jaquar Chrome Toothbrush Holder", "price": 399 },
  { "name": "Jaquar Chrome Extension Pipe", "price": 499 },
  { "name": "Jaquar Chrome Bidet Spray", "price": 699 },
  { "name": "Jaquar Chrome Sink Tap", "price": 999 },
  { "name": "Jaquar Chrome Basin Mixer", "price": 1399 },
  { "name": "Jaquar Chrome Wall Mixer", "price": 1699 },
  { "name": "Jaquar Chrome Shower Head", "price": 899 },
  { "name": "Jaquar Chrome Health Faucet", "price": 799 },
  { "name": "Jaquar Chrome Wall Mixer with Bend", "price": 1799 },
  { "name": "Jaquar Chrome Bib Tap", "price": 749 },
  { "name": "Jaquar Chrome Shower Arm", "price": 299 },
  { "name": "Jaquar Chrome Toothbrush Holder", "price": 399 },
  { "name": "Jaquar Chrome Soap Dish", "price": 349 },
  { "name": "Jaquar Chrome Towel Ring", "price": 299 },
  { "name": "Jaquar Chrome Bidet Spray", "price": 699 },
  { "name": "Jaquar Chrome Health Faucet", "price": 799 },
  { "name": "Jaquar Chrome Wall Mixer", "price": 1699 },
  { "name": "Jaquar Chrome Shower Head", "price": 899 },
  { "name": "Jaquar Chrome Basin Mixer", "price": 1399 },
  { "name": "Jaquar Chrome Wall Mixer with Bend", "price": 1799 },
  { "name": "Jaquar Chrome Bib Tap", "price": 749 },
  { "name": "Jaquar Chrome Sink Tap", "price": 999 },
  { "name": "Jaquar Chrome Extension Pipe", "price": 499 },
  { "name": "Jaquar Chrome Shower Arm", "price": 299 },
  { "name": "Jaquar Chrome Toothbrush Holder", "price": 399 },
  { "name": "Jaquar Chrome Soap Dish", "price": 349 },
  { "name": "Jaquar Chrome Towel Ring", "price": 299 },
  { "name": "Jaquar Chrome Bidet Spray", "price": 699 },
  { "name": "Jaquar Chrome Health Faucet", "price": 799 },
  { "name": "Jaquar Chrome Wall Mixer", "price": 1699 },
  { "name": "Jaquar Chrome Shower Head", "price": 899 },
  { "name": "Jaquar Chrome Basin Mixer", "price": 1399 },
  { "name": "Jaquar Chrome Wall Mixer with Bend", "price": 1799 },
  { "name": "Jaquar Chrome Bib Tap", "price": 749 },
  { "name": "Jaquar Chrome Sink Tap", "price": 999 },
  { "name": "Jaquar Chrome Extension Pipe", "price": 499 },
  { "name": "Jaquar Chrome Shower Arm", "price": 299 },
  { "name": "Jaquar Chrome Toothbrush Holder", "price": 399 },
  { "name": "Jaquar Chrome Soap Dish", "price": 349 },
  { "name": "Jaquar Chrome Towel Ring", "price": 299 },
  { "name": "Jaquar Chrome Bidet Spray", "price": 699 },
  { "name": "Jaquar Chrome Health Faucet", "price": 799 },
  { "name": "Jaquar Chrome Wall Mixer", "price": 1699 },
  { "name": "Jaquar Chrome Shower Head", "price": 899 },
  { "name": "Jaquar Chrome Basin Mixer", "price": 1399 },
  { "name": "Jaquar Chrome Wall Mixer with Bend", "price": 1799 },
  { "name": "Jaquar Chrome Bib Tap", "price": 749 },
  { "name": "Jaquar Chrome Sink Tap", "price": 999 },
  { "name": "Jaquar Chrome Extension Pipe", "price": 499 },
  { "name": "Jaquar Chrome Shower Arm", "price": 299 },
  { "name": "Jaquar Chrome Toothbrush Holder", "price": 399 },
  { "name": "Jaquar Chrome Soap Dish", "price": 349 },
  { "name": "Jaquar Chrome Towel Ring", "price": 299 },
  { "name": "Jaquar Chrome Bidet Spray", "price": 699 },
  { "name": "Jaquar Chrome Health Faucet", "price": 799 },
  { "name": "Jaquar Chrome Wall Mixer", "price": 1699 },


  { "name": "ZAPATOZ Stainless Steel Sink Grid", "price": 349 },
  { "name": "Kohler K-98359IN-CP Rain Shower", "price": 2899 },
  { "name": "Delta Faucet Wall Mount Bib Tap", "price": 999 },
  { "name": "Grohe Eurosmart Basin Mixer", "price": 3199 },
  { "name": "American Standard Concealed Valve", "price": 1899 },
  { "name": "TOTO Wall Hung Toilet Bowl", "price": 6499 },
  { "name": "Duravit Ceramic Wash Basin", "price": 2899 },
  { "name": "Hansgrohe Overhead Shower 240mm", "price": 3599 },
  { "name": "Roca Chrome Bidet Faucet", "price": 1499 },
  { "name": "Vitra Swan Neck Tap", "price": 899 },
  { "name": "Kerovit Dual Flush Cistern", "price": 1199 },
  { "name": "Somany Ceramic Floor Closet", "price": 4999 },
  { "name": "Essco Angle Valve Chrome Finish", "price": 399 },
  { "name": "Cotto ABS Health Faucet", "price": 799 },
  { "name": "Viega Pipe Connector 1/2 inch", "price": 199 },
  { "name": "Astral CPVC Pipe 3m", "price": 249 },
  { "name": "Finolex PVC Pipe 2 inch", "price": 189 },
  { "name": "Supreme UPVC Elbow Joint", "price": 89 },
  { "name": "Ashirvad CPVC Tee Connector", "price": 99 },
  { "name": "Prince Pipe Reducer 3/4 inch", "price": 79 },
  { "name": "Kisan Pipe End Cap", "price": 59 },
  { "name": "Legrand Chrome Shower Mixer", "price": 1799 },
  { "name": "Zoloto Brass Ball Valve", "price": 299 },
  { "name": "Jindal Stainless Steel Sink", "price": 2399 },
  { "name": "Nirali Granite Kitchen Sink", "price": 3299 },
  { "name": "Anupam SS Sink with Drainboard", "price": 2899 },
  { "name": "Blanco Ceramic Basin", "price": 2199 },
  { "name": "Kohler Toilet Seat Cover", "price": 899 },
  { "name": "Jaquar Chrome Shower Panel", "price": 4999 },
  { "name": "Parryware Wall Hung Basin", "price": 1899 },
  { "name": "Cera Dual Flow Sink Mixer", "price": 1599 },
  { "name": "Hindware Wall Mounted Tap", "price": 799 },
  { "name": "Benelave Chrome Basin Tap", "price": 899 },
  { "name": "ALTON Brass Shower Arm", "price": 499 },
  { "name": "Prestige SS Towel Rack", "price": 699 },
  { "name": "KAMAL ABS Soap Dispenser", "price": 349 },
  { "name": "Flipkart SmartBuy Shower Curtain", "price": 299 },
  { "name": "ZenZone Bathroom Shelf 3-Tier", "price": 599 },
  { "name": "Plantex Stainless Steel Shelf", "price": 699 },
  { "name": "GLOXY Chrome Toothbrush Stand", "price": 399 },
  { "name": "Rainflow Tank Filter 100 Micron", "price": 449 },
  { "name": "DRC Tap Filter Cartridge", "price": 199 },
  { "name": "Water Science CLEO Shower Filter", "price": 1499 },
  { "name": "Kyari ABS Shower Arm", "price": 259 },
  { "name": "MAYUR HF-57 Health Faucet", "price": 289 },
  { "name": "ProHome Sink Tap Black Finish", "price": 699 },
  { "name": "KAMAL SPR-0785 Extension Pipe", "price": 499 },
  { "name": "AKRIZA Flexible Sink Faucet", "price": 199 },
  { "name": "clayplus Ceramic Wall Closet", "price": 3699 },
  { "name": "VRPRIME Corner Shelf Gold", "price": 499 },
  { "name": "KYASO Iron Shelf 3-Tier", "price": 399 },
  { "name": "kedarnath Adhesive Rack Black", "price": 109 },
  { "name": "Mocksh Brass Sink Mixer", "price": 849 },
  { "name": "ArrayStyle Sink Strainer Set", "price": 129 },
  { "name": "SSUCA Push Sink Strainer", "price": 59 },
  { "name": "Ramya Rain Shower 6x6", "price": 299 },
  { "name": "Mocksh Turbo Valve Chrome", "price": 749 },
  { "name": "aerowell POLO Sink Mixer", "price": 159 },
  { "name": "Rab Shelf Button Pack of 12", "price": 249 },
  { "name": "droptech PVC Sink Tap", "price": 109 },
  { "name": "GOLDEN LIKE Foldable Rack", "price": 389 },
  { "name": "Prestige KHL22 Health Faucet", "price": 319 },
  { "name": "Citrine SS Towel Hanger", "price": 289 },
  { "name": "DR CARTRIDGE POINT Sink 36x18", "price": 5799 },
  { "name": "iSTAR Mirror Cabinet White", "price": 1299 },
  { "name": "olwick Sink Strainer 3-Pack", "price": 229 },
  { "name": "Cherry Tap Extender 360°", "price": 239 },
  { "name": "QXORE Shelf + Soap Stand Set", "price": 269 },
  { "name": "Kyari Foam Flow Tap Pack of 20", "price": 179 },
  { "name": "clayplus Ceramic Closet 105", "price": 4999 },


  { "name": "Droptech PVC Sink Cock", "price": 173 },
  { "name": "MONIT Nozzle Bib Cock", "price": 130 },
  { "name": "Techhark ABS Multi-Use Tap", "price": 199 },
  { "name": "Jogi PVC Water Tap", "price": 189 },
  { "name": "RN Bib Cock Foam Flow RNG2009B32", "price": 369 },
  { "name": "Imaashi Turkey Nozzle Bib Cock", "price": 245 },
  { "name": "BATH GURU Turkey Bib Cock (Pack of 12)", "price": 599 },
  { "name": "House Tools Splash Faucet Nozzle", "price": 99 },
  { "name": "RN PTMT Faucet Supernova RNSUP09B32", "price": 303 },
  { "name": "Polo PVC Bibcock Water Tap", "price": 75 },
  { "name": "Cossimo Polo Long Body Bib Cock (Pack of 6)", "price": 259 },
  { "name": "LIPKA Nobel Bib Cock", "price": 165 },
  { "name": "RN PTMT Swan Neck Tap RNVIP09B09", "price": 799 },
  { "name": "RN PTMT Pillar Cock RNABP09B06", "price": 510 },
  { "name": "Jogi Royal Bib Taps (Set of 4)", "price": 320 },
  { "name": "RN PTMT Basin Faucet RNSAF22F02", "price": 279 },
  { "name": "SBD Swan Neck Sink Tap", "price": 284 },
  { "name": "MONIT Washing Machine Tap", "price": 199 },
  { "name": "Konvio Neer RO Tap (Set of 4)", "price": 249 },
  { "name": "iSTAR PTMT Bib Cock", "price": 349 },
  { "name": "LIPKA Designo Swan Neck Faucet", "price": 297 },
  { "name": "MONIT Eco Angle Cock", "price": 279 },
  { "name": "MONIT ABS Swan Neck EPC1", "price": 249 },
  { "name": "NEW WARE Sink Cock Bib Tap", "price": 509 },
  { "name": "G Shri Ganesh Bib Cock (Set of 12)", "price": 360 },
  { "name": "New Ware PVC Bib Cock (3/4\")", "price": 199 },
  { "name": "LIPKA Grand Nozzle Bib Cock", "price": 176 },
  { "name": "RN PTMT Long Body Tap RNVIR09B35", "price": 449 },
  { "name": "BATH GURU Brass Nozzle Bib Cock", "price": 251 },
  { "name": "IONIX Flexible Sink Faucet", "price": 73 },
  { "name": "Sparsh Pearl LPR-1281 Bibcock", "price": 280 },
  { "name": "LIPKA Grand Bib Tap Two Way", "price": 294 },
  { "name": "Unique Creation PVC Bibcock", "price": 160 },
  { "name": "Spazio Silicon Swivel Spout", "price": 646 },
  { "name": "KAMAL Health Faucet Enigma", "price": 449 },
  { "name": "Prestige SS Fusion Angle Valve", "price": 149 },
  { "name": "ProHome Brass Sink Faucet", "price": 689 },
  { "name": "KAMAL SPR-0784 SS Extension", "price": 475 },
  { "name": "Kyari Galaxy ABS Shower", "price": 259 },
  { "name": "AKRIZA Anti Splash Faucet", "price": 177 },
  { "name": "clayplus Platinum Ceramic Closet", "price": 3299 },
  { "name": "VRPRIME Bathroom Shelf Rack", "price": 498 },
  { "name": "KYASO Iron Wall Shelf", "price": 236 },
  { "name": "kedarnath Kitchen Shelf", "price": 102 },
  { "name": "Prestige Brass Swan Neck Tap", "price": 499 },
  { "name": "DRC Tap Mount Water Filter", "price": 54 },
  { "name": "MAYUR ÖCICH Health Faucet HF-56", "price": 267 },
  { "name": "ZenZone Adhesive Shelf", "price": 403 },
  { "name": "Flipkart SmartBuy Corner Shelf", "price": 253 },
  { "name": "Rainflow Y-type Tank Filter", "price": 491 },
  { "name": "GLOXY Double Soap Dish", "price": 231 },
  { "name": "ARISSION Toilet Spray Jet", "price": 133 },
  { "name": "MICASHU Sink Strainer", "price": 73 },
  { "name": "Plantex Ceramic Wall Hung Commode", "price": 4199 },
  { "name": "Water Science SFU 717 Tap Mount", "price": 2395 },
  { "name": "clayplus One Piece Western Toilet", "price": 5899 },
  { "name": "PESCA NOVA ABS Faucet", "price": 198 },
  { "name": "GLOXY Toothbrush Holder", "price": 462 },
  { "name": "kridha Iron Coating Rack", "price": 102 },
  { "name": "Prestige SS Towel Ring", "price": 149 },
  { "name": "Strength SDS-04 Towel Ring", "price": 68 },
  { "name": "pizmo Double Soap Dish", "price": 613 },
  { "name": "KAMAL Sink Spray Dixy", "price": 749 },
  { "name": "clayplus Floor Mounted Toilet", "price": 3599 },
  { "name": "Flipkart SmartBuy Wall Sticker Shelf", "price": 253 },
  { "name": "Unique Creation Jet Spray", "price": 144 },
  { "name": "Plantex Ceramic Wall Hung Toilet", "price": 4199 },
  { "name": "Water Science SFU 717 Cartridge Tap", "price": 2395 },
                 

    { "name": "Other Service", "price": 5000 },

                  ],
                  "Bakery": [

    
  { "name": "White Bread", "price": 30 },
  { "name": "Whole Wheat Bread", "price": 35 },
  { "name": "Multigrain Bread", "price": 40 },
  { "name": "Milk Bread", "price": 32 },
  { "name": "Brown Bread", "price": 38 },
  { "name": "Garlic Bread", "price": 45 },
  { "name": "Cheese Garlic Bread", "price": 55 },
  { "name": "Oat Bread", "price": 42 },
  { "name": "Honey Wheat Bread", "price": 45 },
  { "name": "Sourdough Bread", "price": 50 },
  { "name": "Rye Bread", "price": 48 },
  { "name": "French Bread", "price": 40 },
  { "name": "Italian Bread", "price": 42 },
  { "name": "Baguette", "price": 35 },
  { "name": "Ciabatta", "price": 46 },
  { "name": "Focaccia", "price": 50 },
  { "name": "Corn Bread", "price": 38 },
  { "name": "Potato Bread", "price": 40 },
  { "name": "Banana Bread", "price": 55 },
  { "name": "Pumpkin Bread", "price": 60 },
  { "name": "Zucchini Bread", "price": 58 },
  { "name": "Sweet Bread", "price": 35 },
  { "name": "Butter Bread", "price": 37 },
  { "name": "Soft Roll Bread", "price": 30 },
  { "name": "Mini Loaf Bread", "price": 28 },
  { "name": "Pullman Bread", "price": 34 },
  { "name": "Vienna Bread", "price": 44 },
  { "name": "Bagel Bread", "price": 32 },
  { "name": "Pretzel Bread", "price": 36 },
  { "name": "Crusty Bread", "price": 39 },
  { "name": "Soft Crust Bread", "price": 34 },
  { "name": "Kaiser Roll", "price": 30 },
  { "name": "Brioche Bread", "price": 55 },
  { "name": "Pita Bread", "price": 35 },
  { "name": "Naan Bread", "price": 33 },
  { "name": "Tandoori Bread", "price": 36 },
  { "name": "Kulcha Bread", "price": 34 },
  { "name": "Flatbread", "price": 32 },
  { "name": "Turmeric Bread", "price": 38 },
  { "name": "Spinach Bread", "price": 40 },
  { "name": "Tomato Basil Bread", "price": 42 },
  { "name": "Herb Bread", "price": 44 },
  { "name": "Jalapeño Cheese Bread", "price": 52 },
  { "name": "Onion Bread", "price": 39 },
  { "name": "Coconut Bread", "price": 48 },
  { "name": "Chocolate Chip Bread", "price": 60 },
  { "name": "Carrot Bread", "price": 50 },
  { "name": "Raisin Bread", "price": 54 },
  { "name": "Fruit Bread", "price": 56 },
  { "name": "Date Nut Bread", "price": 58 },
  { "name": "Walnut Bread", "price": 52 },
  { "name": "Almond Bread", "price": 56 },
  { "name": "Cashew Bread", "price": 58 },
  { "name": "Pine Nut Bread", "price": 60 },
  { "name": "Sesame Bread", "price": 44 },
  { "name": "Sunflower Seed Bread", "price": 46 },
  { "name": "Flax Seed Bread", "price": 48 },
  { "name": "Chia Seed Bread", "price": 50 },
  { "name": "Quinoa Bread", "price": 52 },
  { "name": "Barley Bread", "price": 45 },
  { "name": "Millet Bread", "price": 42 },
  { "name": "Ragi Bread", "price": 40 },
  { "name": "Soy Bread", "price": 43 },
  { "name": "Protein Bread", "price": 55 },
  { "name": "Low-carb Bread", "price": 58 },
  { "name": "High-fiber Bread", "price": 54 },
  { "name": "Gluten-Free White Bread", "price": 60 },
  { "name": "Gluten-Free Brown Bread", "price": 62 },
  { "name": "Keto Bread", "price": 65 },
  { "name": "Vegan Bread", "price": 50 },
  { "name": "Organic Wheat Bread", "price": 48 },
  { "name": "Artisan Bread", "price": 52 },
  { "name": "Cracked Wheat Bread", "price": 46 },
  { "name": "Methi Bread", "price": 42 },



  
  { "name": "Chocolate Cake", "price": 300 },
  { "name": "Vanilla Cake", "price": 280 },
  { "name": "Black Forest Cake", "price": 350 },
  { "name": "Red Velvet Cake", "price": 370 },
  { "name": "Pineapple Cake", "price": 320 },
  { "name": "Strawberry Cake", "price": 330 },
  { "name": "Butter Scotch Cake", "price": 340 },
  { "name": "Coffee Cake", "price": 310 },
  { "name": "Mango Cake", "price": 325 },
  { "name": "Blueberry Cake", "price": 345 },
  { "name": "Raspberry Cake", "price": 355 },
  { "name": "Lemon Cake", "price": 300 },
  { "name": "Carrot Cake", "price": 310 },
  { "name": "Banana Cake", "price": 295 },
  { "name": "Coconut Cake", "price": 315 },
  { "name": "Marble Cake", "price": 330 },
  { "name": "Cheesecake", "price": 400 },
  { "name": "Chocolate Fudge Cake", "price": 375 },
  { "name": "Swiss Roll Cake", "price": 350 },
  { "name": "Opera Cake", "price": 425 },
  { "name": "Funfetti Cake", "price": 305 },
  { "name": "Tiramisu Cake", "price": 420 },
  { "name": "Hazelnut Cake", "price": 385 },
  { "name": "Almond Cake", "price": 360 },
  { "name": "Walnut Cake", "price": 365 },
  { "name": "Cashew Cake", "price": 370 },
  { "name": "Fruit Cake", "price": 340 },
  { "name": "Dry Fruit Cake", "price": 355 },
  { "name": "Ice Cream Cake", "price": 400 },
  { "name": "Molten Lava Cake", "price": 390 },
  { "name": "Sponge Cake", "price": 280 },
  { "name": "Honey Cake", "price": 310 },
  { "name": "Orange Cake", "price": 320 },
  { "name": "Choco Mint Cake", "price": 350 },
  { "name": "Choco Truffle Cake", "price": 375 },
  { "name": "Mousse Cake", "price": 400 },
  { "name": "Baked Yogurt Cake", "price": 385 },
  { "name": "Custard Cake", "price": 360 },
  { "name": "Layered Cake", "price": 340 },
  { "name": "Rose Flavored Cake", "price": 330 },
  { "name": "Saffron Cake", "price": 395 },
  { "name": "Date Cake", "price": 310 },
  { "name": "Kiwi Cake", "price": 325 },
  { "name": "Choco Cherry Cake", "price": 355 },
  { "name": "Yogurt Berry Cake", "price": 370 },
  { "name": "Choco Orange Cake", "price": 345 },
  { "name": "Berry Blast Cake", "price": 365 },
  { "name": "Cupcake Assorted Box", "price": 220 },
  { "name": "Mini Cake Bites", "price": 250 },
  { "name": "Gluten-Free Cake", "price": 410 },
  { "name": "Sugar-Free Chocolate Cake", "price": 395 },
  { "name": "Eggless Vanilla Cake", "price": 290 },
  { "name": "Eggless Chocolate Cake", "price": 310 },
  { "name": "Keto Cake", "price": 420 },
  { "name": "Vegan Cake", "price": 400 },
  { "name": "Birthday Cake Classic", "price": 350 },
  { "name": "Anniversary Cake Special", "price": 360 },
  { "name": "Photo Print Cake", "price": 470 },
  { "name": "Designer Fondant Cake", "price": 500 },
  { "name": "Theme Cake", "price": 490 },
  { "name": "3D Cake", "price": 550 },
  { "name": "Emoji Cake", "price": 440 },
  { "name": "Rainbow Cake", "price": 390 },
  { "name": "Gemstone Cake", "price": 410 },
  { "name": "Peach Cake", "price": 330 },
  { "name": "Choco Almond Crunch Cake", "price": 365 },
  { "name": "Choco Hazelnut Cake", "price": 370 },
  { "name": "Cookies & Cream Cake", "price": 380 },
  { "name": "Mint Chocolate Cake", "price": 355 },
  { "name": "Oreo Cake", "price": 375 },
  { "name": "Toffee Cake", "price": 345 },



  { "name": "Butter Croissant", "price": 60 },
  { "name": "Almond Croissant", "price": 75 },
  { "name": "Chocolate Croissant", "price": 70 },
  { "name": "Strawberry Danish", "price": 65 },
  { "name": "Blueberry Danish", "price": 70 },
  { "name": "Cinnamon Roll", "price": 60 },
  { "name": "Apple Turnover", "price": 65 },
  { "name": "Vanilla Éclair", "price": 70 },
  { "name": "Chocolate Éclair", "price": 75 },
  { "name": "Cream Puff", "price": 55 },
  { "name": "Fruit Tart", "price": 80 },
  { "name": "Lemon Tart", "price": 70 },
  { "name": "Custard Tart", "price": 65 },
  { "name": "Peach Tart", "price": 75 },
  { "name": "Choco Fudge Brownie", "price": 60 },
  { "name": "Walnut Brownie", "price": 65 },
  { "name": "Red Velvet Brownie", "price": 70 },
  { "name": "Chocolate Chip Muffin", "price": 55 },
  { "name": "Blueberry Muffin", "price": 60 },
  { "name": "Banana Nut Muffin", "price": 58 },
  { "name": "Vanilla Cupcake", "price": 50 },
  { "name": "Chocolate Cupcake", "price": 55 },
  { "name": "Strawberry Cupcake", "price": 60 },
  { "name": "Oreo Cupcake", "price": 65 },
  { "name": "Macarons Assorted Box", "price": 120 },
  { "name": "Choco Hazelnut Macaron", "price": 35 },
  { "name": "Pistachio Macaron", "price": 35 },
  { "name": "Raspberry Macaron", "price": 35 },
  { "name": "Vanilla Macaron", "price": 35 },
  { "name": "Shortbread Cookies", "price": 40 },
  { "name": "Chocolate Chip Cookies", "price": 45 },
  { "name": "Oatmeal Raisin Cookies", "price": 42 },
  { "name": "Peanut Butter Cookies", "price": 48 },
  { "name": "Sugar Cookies", "price": 38 },
  { "name": "Snickerdoodle Cookies", "price": 45 },
  { "name": "Double Chocolate Cookies", "price": 50 },
  { "name": "Butter Cookies", "price": 40 },
  { "name": "Coconut Cookies", "price": 42 },
  { "name": "Cashew Cookies", "price": 48 },
  { "name": "Almond Cookies", "price": 50 },
  { "name": "Walnut Cookies", "price": 52 },
  { "name": "Jam Thumbprint Cookies", "price": 46 },
  { "name": "Gingerbread Cookies", "price": 44 },
  { "name": "Mint Chocolate Cookies", "price": 48 },
  { "name": "White Chocolate Macadamia Cookies", "price": 50 },
  { "name": "Choco Orange Cookies", "price": 47 },
  { "name": "Coffee Bean Cookies", "price": 45 },
  { "name": "Sesame Cookies", "price": 42 },
  { "name": "Flaxseed Cookies", "price": 43 },
  { "name": "Chia Seed Cookies", "price": 44 },
  { "name": "Ragi Cookies", "price": 40 },
  { "name": "Millet Cookies", "price": 42 },
  { "name": "Multi-grain Cookies", "price": 45 },
  { "name": "Gluten-Free Cookies", "price": 52 },
  { "name": "Sugar-Free Cookies", "price": 50 },
  { "name": "Eggless Cookies", "price": 48 },
  { "name": "Vegan Cookies", "price": 50 },
  { "name": "Whole Wheat Cookies", "price": 44 },
  { "name": "Protein Cookies", "price": 55 },
  { "name": "Low Carb Cookies", "price": 56 },
  { "name": "Keto Cookies", "price": 58 },
  { "name": "Heart-Shaped Cookies", "price": 46 },
  { "name": "Star-Shaped Cookies", "price": 45 },
  { "name": "Emoji Cookies", "price": 50 },
  { "name": "Decorative Iced Cookies", "price": 60 },
  { "name": "Theme Cookies Box", "price": 100 },
  { "name": "Baklava", "price": 90 },
  { "name": "Mini Mille-Feuille", "price": 80 },
  { "name": "Cream Cheese Danish", "price": 70 },
  { "name": "Chocolate Torte", "price": 85 },
  { "name": "Apricot Pastry", "price": 75 },
  { "name": "Pineapple Pastry", "price": 78 },


  
  { "name": "Vegetable Puff", "price": 25 },
  { "name": "Paneer Puff", "price": 30 },
  { "name": "Egg Puff", "price": 28 },
  { "name": "Chicken Puff", "price": 35 },
  { "name": "Mutton Puff", "price": 40 },
  { "name": "Corn and Cheese Puff", "price": 32 },
  { "name": "Spinach Puff", "price": 30 },
  { "name": "Masala Puff", "price": 28 },
  { "name": "Pizza Puff", "price": 33 },
  { "name": "Garlic Puff", "price": 26 },
  { "name": "Samosa Puff", "price": 27 },
  { "name": "Chilli Cheese Puff", "price": 34 },
  { "name": "Capsicum Puff", "price": 30 },
  { "name": "Mixed Veg Puff", "price": 29 },
  { "name": "Beetroot Puff", "price": 28 },
  { "name": "Peanut Puff", "price": 26 },
  { "name": "Paneer Tikka Puff", "price": 33 },
  { "name": "Keema Puff", "price": 38 },
  { "name": "Mini Puff Box", "price": 110 },
  { "name": "Sweet Corn Puff", "price": 27 },
  { "name": "Mayo Puff", "price": 31 },
  { "name": "Onion Puff", "price": 25 },
  { "name": "Curry Puff", "price": 28 },
  { "name": "Egg Mayo Puff", "price": 30 },
  { "name": "Tandoori Puff", "price": 32 },
  { "name": "Cream Cheese Puff", "price": 35 },
  { "name": "Choco Puff", "price": 30 },
  { "name": "Nutella Puff", "price": 40 },
  { "name": "Jam Puff", "price": 28 },
  { "name": "Dry Fruit Puff", "price": 36 },
  { "name": "Butter Puff", "price": 25 },
  { "name": "Palak Puff", "price": 26 },
  { "name": "Tomato Puff", "price": 27 },
  { "name": "Cheesy Veg Puff", "price": 32 },
  { "name": "Spicy Chicken Puff", "price": 36 },
  { "name": "BBQ Puff", "price": 34 },
  { "name": "Cabbage Puff", "price": 25 },
  { "name": "Coconut Puff", "price": 30 },
  { "name": "Sesame Puff", "price": 28 },
  { "name": "Herb Puff", "price": 29 },
  { "name": "Hot Dog Roll", "price": 45 },
  { "name": "Veg Roll", "price": 38 },
  { "name": "Paneer Roll", "price": 42 },
  { "name": "Chicken Roll", "price": 50 },
  { "name": "Mayo Roll", "price": 40 },
  { "name": "Wrap Puff", "price": 36 },
  { "name": "Mini Veg Pizza", "price": 40 },
  { "name": "Mini Chicken Pizza", "price": 45 },
  { "name": "Bread Sandwich", "price": 30 },
  { "name": "Toasted Veg Sandwich", "price": 35 },
  { "name": "Grilled Cheese Sandwich", "price": 40 },
  { "name": "Paneer Sandwich", "price": 38 },
  { "name": "Chicken Sandwich", "price": 45 },
  { "name": "Egg Sandwich", "price": 32 },
  { "name": "Club Sandwich", "price": 50 },
  { "name": "Mini Burger Veg", "price": 35 },
  { "name": "Mini Burger Chicken", "price": 40 },
  { "name": "Aloo Tikki Burger", "price": 36 },
  { "name": "Spicy Paneer Burger", "price": 42 },
  { "name": "Cheese Burst Burger", "price": 45 },
  { "name": "Curried Veg Pie", "price": 33 },
  { "name": "Chicken Pot Pie", "price": 48 },
  { "name": "Egg Pie", "price": 38 },
  { "name": "Mushroom Puff", "price": 30 },
  { "name": "Sweet Puff", "price": 28 },
  { "name": "Stuffed Veg Roll", "price": 36 },
  { "name": "Stuffed Chicken Roll", "price": 46 },
  { "name": "Peri Peri Puff", "price": 34 },
  { "name": "Paneer Masala Puff", "price": 33 },
  { "name": "Multigrain Puff", "price": 30 },
  { "name": "Special Puff Box", "price": 120 },


  
  { "name": "Butter Bun", "price": 20 },
  { "name": "Sweet Coconut Bun", "price": 25 },
  { "name": "Jam Bun", "price": 22 },
  { "name": "Cream Roll Bun", "price": 28 },
  { "name": "Masala Bun", "price": 24 },
  { "name": "Fruit Bun", "price": 26 },
  { "name": "Cheese Bun", "price": 30 },
  { "name": "Paneer Bun", "price": 32 },
  { "name": "Chocolate Bun", "price": 28 },
  { "name": "Honey Glazed Bun", "price": 26 },
  { "name": "Oreo Bun", "price": 30 },
  { "name": "Cinnamon Swirl Bun", "price": 34 },
  { "name": "Garlic Butter Bun", "price": 25 },
  { "name": "Multigrain Bun", "price": 30 },
  { "name": "Mini Pizza Bun", "price": 32 },
  { "name": "Choco Lava Bun", "price": 35 },
  { "name": "Bournvita Bun", "price": 28 },
  { "name": "Cadbury Dairy Milk (Mini)", "price": 20 },
  { "name": "KitKat Bar", "price": 30 },
  { "name": "Perk", "price": 10 },
  { "name": "Munch", "price": 10 },
  { "name": "5 Star Bar", "price": 25 },
  { "name": "Snickers", "price": 35 },
  { "name": "Ferrero Rocher (3 pcs)", "price": 125 },
  { "name": "Amul Dark Chocolate", "price": 90 },
  { "name": "Toblerone (Mini)", "price": 110 },
  { "name": "Milky Bar", "price": 20 },
  { "name": "Bournville Rich Cocoa", "price": 100 },
  { "name": "Nestlé Alpino", "price": 120 },
  { "name": "Cadbury Silk Oreo", "price": 85 },
  { "name": "Hershey’s Cookies 'n' Creme", "price": 95 },
  { "name": "Galaxy Smooth Milk", "price": 100 },
  { "name": "Lindt Excellence 70%", "price": 160 },
  { "name": "Birthday Rainbow Cake", "price": 450 },
  { "name": "Chocolate Ganache Cake", "price": 500 },
  { "name": "Strawberry Fresh Cream Cake", "price": 480 },
  { "name": "Pineapple Decor Cake", "price": 420 },
  { "name": "Mango Delight Cake", "price": 460 },
  { "name": "Black Forest Birthday Cake", "price": 470 },
  { "name": "Vanilla Rose Cake", "price": 440 },
  { "name": "Red Velvet Birthday Cake", "price": 550 },
  { "name": "Tiramisu Cake", "price": 600 },
  { "name": "Heart Shape Chocolate Cake", "price": 520 },
  { "name": "Doll Theme Cake", "price": 700 },
  { "name": "Photo Print Birthday Cake", "price": 650 },
  { "name": "Unicorn Theme Cake", "price": 750 },
  { "name": "Cricket Bat Cake", "price": 680 },
  { "name": "Minion Cake", "price": 720 },
  { "name": "Birthday Cap (Pack of 6)", "price": 60 },
  { "name": "Happy Birthday Banner", "price": 100 },
  { "name": "Colorful Balloons (Pack of 20)", "price": 80 },
  { "name": "Cake Topper - Glitter", "price": 45 },
  { "name": "Paper Masks (Animal Theme)", "price": 65 },
  { "name": "Birthday Badges", "price": 40 },
  { "name": "Confetti Poppers", "price": 90 },
  { "name": "Party Streamers Roll", "price": 55 },
  { "name": "Birthday Return Gift Bag", "price": 30 },
  { "name": "Balloon Pump Manual", "price": 85 },
  { "name": "Party Blowouts (Pack of 10)", "price": 50 },
  { "name": "Foil Curtains (Backdrop)", "price": 150 },
  { "name": "Theme Cake Knife & Server Set", "price": 70 },
  { "name": "LED Birthday Banner", "price": 170 },
  { "name": "Cake Candle - Number", "price": 15 },
  { "name": "Spiral Cake Candles (Pack of 12)", "price": 25 },
  { "name": "Musical Candle", "price": 40 },
  { "name": "Fountain Sparkle Candle", "price": 60 },
  { "name": "Color Changing LED Candle", "price": 55 },
  { "name": "Scented Birthday Candle Jar", "price": 65 },
  { "name": "Floral Printed Candles (Pack)", "price": 50 },
  { "name": "Gold Glitter Birthday Candle", "price": 45 },
  { "name": "Birthday Candle with Holder", "price": 20 },
  { "name": "Vanilla Bean Ice Cream", "price": 60 },
  { "name": "Mango Swirl Ice Cream", "price": 70 },
  { "name": "Chocolate Fudge Ice Cream", "price": 75 },
  { "name": "Strawberry Cream Ice Cream", "price": 70 },
  { "name": "Butterscotch Delight Ice Cream", "price": 72 },
  { "name": "Black Currant Ice Cream", "price": 70 },
  { "name": "Tender Coconut Ice Cream", "price": 75 },
  { "name": "Pista Kulfi Ice Cream", "price": 78 },
  { "name": "Rose Milk Ice Cream", "price": 68 },
  { "name": "Honey Almond Ice Cream", "price": 80 },
  { "name": "Coffee Crème Ice Cream", "price": 72 },
  { "name": "Jamun Sorbet", "price": 65 },
  { "name": "Guava Chilli Sorbet", "price": 62 },
  { "name": "Nolen Gur Ice Cream", "price": 75 },
  { "name": "Chocolate Chip Cookie Ice Cream", "price": 85 },
  { "name": "Salted Caramel Ice Cream", "price": 80 },
  { "name": "Fig & Honey Ice Cream", "price": 78 },
  { "name": "Anjeer Kulfi", "price": 82 },
  { "name": "Lychee Ice Cream", "price": 72 },
  { "name": "Papaya Twist Ice Cream", "price": 65 },
  { "name": "Avocado Ice Cream", "price": 85 },
  { "name": "Custard Apple Ice Cream", "price": 75 },
  { "name": "Masala Chai Ice Cream", "price": 70 },
  { "name": "Paan Ice Cream", "price": 72 },
  { "name": "Gulkand Ice Cream", "price": 75 },
  { "name": "Choco Hazelnut Gelato", "price": 85 },
  { "name": "Orange Zest Sorbet", "price": 60 },
  { "name": "Coconut Jaggery Ice Cream", "price": 78 },
  { "name": "Saffron Pistachio Ice Cream", "price": 85 },
  { "name": "Mint Chocolate Chip Ice Cream", "price": 75 },
  { "name": "Banana Walnut Ice Cream", "price": 70 },
  { "name": "Dates & Nut Ice Cream", "price": 78 },
  { "name": "Oreo Blast Ice Cream", "price": 80 },
  { "name": "Tutti Frutti Ice Cream", "price": 68 },
  { "name": "Chocolate Brownie Ice Cream", "price": 85 },
  { "name": "Kulfi Falooda Sundae", "price": 90 },
  { "name": "Cookie Crumble Cone", "price": 60 },
  { "name": "Waffle Cone Ice Cream", "price": 65 },
  { "name": "Fruit Punch Ice Cream Cup", "price": 60 },
  { "name": "Rose Lassi Ice Cream", "price": 70 },
  { "name": "Malai Kulfi Stick", "price": 60 },
  { "name": "Choco Lava Pastry", "price": 55 },
  { "name": "Cream Bun", "price": 30 },
  { "name": "Honey Glazed Donut", "price": 40 },
  { "name": "Jam Swiss Roll", "price": 45 },
  { "name": "Puff Pastry Pocket", "price": 35 },
  { "name": "Vegetable Spring Roll", "price": 45 },
  { "name": "Mini Samosa", "price": 30 },
  { "name": "Paneer Puff", "price": 40 },
  { "name": "Cheese Corn Roll", "price": 38 },
  { "name": "Spicy Masala Vada", "price": 25 },
  { "name": "Onion Rings", "price": 30 },
  { "name": "Cheese Balls", "price": 40 },
  { "name": "Potato Nuggets", "price": 35 },
  { "name": "Veg Cutlet", "price": 30 },
  { "name": "Sweet Corn Patty", "price": 32 },
  { "name": "French Fries Classic", "price": 40 },
  { "name": "Masala Fries", "price": 45 },
  { "name": "Mini Pizza Slice", "price": 55 },
  { "name": "Garlic Bread Stick", "price": 35 },
  { "name": "Cheesy Paneer Pizza", "price": 60 },
  { "name": "Spicy Veg Wrap", "price": 50 },
  { "name": "Mini Burger", "price": 50 },
  { "name": "Chilli Cheese Toast", "price": 40 },
  { "name": "Mushroom Puff", "price": 42 },
  { "name": "Spinach Corn Sandwich", "price": 55 },
  { "name": "Mixed Veg Quiche", "price": 58 },
  { "name": "Eggless Chocolate Muffin", "price": 40 },
  { "name": "Vanilla Cupcake", "price": 38 },
  { "name": "Blueberry Cheesecake Slice", "price": 65 },
  { "name": "Caramel Apple Tart", "price": 50 },
  { "name": "Red Velvet Jar Cake", "price": 70 },
  { "name": "South Indian Mixture", "price": 60 },
  { "name": "Madras Mixture", "price": 65 },
  { "name": "Spicy Kara Boondi", "price": 55 },
  { "name": "Cornflakes Mixture", "price": 70 },
  { "name": "Ribbon Pakoda", "price": 60 },
  { "name": "Omapodi", "price": 50 },
  { "name": "Thenkuzhal", "price": 55 },
  { "name": "Mullu Murukku", "price": 60 },
  { "name": "Butter Murukku", "price": 65 },
  { "name": "Achu Murukku", "price": 68 },
  { "name": "Sev Mixture", "price": 58 },
  { "name": "Rice Flour Thattai", "price": 50 },
  { "name": "Masala Peanuts", "price": 45 },
  { "name": "Roasted Gram Mix", "price": 50 },
  { "name": "Sweet Corn Murmura", "price": 48 },
  { "name": "Fried Chana Dal", "price": 52 },
  { "name": "Fried Moong Dal", "price": 52 },
  { "name": "Nenthram Chips", "price": 70 },
  { "name": "Tapioca Chips", "price": 65 },
  { "name": "Jackfruit Chips", "price": 75 },
  { "name": "Banana Chips Masala", "price": 68 },
  { "name": "Sago Chips", "price": 60 },
  { "name": "Potato Chips Masala", "price": 58 },
  { "name": "Raw Mango Thokku", "price": 55 },
  { "name": "Coconut Thokku", "price": 52 },
  { "name": "Lemon Pickle", "price": 50 },
  { "name": "Ginger Candy", "price": 40 },
  { "name": "Panakam Candy", "price": 42 },
  { "name": "Palm Sugar Balls", "price": 45 },
  { "name": "Karupatti Mittai", "price": 50 },
  { "name": "Ellu Mittai", "price": 48 },
  { "name": "Kadalai Mittai", "price": 52 },
  { "name": "Thinai Laddu", "price": 55 },
  { "name": "Kambu Laddu", "price": 55 },
  { "name": "Saamai Laddu", "price": 50 },
  { "name": "Foxtail Millet Laddu", "price": 53 },
  { "name": "Black Sesame Laddu", "price": 52 },
  { "name": "Ragi Laddu", "price": 50 },
  { "name": "Dry Fruit Energy Ball", "price": 60 },
  { "name": "Peanut Chikki", "price": 42 },
  { "name": "Til Chikki", "price": 45 },
  { "name": "Cashew Chikki", "price": 50 },
  { "name": "Mixed Nut Chikki", "price": 55 },
  { "name": "Rose Coconut Burfi", "price": 60 },
  { "name": "Milk Mysore Pak", "price": 52 },
  { "name": "Chocolate Barfi", "price": 50 },
  { "name": "Peanut Barfi", "price": 48 },
  { "name": "Chana Dal Halwa", "price": 55 },
  { "name": "Wheat Halwa", "price": 60 },
  { "name": "Karuppatti Halwa", "price": 62 },
  { "name": "Tapioca Halwa", "price": 58 },
  { "name": "Kasi Halwa", "price": 65 },
  { "name": "Badusha", "price": 50 },
  { "name": "Khoa Balls", "price": 55 },
  { "name": "Kesari Cubes", "price": 48 },
  { "name": "Paalkova", "price": 60 },
  { "name": "Milk Cake", "price": 58 },
  { "name": "Special Kesar Peda", "price": 55 },
  { "name": "Rose Gulkand Laddu", "price": 52 },
  { "name": "Chocolate Dry Fruit Balls", "price": 62 },
  { "name": "Dry Fig Mithai", "price": 60 },
  { "name": "Anjeer Coconut Roll", "price": 58 },
  { "name": "Sweet Potato Burfi", "price": 55 },
  { "name": "Paneer Laddu", "price": 56 },
  { "name": "Custard Mithai", "price": 60 },
  { "name": "Thirattipal", "price": 62 },
  { "name": "Elaichi Milk Balls", "price": 55 },
  { "name": "Honey Almond Cubes", "price": 60 },
  { "name": "Dry Rose Petal Laddu", "price": 52 },
  { "name": "Dates and Nuts Roll", "price": 60 },
  { "name": "Besan Coconut Balls", "price": 50 },
  { "name": "Vermicelli Mithai", "price": 48 },


  { "name": "Hot Garlic Breadsticks", "price": 45 },
  { "name": "Toasted Cheese Sandwich", "price": 55 },
  { "name": "Veg Grilled Panini", "price": 60 },
  { "name": "Spicy Chicken Panini", "price": 70 },
  { "name": "Mushroom Cheese Melt", "price": 65 },
  { "name": "Baked Masala Bun", "price": 35 },
  { "name": "Stuffed Aloo Bun", "price": 38 },
  { "name": "Hot Veg Pizza Slice", "price": 60 },
  { "name": "Hot Chicken Pizza Slice", "price": 70 },
  { "name": "Corn & Spinach Sandwich", "price": 52 },
  { "name": "Paneer Masala Toast", "price": 56 },
  { "name": "Spiced Egg Sandwich", "price": 58 },
  { "name": "Baked Macaroni Cups", "price": 62 },
  { "name": "Hot Dog Bun with Mayo", "price": 68 },
  { "name": "Grilled Tomato Cheese Toast", "price": 54 },
  { "name": "Tandoori Paneer Wrap", "price": 65 },
  { "name": "Chicken Tikka Wrap", "price": 70 },
  { "name": "Hot Puff Combo Box", "price": 120 },
  { "name": "Baked Veg Cutlet", "price": 45 },
  { "name": "Spicy Samosa Hot Pocket", "price": 48 },
  { "name": "Chilli Cheese Toast", "price": 55 },
  { "name": "BBQ Chicken Slider", "price": 72 },
  { "name": "Veg Mini Slider", "price": 60 },
  { "name": "Curried Potato Roll", "price": 50 },
  { "name": "Egg Masala Bun", "price": 52 },
  { "name": "Mutton Keema Roll", "price": 75 },
  { "name": "Veggie Quiche", "price": 65 },
  { "name": "Mini Chicken Quiche", "price": 70 },
  { "name": "Baked Beans Toast", "price": 52 },
  { "name": "Toasted Sausage Roll", "price": 68 },
  { "name": "Stuffed Cheese Bombs", "price": 60 },
  { "name": "Crispy Veg Pizza Puff", "price": 50 },
  { "name": "Hot Corn Cutlet", "price": 45 },
  { "name": "Paneer Kathi Roll", "price": 62 },
  { "name": "Spicy Veg Frankie", "price": 58 },
  { "name": "Grilled Tofu Sandwich", "price": 60 },
  { "name": "Mexican Nacho Bake", "price": 70 },
  { "name": "Spicy Mayo Paneer Bun", "price": 55 },
  { "name": "Cheese Burst Garlic Toast", "price": 60 },
  { "name": "Masala Bread Pakora", "price": 48 },
  { "name": "Hot Paneer Samosa", "price": 52 },
  { "name": "Chocolate Gulab Jamun", "price": 50 },
  { "name": "Classic Rasgulla", "price": 45 },
  { "name": "Milk Barfi", "price": 40 },
  { "name": "Kaju Katli", "price": 65 },
  { "name": "Badam Halwa", "price": 60 },
  { "name": "Besan Ladoo", "price": 48 },
  { "name": "Moong Dal Halwa", "price": 55 },
  { "name": "Hot Jalebi Plate", "price": 50 },
  { "name": "Boondi Laddu", "price": 45 },
  { "name": "Peda", "price": 42 },
  { "name": "Sandesh", "price": 46 },
  { "name": "Chena Murki", "price": 44 },
  { "name": "Gajar Ka Halwa", "price": 58 },
  { "name": "Malpua with Rabri", "price": 62 },
  { "name": "Imarti", "price": 40 },
  { "name": "Mysore Pak", "price": 48 },
  { "name": "Kesar Rasmalai", "price": 70 },
  { "name": "Anjeer Barfi", "price": 52 },
  { "name": "Chocolate Soan Papdi", "price": 50 },
  { "name": "Rose Milk Cake", "price": 60 },
  { "name": "Hot Kalakand", "price": 55 },
  { "name": "Coconut Ladoo", "price": 45 },
  { "name": "Til Barfi", "price": 50 },
  { "name": "Dry Fruit Laddu", "price": 56 },
  { "name": "Sweet Samosa", "price": 42 },
  { "name": "Orange Mithai Cubes", "price": 48 },
  { "name": "Pistachio Rolls", "price": 52 },
  { "name": "Saffron Milk Burfi", "price": 58 },
  { "name": "Milk Chocolate Bar", "price": 55 },
  { "name": "Dark Chocolate Bar", "price": 60 },
  { "name": "White Chocolate Bar", "price": 58 },
  { "name": "Hazelnut Chocolate", "price": 65 },
  { "name": "Almond Chocolate", "price": 63 },
  { "name": "Caramel Chocolate", "price": 60 },
  { "name": "Mint Chocolate", "price": 62 },
  { "name": "Fruit & Nut Chocolate", "price": 68 },
  { "name": "Strawberry Filled Chocolate", "price": 64 },
  { "name": "Orange Zest Chocolate", "price": 63 },
  { "name": "Truffle Box", "price": 250 },
  { "name": "Assorted Chocolate Box", "price": 280 },
  { "name": "Sugar-Free Chocolate", "price": 70 },
  { "name": "Vegan Chocolate", "price": 75 },
  { "name": "Coffee Chocolate", "price": 62 },
  { "name": "Roasted Nut Chocolate", "price": 66 },
  { "name": "Coconut Chocolate", "price": 60 },
  { "name": "Kesar Chocolate", "price": 70 },
  { "name": "Marble Chocolate", "price": 65 },
  { "name": "Layered Chocolate Square", "price": 72 },
  { "name": "Gold Foil Chocolate", "price": 80 },
  { "name": "Emoji Chocolate", "price": 45 },
  { "name": "Heart Shaped Chocolate", "price": 50 },
  { "name": "Birthday Special Chocolate", "price": 85 },
  { "name": "Premium Dark Chocolate", "price": 75 },
  { "name": "Crunchy Chocolate", "price": 63 },
  { "name": "Nougat Chocolate", "price": 68 },
  { "name": "Peanut Butter Chocolate", "price": 65 },
  { "name": "Chocolate Coin", "price": 40 },
  { "name": "Choco Bites Box", "price": 110 },
  { "name": "Biscuit Chocolate Combo", "price": 95 },
  { "name": "Butter Biscuit", "price": 40 },
  { "name": "Cashew Biscuit", "price": 45 },
  { "name": "Almond Biscuit", "price": 48 },
  { "name": "Chocolate Chip Biscuit", "price": 50 },
  { "name": "Oat Biscuit", "price": 42 },
  { "name": "Ragi Biscuit", "price": 38 },
  { "name": "Multigrain Biscuit", "price": 40 },
  { "name": "Digestive Biscuit", "price": 44 },
  { "name": "Coconut Biscuit", "price": 42 },
  { "name": "Salted Biscuit", "price": 35 },
  { "name": "Sweet Biscuit", "price": 38 },
  { "name": "Jeera Biscuit", "price": 36 },
  { "name": "Jam Centre Biscuit", "price": 45 },
  { "name": "Cream Filled Biscuit", "price": 50 },
  { "name": "Choco Cream Biscuit", "price": 52 },
  { "name": "Vanilla Cream Biscuit", "price": 50 },
  { "name": "Strawberry Cream Biscuit", "price": 48 },
  { "name": "Coffee Biscuit", "price": 44 },
  { "name": "Spicy Masala Biscuit", "price": 40 },
  { "name": "Thick Crunch Biscuit", "price": 46 },
  { "name": "Thin Crisp Biscuit", "price": 42 },
  { "name": "Gluten-Free Biscuit", "price": 55 },
  { "name": "Sugar-Free Biscuit", "price": 52 },
  { "name": "Eggless Biscuit", "price": 48 },
  { "name": "Vegan Biscuit", "price": 50 },
  { "name": "Millet Biscuit", "price": 42 },
  { "name": "Peanut Biscuit", "price": 45 },
  { "name": "Chia Seed Biscuit", "price": 48 },
  { "name": "Flaxseed Biscuit", "price": 47 },
  { "name": "Sesame Biscuit", "price": 44 },
  { "name": "Heart Shaped Biscuit", "price": 46 },
  { "name": "Star Shaped Biscuit", "price": 45 },
  { "name": "Emoji Biscuit", "price": 50 },
  { "name": "Festive Biscuit Box", "price": 100 },
  { "name": "Mini Biscuit Pack", "price": 60 },
  { "name": "Chocolate Dipped Biscuit", "price": 55 },
  { "name": "Biscuit Assorted Box", "price": 120 },
  { "name": "Gift Pack Chocolates", "price": 300 },


                  ],
                  "Others": [

    { "name": "Other Service", "price": 5000 },

                  ],

   
  });

  const [searchText, setSearchText] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  


  const [shopName, setShopName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedItem, setSelectedItem] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [cart, setCart] = useState([]);
  const [gstRate, setGstRate] = useState(0);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [showModal, setShowModal] = useState(false);

  const [shareMethod, setShareMethod] = useState('');
  const [pdfFormat, setPdfFormat] = useState('default');


  const handleSearchChange = (event) => {
    const text = event.target.value;
    setSearchText(text);
  
    const allItems = Object.entries(categories).flatMap(([category, items]) =>
      items.map(item => ({ ...item, category }))
    );
  
    const filtered = allItems.filter(item =>
      item.name.toLowerCase().includes(text.toLowerCase())
    );
  
    setSuggestions(filtered);
  };

  const handleSelectSuggestion = (item) => {
    const newItem = {
      name: item.name,
      price: item.price,
      quantity: 1,
      subtotal: item.price * 1,
    };
    setCart([...cart, newItem]);
    setSearchText('');
    setSuggestions([]);
  };

  const handleNewBill = () => {
    setShopName('');
    setGstNumber('');
    setPhoneNumber('');
    setSelectedCategory('');
    setSelectedItem('');
    setQuantity(1);
    setCart([]);
    setGstRate(0);
    setSearchText('');
    setSuggestions([]);
    setPdfFormat('default');
  };
  

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
    setSelectedItem('');
    setQuantity(1);
  };

  const handleItemChange = (event) => {
    setSelectedItem(event.target.value);
    setQuantity(1);
  };

  const handleQuantityChange = (event) => {
    setQuantity(event.target.value);
  };

  const handleAddItem = () => {
    const categoryItems = categories[selectedCategory];
    const item = categoryItems.find(i => i.name === selectedItem);
    if (item) {
      const newItem = {
        name: item.name,
        price: item.price,
        quantity: quantity,
        subtotal: item.price * quantity
      };
      setCart([...cart, newItem]);
      setSelectedItem('');
      setQuantity(1);
    }
  };

  const handleGstRateChange = (event) => {
    setGstRate(event.target.value);
  };

  const handlePriceChange = (index, event) => {
    const newCart = [...cart];
    newCart[index].price = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleQuantityEdit = (index, event) => {
    const newCart = [...cart];
    newCart[index].quantity = event.target.value;
    newCart[index].subtotal = newCart[index].price * newCart[index].quantity;
    setCart(newCart);
  };

  const handleRemoveItem = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1); // Remove one item at the given index
    setCart(newCart);
  };
  
  const calculateTotal = () => {
    const subtotal = cart.reduce((acc, item) => acc + item.subtotal, 0);
    const gst = subtotal * (gstRate / 100);
    const total = subtotal + gst;
    return { subtotal, gst, total };
  };

  const generatePdfInvoice = () => {
    const total = calculateTotal();
    const currentDate = new Date().toLocaleDateString();
    const doc = new jsPDF();

    switch (pdfFormat) {
        case 'default':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'table':
            doc.autoTable({
                head: [[' Name', 'GST No', 'Phone Number', 'Date']],
                body: [[shopName, gstNumber, phoneNumber, currentDate]],
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'blueBlack':
            doc.setTextColor(0, 0, 255);
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.setTextColor(0, 0, 0);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

        case 'professionalGrid':
            doc.setFontSize(18);
            doc.text(shopName, 10, 10);
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 10, 20);
            doc.text(`Date: ${currentDate}`, 10, 30);
            doc.autoTable({
                startY: 40,
                head: [['Item No', 'Item', 'Price', 'Quantity', 'Subtotal']],
                body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                theme: 'grid',
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                theme: 'grid',
            });
            break;

        case 'compactSummary':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
            });
            break;

            
                case 'classicTable':
                    doc.setFontSize(20);
                    doc.text(shopName, 105, 15, null, null, 'center');
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
                    doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
                    doc.setFontSize(16);
                    doc.text('Invoice', 105, 30, null, null, 'center');
                    doc.autoTable({
                        startY: 40,
                        head: [['Item No', 'Item', 'Price', 'Quantity(Kg/Ltr/each)', 'Subtotal']],
                        body: cart.map((item, index) => [index + 1, item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                    });
                    break;
        
                case 'boxedLayout':
                    doc.setFontSize(20);
                    doc.text(shopName, 10, 10);
                    doc.setFontSize(12);
                    doc.text(`GST No: ${gstNumber}`, 10, 20);
                    doc.text(`Date: ${currentDate}`, 10, 30);
                    doc.autoTable({
                        startY: 40,
                        head: [['Item', 'Price', 'Quantity', 'Subtotal']],
                        body: cart.map((item) => [item.name, item.price, item.quantity, item.subtotal.toFixed(2)]),
                        styles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineColor: [0, 0, 0], lineWidth: 0.5 },
                    });
                    doc.autoTable({
                        startY: doc.lastAutoTable.finalY + 10,
                        body: [
                            ['Subtotal', total.subtotal.toFixed(2)],
                            ['GST', total.gst.toFixed(2)],
                            ['Total', total.total.toFixed(2)],
                        ],
                        styles: { fillColor: [0, 180, 0], textColor: [0, 0, 0] },
                    });
            break;   
            
            

        case 'modernMinimalist':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity(Kg/ltr/each', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.1 },
            });
            break;

        case 'elegantLines':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Item', 'Quantity', 'Subtotal']],
                body: cart.map((item) => [item.name, item.quantity, item.subtotal.toFixed(2)]),
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                body: [
                    ['Subtotal', total.subtotal.toFixed(2)],
                    ['GST', total.gst.toFixed(2)],
                    ['Total', total.total.toFixed(2)],
                ],
                styles: { fontStyle: 'italic', fontSize: 12, lineColor: [150, 150, 150], lineWidth: 0.1 },
            });
            break;

        case 'detailedSections':
            doc.setFontSize(20);
            doc.text(shopName, 105, 15, null, null, 'center');
            doc.setFontSize(12);
            doc.text(`GST No: ${gstNumber}`, 200, 15, null, null, 'right');
            doc.text(`Date: ${currentDate}`, 200, 25, null, null, 'right');
            doc.setFontSize(16);
            doc.text('Invoice', 105, 30, null, null, 'center');
            doc.autoTable({
                startY: 40,
                head: [['Section', 'Details']],
                body: [
                    ['Shop Details', `${shopName}, GST No: ${gstNumber}, Date: ${currentDate}`],
                    ['Items', cart.map((item) => `Name: ${item.name}, Quantity: ${item.quantity}, Subtotal: ${item.subtotal.toFixed(2)}`).join('; ')],
                    ['Totals', `Subtotal: ${total.subtotal.toFixed(2)}, GST: ${total.gst.toFixed(2)}, Total: ${total.total.toFixed(2)}`],
                ],
                styles: { fontSize: 10, lineColor: [0, 0, 0], lineWidth: 0.5 },
            });
            break;

        

        default:
            break;
    }

    // Save the PDF to Blob
    const pdfBlob = doc.output('blob');

    // Share to WhatsApp
    const shareToWhatsApp = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const whatsappUrl = `https://wa.me/${phoneNumber}?text=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(whatsappUrl, '_blank');
    };

    // Share to Email
    const shareToEmail = () => {
        const fileURL = URL.createObjectURL(pdfBlob);
        const mailtoUrl = `mailto:?subject=Your Invoice&body=Your invoice is ready. Download it here: ${fileURL}`;
        window.open(mailtoUrl, '_blank');
    };

    // Share the PDF as needed
    if (shareMethod === 'whatsapp') {
        shareToWhatsApp();
    } else if (shareMethod === 'mail') {
        shareToEmail();
    }

    // Save the PDF
    //doc.save('invoice.pdf');
    doc.save(`${shopName +'-invoice' || 'invoice'}.pdf`);

};


  const handleShare = (method) => {
    setShareMethod(method); // Set the sharing method
    const shareText = `Shop Name: ${shopName}\nGST No: ${gstNumber}\nPhone Number: ${phoneNumber}`;

    if (method === 'whatsapp') {
      window.open(`https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(shareText)}`);
    } else if (method === 'mail') {
      window.open(`mailto:?subject=MarketApp%20Details&body=${encodeURIComponent(shareText)}`);
    }

    setShowModal(false); // Close modal after sharing
  };

  const handleGenerateAndShare = () => {
    generatePdfInvoice();
    setShowModal(true); // Show modal after generating PDF
  };

  const handleFormatChange = (e) => {
    setPdfFormat(e.target.value); // Set the PDF format
};

const formatOptions = [
    { value: 'default', label: 'Default' },
    { value: 'table', label: 'Table Format' },
    { value: 'blueBlack', label: 'Blue and Black' },
    { value: 'professionalGrid', label: 'Professional Grid' },
    { value: 'compactSummary', label: 'Compact Summary' },
    { value: 'classicTable', label: 'Classic Table' },
    { value: 'boxedLayout', label: 'Boxed Layout' },
    { value: 'modernMinimalist', label: 'Modern Minimalist' },
    { value: 'elegantLines', label: 'Elegant Lines' },
    { value: 'detailedSections', label: 'Detailed Sections' },
    
];


return (
    <div className="MarketApp">
       <img src="./Images/jalm.png" alt="Just A Little Market" width="100" height="100" />
      <h1><u>Services</u></h1>

<div style={{ marginTop: '20px', textAlign: 'left', paddingLeft: '10px' }}>
  <button
    onClick={handleNewBill}
    style={{
      backgroundColor: '#007bff',
      color: '#fff',
      padding: '12px 20px',
      fontSize: '18px',
      fontWeight: '600',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '8px',
      boxShadow: '0 4px 8px rgba(0, 123, 255, 0.3)',
      transition: 'background-color 0.3s ease, transform 0.2s ease'
    }}
    onMouseOver={(e) => {
      e.target.style.backgroundColor = '#0056b3';
      e.target.style.transform = 'scale(1.05)';
    }}
    onMouseOut={(e) => {
      e.target.style.backgroundColor = '#007bff';
      e.target.style.transform = 'scale(1)';
    }}
  >
    🧾 New Bill
  </button>
</div>
<br/>

  
      {/* Shop Info */}
  
    <div className="container">
  {/* Responsive Input Section */}
  <div className="input-section">
    <div className="form-group">
      <label>Services/Shop Name:</label>
      <input type="text" value={shopName} onChange={(e) => setShopName(e.target.value)} />
    </div>

    <div className="form-group">
      <label>GST No:</label>
      <input type="text" value={gstNumber} onChange={(e) => setGstNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Phone Number:</label>
      <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} />
    </div>

    <div className="form-group">
      <label>Search Items:</label>
      <input
        type="text"
        value={searchText}
        onChange={handleSearchChange}
        placeholder="Type to search..."
      />
      {suggestions.length > 0 && (
        <ul className="suggestion-list">
          {suggestions.map((item, idx) => (
            <li key={idx} onClick={() => handleSelectSuggestion(item)}>
              {item.name} — ₹{item.price} <span className="category">({item.category})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  </div>

  {/* Category Selection */}
  <div className="form-group">
    <label>Select Category:</label>
    <select onChange={handleCategoryChange} value={selectedCategory}>
      <option value="" disabled>Select a category</option>
      {Object.keys(categories).map((cat, i) => (
        <option key={i} value={cat}>{cat}</option>
      ))}
    </select>
  </div>

  {selectedCategory && (
    <>
      <div className="form-group">
        <label>Select Item:</label>
        <select onChange={handleItemChange} value={selectedItem}>
          <option value="" disabled>Select an item</option>
          {categories[selectedCategory].map((item, i) => (
            <option key={i} value={item.name}>{item.name}</option>
          ))}
        </select>
      </div>

      {selectedItem && (
        <>
          <div className="form-group">
            <label>Quantity:</label>
            <input type="number" value={quantity} onChange={handleQuantityChange} min="1" />
          </div>
          <div className="form-group">
            <button onClick={handleAddItem}>Add Item</button>
          </div>
        </>
      )}
    </>
  )}

  {/* Cart Table */}
  <div className="cart-section">
    <h2>Cart</h2>
    {cart.length === 0 ? (
      <p>No items added.</p>
    ) : (
      <div className="responsive-table">
        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
              <th>Remove</th>
            </tr>
          </thead>
          <tbody>
            {cart.map((item, index) => (
              <tr key={index}>
                <td>{item.name}</td>
                <td>
                  <input
                    type="number"
                    value={item.price}
                    onChange={(e) => handlePriceChange(index, e)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={item.quantity}
                    onChange={(e) => handleQuantityEdit(index, e)}
                    min="1"
                  />
                </td>
                <td>{item.subtotal.toFixed(2)}</td>
                <td><button onClick={() => handleRemoveItem(index)}>Remove</button></td>
              </tr>
            ))}
            <tr>
              <td colSpan="3">Subtotal</td>
              <td>{calculateTotal().subtotal.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">
                GST Rate:
                <select onChange={handleGstRateChange} value={gstRate}>
                  <option value="0">0%</option>
                  <option value="5">5%</option>
                  <option value="6">6%</option>
                  <option value="9">9%</option>
                  <option value="18">18%</option>
                </select>
              </td>
              <td>{calculateTotal().gst.toFixed(2)}</td>
            </tr>
            <tr>
              <td colSpan="3">Total</td>
              <td>{calculateTotal().total.toFixed(2)}</td>
            </tr>
          </tbody>
        </table>
      </div>
    )}
  </div>

  {/* PDF Section */}
{cart.length > 0 && (
 
  <div className="pdf-section" style={{
    marginTop: '30px',
    padding: '20px',
    backgroundColor: '#f1f3f5',
    borderRadius: '10px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
    maxWidth: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px'
  }}>
    <label style={{
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333'
    }}>
      🧾 Select Invoice Format:
    </label>

    <select
      onChange={handleFormatChange}
      value={pdfFormat}
      style={{
        padding: '10px',
        fontSize: '16px',
        borderRadius: '6px',
        border: '1px solid #ccc',
        width: '100%',
        boxSizing: 'border-box'
      }}
    >
      {formatOptions.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>

    <button
      onClick={handleGenerateAndShare}
      style={{
        backgroundColor: '#007bff',
        color: '#fff',
        padding: '14px',
        fontSize: '17px',
        fontWeight: '600',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        boxShadow: '0 4px 8px rgba(0,123,255,0.3)',
        transition: 'transform 0.2s ease, background-color 0.3s ease'
      }}
      onMouseOver={(e) => {
        e.target.style.backgroundColor = '#0056b3';
        e.target.style.transform = 'scale(1.05)';
      }}
      onMouseOut={(e) => {
        e.target.style.backgroundColor = '#007bff';
        e.target.style.transform = 'scale(1)';
      }}
    >
      📄 Generate PDF Invoice
    </button>
  </div>
)}


<br /><br />

 

</div>

 </div>   
  ); // ✅ this closes the return statement
  
  
}

export default Services;
  


  

